<div id="mainBlock" class="">
    <header data-html2canvas-ignore id="header">
        <div id="slide-out" class="side-nav fixed wide overflow-auto d-flex flex-column justify-content-between align-content-between custom-scrollbar">
            <div class="d-flex flex-column">
                <div class="">
                    <a href="#">
                        <img src="/images/logo_white.png">
                    </a>
                </div>

                <ul class="collapsible collapsible-accordion">
                    <ng-container *ngFor="let navMenuElement of navMenu">
                        <li *ngIf="!navMenuElement.hide"
                            [id]="navMenuElement.id"
                            [routerLinkActive]="navMenuElement.link.routerLinkActive"
                            [routerLinkActiveOptions]="navMenuElement.link.routerLinkActiveOptions"
                        >
                            <a [id]="navMenuElement.link.id"
                                (click)="navMenuElement.link.onClick()"
                                [routerLink]="navMenuElement.link.routerLink"
                                [routerLinkActive]="navMenuElement.link.routerLinkActive"
                                [ngClass]="navMenuElement.link.ngClass"
                                [ngStyle]="navMenuElement.link.ngStyle"
                            >
                                <i [ngClass]="navMenuElement.link.icon"></i>
                                <span class="cursor--pointer" [innerHTML]="navMenuElement.link.label"></span>
                                <i *ngIf="navMenuElement.children.length > 0" class="fas fa-angle-down rotate-icon"></i>
                            </a>
                            <div *ngIf="navMenuElement.children.length > 0" class="collapsible-body">
                                <ul>
                                    <li *ngFor="let navMenuSubElement of navMenuElement.children" [id]="navMenuSubElement.id">
                                        <a [id]="navMenuSubElement.link.id"
                                            (click)="navMenuSubElement.link.onClick()"
                                            [routerLink]="navMenuSubElement.link.routerLink"
                                            [routerLinkActive]="navMenuSubElement.link.routerLinkActive"
                                            [ngClass]="navMenuSubElement.link.ngClass"
                                            [ngStyle]="navMenuSubElement.link.ngStyle"
                                        >
                                            <i [ngClass]="navMenuSubElement.link.icon"></i>
                                            <span class="cursor--pointer">{{navMenuSubElement.link.label}}</span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </li>
                    </ng-container>
                </ul>
            </div>

            <div class="d-flex flex-column" style="background-color: rgb(75, 79, 84) !important;">
                <ul class="collapsible collapsible-accordion mt-0">
                    <ng-container *ngFor="let navMenuElement of orgNavMenu">
                        <li *ngIf="!navMenuElement.hide"
                            [id]="navMenuElement.id"
                            [routerLinkActive]="navMenuElement.link.routerLinkActive"
                            [routerLinkActiveOptions]="navMenuElement.link.routerLinkActiveOptions"
                        >
                            <a [id]="navMenuElement.link.id"
                                (click)="navMenuElement.link.onClick()"
                                [routerLink]="navMenuElement.link.routerLink"
                                [routerLinkActive]="navMenuElement.link.routerLinkActive"
                                [ngClass]="navMenuElement.link.ngClass"
                                style="background-color:#6E42FF !important;"
                            >
                                <i [ngClass]="navMenuElement.link.icon"></i>
                                <span class="cursor--pointer" [innerHTML]="navMenuElement.link.label"></span>
                                <i class="fas fa-arrows-alt-v"></i>
                            </a>
                        </li>
                    </ng-container>
                </ul>
    
                @if(orgUser?.loggedInUser) {
                    <div id="logged-in-as" style="margin-left:30px;padding-top:16px;">
                        <div class="d-flex flex-column">
                            <div class="body-1--weight-bold mb-1 pl-4">{{orgUser.loggedInUser.name}}</div>
                            <div class="body-2 mb-3 pl-4">{{accessText}}</div>
                        </div>
                    </div>
                }
            </div>
        </div>
    </header>
    <main data-html2canvas-ignore id="main">
        <div id="main-container">
            <div id="paymentDuePopup" class="row justify-content-center position-relative" style="display: none; background: green;margin-top: 62.5px; margin-bottom: -3rem;">
                <div class="col text-center">
                    <span class="h6" style="color: white">Your subscription payment is due</span>
                    <button id="payNow" onclick="orgMain.showPaymentModal()" class="btn btn-info btn-sm"><b>Pay Now</b></button>
                </div>
            </div>
            <div id="invoiceDuePopup" class="row justify-content-center position-relative" style="display: none; background: green;margin-top: 62.5px; margin-bottom: -3rem;">
                <div class="col text-center">
                    <span class="h6" style="color: white">You have a pending invoice</span>
                    <button id="payInvoiceNow" onclick="orgMain.showPaymentModal(true)" class="btn btn-info btn-sm"><b>Pay Now</b></button>
                </div>
            </div>
            <router-outlet></router-outlet>
        </div>      
    </main>
        <div data-html2canvas-ignore class="modal fade" id="uploadImageCropModel" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content"> 
                    <div class="modal-body" style="overflow: hidden;margin-right: 1rem;">
                        <img id="imageToCrop" src="" alt="image corp" style="max-height: 80vh; display: block; width: auto">
                        <div class="cropper-actions d-flex justify-content-center position-absolute" style="left:50%;margin-left:-64px;bottom:32px;">
                            <div class="cropper-actions__background position-absolute h-100 w-100" style="background-color:#000000;opacity:0.5;"></div>
                            <svg id="zoomIn" width="1em" height="1em" viewBox="0 0 16 16" class="m-2 bi bi-zoom-in" fill="#fff" style="cursor:pointer;z-index:1;" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" d="M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zM13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z"/>
                                <path d="M10.344 11.742c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1 6.538 6.538 0 0 1-1.398 1.4z"/>
                                <path fill-rule="evenodd" d="M6.5 3a.5.5 0 0 1 .5.5V6h2.5a.5.5 0 0 1 0 1H7v2.5a.5.5 0 0 1-1 0V7H3.5a.5.5 0 0 1 0-1H6V3.5a.5.5 0 0 1 .5-.5z"/>
                            </svg>
                            <svg id="zoomOut" width="1em" height="1em" viewBox="0 0 16 16" class="m-2 bi bi-zoom-out" fill="#fff" style="cursor:pointer;z-index:1;" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" d="M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zM13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z"/>
                                <path d="M10.344 11.742c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1 6.538 6.538 0 0 1-1.398 1.4z"/>
                                <path fill-rule="evenodd" d="M3 6.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5z"/>
                            </svg>
                            <svg id="rotateLeft" width="1em" height="1em" viewBox="0 0 16 16" class="m-2 bi bi-arrow-counterclockwise" fill="#fff" style="cursor:pointer;z-index:1;" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" d="M12.83 6.706a5 5 0 0 0-7.103-3.16.5.5 0 1 1-.454-.892A6 6 0 1 1 2.545 5.5a.5.5 0 1 1 .91.417 5 5 0 1 0 9.375.789z"/>
                                <path fill-rule="evenodd" d="M7.854.146a.5.5 0 0 0-.708 0l-2.5 2.5a.5.5 0 0 0 0 .708l2.5 2.5a.5.5 0 1 0 .708-.708L5.707 3 7.854.854a.5.5 0 0 0 0-.708z"/>
                            </svg>
                            <svg id="rotateRight" width="1em" height="1em" viewBox="0 0 16 16" class="m-2 bi bi-arrow-clockwise" fill="#fff" style="cursor:pointer;z-index:1;" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" d="M3.17 6.706a5 5 0 0 1 7.103-3.16.5.5 0 1 0 .454-.892A6 6 0 1 0 13.455 5.5a.5.5 0 0 0-.91.417 5 5 0 1 1-9.375.789z"/>
                                <path fill-rule="evenodd" d="M8.147.146a.5.5 0 0 1 .707 0l2.5 2.5a.5.5 0 0 1 0 .708l-2.5 2.5a.5.5 0 1 1-.707-.708L10.293 3 8.147.854a.5.5 0 0 1 0-.708z"/>
                            </svg>
                        </div>
                    </div>
                    <div class="modal-footer text-align-center" style="background-color: white;">
                        <button id="cropDone" class="btn btn-success">Select</button>
                    </div>
                </div>
            </div>
        </div>
    
        <div data-html2canvas-ignore class="modal fade" id="addTicketsModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col">
                                <div class="modal-main-heading">Create Ticket</div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="modal-sub-heading">
                                    Add single or group tickets and assign guests to tickets
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body">
                        <div class="px-3 mb-3">
                            <div class="card card--ticket">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-6">
                                            <div class="headline-6 white-text mb-2">Ticket Type</div>
                                            <div class="body-2 white-text">This here explains what is an individual ticket and when can the  user use  it</div>
                                        </div>
                                        <div class="col-6">
                                            <fieldset id="addTicketOptionFS" class="form-group noMargin mb-3 caret-up"></fieldset>
                                            <div id="addTicketQuantityRow">
                                                <div class="ticket-count white-text text-right mb-2">Ticket count <span id="ticketMultiplier"></span></div>
                                                <div class="mb-3">
                                                    <div class="input-group input-group--paybee justify-content-end">
                                                        <button id="addTicketCountDown" class="btn btn--first px-3" type="button">
                                                            -
                                                        </button>
                                                        <input id="addTicketCount" type="text" min="1" class="form-control body-1 text-center px-0" placeholder="">
                                                        <button id="addTicketCountUp" class="btn btn--last px-3" type="button">
                                                            +
                                                        </button>
                                                    </div>
                                                    <div class="d-none justify-content-end caption red-text mt-2" id="addTicketCountError"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="px-3">
                            <div id="addTicketDonorInfo" class="row custom-material-form updated-dropdown">
                                <div class="col-12">
                                    <div class="md-form">
                                        <input type='text' id='addTicketName' autocomplete='chrome-off' required class='form-control validate'>
                                        <label id="addTicketNameLabel" class='inputLabel' for='addTicketName' required data-error='Invalid' data-success=''>
                                            Name
                                        </label>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class='md-form'>
                                        <input type='text' id='addTicketEmail' autocomplete='chrome-off' required class='form-control validate'>
                                        <label id="addTicketEmailLabel" class='inputLabel' for='addTicketEmail' required data-error='Invalid' data-success=''>
                                            Email
                                        </label>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="black-text custom-control custom-switch mb-4">
                                        <input type="checkbox" class="custom-control-input" id="noneTicketEmail">
                                        <label class="custom-control-label subtitle-1" for="noneTicketEmail">No email available</label>
                                    </div>
                                </div>
                                <div class="col-12" id="accordionAddTicketsModal" style="display: none">
                                    <div class="md-accordion md-accordion--addToCard px-0  col-12" id="accordionExampleAddTicketsModal">
                                        <div class="card card--guest accordion z-depth-0">
                                            <div class="card-header card-header--guest p-0 d-flex justify-content-between" id='headerAddTicketsModal'>
                                                <button
                                                    class="btn btn-link btn-link--text-decoration-none btn-link--text-transform-none collapsed d-flex align-items-center pl-0 m-0"
                                                    type="button"
                                                    id='header_buttonAddTicketsModal'
                                                    data-toggle="collapse"
                                                    data-target="#contentAddTicketsModal"
                                                    aria-expanded="true"
                                                    aria-controls="accordionAddTicketsModal"
                                                >
                                                    <i class="fas fa-angle-down rotate-icon mr-3" style="font-size: 1.5rem;"></i>
                                                    <span class="body-1--weight-medium  black-text" data-toggle="tooltip-add-ticket" data-placement="right" title="This information is required on the donor side, but you can skip this step.">Additional information (Optional)</span>
                                                </button>
                                            </div>
                                            <div id="contentAddTicketsModal" class="collapse"
                                                aria-labelledby="headerAddTicketsModal"
                                                data-parent="#accordionExampleAddTicketsModal"
                                            >
                                                <div class="card-body">
                                                    <div class="col-12 mb-3 p-0" id="streetAddressDivAddTicketsModal">
                                                        <div class="row">
                                                            <div class="md-form col-9 no-bottom-margin">
                                                                <div class="position-relative black-text">
                                                                    <input class="form-control input-default mb-0 " type="text" placeholder="Search for address" id="streetAddressAddTicketsModal" onfocus="this.setAttribute('autocomplete','chrome-off')">
                                                                    <button id="streetAddressCanselBtnAddTicketsModal" type="button" class="matGoogleMapsAutocomplete-clear cansel-org-side">
                                                                        <i class="fas fa-times"></i>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            <div class="col-3">
                                                                <div class="md-form no-bottom-margin">
                                                                    <input class="form-control mb-0" type="text" id="streetAddressAddTicketsModalUnit">
                                                                    <label id="streetAddressUnitLabelAddTicketsModal" class="inputLabel" for="streetAddressAddTicketsModalUnit" data-error="Invalid" data-success="">Unit/Apt#</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-12 mb-3 p-0" id="phoneNumDivAddTicketsModal">
                                                        <div class='md-form no-bottom-margin'>
                                                            <input type='text' id='phoneNumAddTicketsModal' autocomplete='chrome-off' class='form-control validate mb-0'>
                                                            <label id="phoneNumLabelAddTicketsModal" class='inputLabel' for='phoneNumAddTicketsModal' data-success=''>
                                                                Phone
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div id="additionalInfoDivAddTicketsModal" class="col-12 p-0 mb-3">
                                                        <div class="md-form no-bottom-margin" style="margin-bottom: 4rem">
                                                            <input
                                                                type="text"
                                                                required
                                                                id="additionalInfoTextAddTicketsModal"
                                                                maxlength="512"
                                                                class="form-control validate mb-0">
                                                            <label
                                                                class="inputLabel"
                                                                id="additionalInfoTextLabelAddTicketsModal"
                                                                for="additionalInfoTextAddTicketsModal"
                                                                data-error="Invalid"
                                                                data-success="">
                                                                Additional Info
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div id="additionalInfoSelectDiv" class="col-12 p-0" style="margin-bottom: 20px">
                                                        <h6 class="text-left sectionHeading" id="additionalInfoSelectDesc"></h6>
                                                        <fieldset class="form-group noMargin" id="additionalInfoSelectList"></fieldset>
                                                        <small style="display: none" class="red-text text-left" id="additionalInfoSelectError"></small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div> 
                                </div>
                            </div>
                            <div id="addTicketPaymentRow" class="row custom-material-form updated-dropdown mt-3">
                                <div class="col-12 mb-4">
                                    <div class="d-flex align-items-center">
                                        <div class="black-text custom-control custom-switch mr-2">
                                            <input type="checkbox" class="custom-control-input" id="noPaymentRequiredTicketAdd">
                                            <label class="custom-control-label subtitle-1" for="noPaymentRequiredTicketAdd">Don't record payment for this ticket</label>
                                        </div>
                                        <i class="blue-text far fa-question-circle cursor--pointer" data-toggle="tooltip" data-placement="top" title="No payment will be recorded, and it will show up in the reports as a $0 transaction. Donors will not receive payment receipts, only a ticket confirmation email."></i>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <fieldset class="form-group noMargin">
                                        <select id="selectAddTicketPaymentMethod" class="mdb-select mdb-select--paybee noMargin validate mb-4">
                                            <option value="" selected disabled>Select Method</option>
                                            <option value="checkRecord">Check</option>
                                            <option value="record">Cash</option>
                                            <option value="other">Other</option>
                                        </select>
                                        <div id='selectAddTicketPaymentMethodError' class='red-text error-message' style="display: none"></div>
                                    </fieldset>
                                </div>
                            </div>
                            <div class="divider mb-4"></div>
                            <div class="row" id="addMemoAddTicketRow">
                                <div class="col-12">
                                    <div class="switch switch--paybee ml-n2 mb-3">
                                        <label>
                                          <input id="addMemoAddTicket" type="checkbox">
                                          <span class="lever"></span> Add memo
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="row custom-material-form updated-dropdown" id="memoAddTicketRow">
                                <div class="col-12">
                                    <div class="md-form">
                                        <input type='text' id='memoAddTicket' required class='form-control validate'>
                                        <label id="memoAddTicketLabel" class='inputLabel' for='memoAddTicket' required data-error='Invalid' data-success=''>
                                            Memo (optional)
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
    
                    <div class="modal-footer paybee-modal-footer">
                        <a class="btn btn-sm modal-cancel-button" data-dismiss="modal">Cancel</a>
                        <a id="addNewTicketButton" class="btn btn-sm modal-confirm-button">Create Ticket</a>
                    </div>
                </div>
            </div>
        </div>
    
        <div data-html2canvas-ignore class="modal fade" id="inviteTicketingModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col-11">
                                <div class="modal-main-heading">Send Invitations</div>
                            </div>
                            <div class="col-1">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" class="black-text">&times;</span>
                                </button>
                            </div>    
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="modal-sub-heading">
                                    Send Invitations for <span id="inviteCampaignName"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body">
                        <fieldset id="bulkUploadTicketInviteFS" class="campaignSettingsBlockFS">
                        </fieldset>
                        <div class="row justify-content-center">
                            <div class="col-8">
                                <div class="form-check md-form mb-4 pl-0">
                                    <input type="checkbox" class="form-check-input filled-in" id="ticketInviteNoOptionCheck" checked>
                                    <label  class="form-check-label" for="ticketInviteNoOptionCheck">Let invitee Select option and quantity</label>
                                </div>
                            </div>
                        </div>
                        <div class="row justify-content-center" id="ticketInviteOptionSelectRow">
                            <div class="col-8 text-center">
                                <div class="text-left" style="color: #757575; font-size: 0.8rem;">Select Option</div>
                                <small id="inviteOptionSelectError" class="red-text"></small>
                                <fieldset class="form-group noMargin caret-up" id="inviteOptionSelectFS" style="margin-bottom: 2rem;"></fieldset>
                            </div>
                        </div>
                        <div id="inviteRows">
                        </div>
                        <div class="row">
                            <div class='col'></div>
                            <div class='col'></div>
                            <div class='col-2'></div>
                            <div class='col-1 d-flex align-items-center justify-content-start mb-4'>
                                <a id="addNewInviteRow"> <i class='fas fa-plus'></i> </a>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer paybee-modal-footer">
                        <a class="btn btn-sm modal-cancel-button" data-dismiss="modal">Cancel</a>
                        <a id="sendInviteButton" class="btn btn-sm modal-confirm-button">Invite<i class="fas fa-paper-plane ml-1"></i></a>
                    </div>
                </div>
            </div>
        </div>
    
        <div data-html2canvas-ignore class="modal fade" id="inviteVirtualGuestsModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-notify modal-info modal-lg" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col-11">
                                <div id="inviteVirtualGuestsHeaderModal" class="modal-main-heading">Send Invitations</div>
                            </div>
                            <div class="col-1">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" class="black-text">&times;</span>
                                </button>
                            </div>
                        </div>                
                        <div class="row">
                            <div class="col">
                                <div class="modal-sub-heading">
                                    <span id="inviteVEventName"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body">
                        <fieldset id="uploadFileVirtualInviteFS" class="campaignSettingsBlockFS">
                        </fieldset>
                        <fieldset class="campaignSettingsBlockFS">
                            <legend class="campaignSettingsBlockLegend">Invite Manually</legend>
                            <div id="inviteVirtualRows" class="pr-4 pl-4">
                            </div>
                            <div class="row pr-4 pl-4">
                                <div class='col-1'></div>
                                <div class='col'></div>
                                <div class='col'></div>
                                <div class='col-1 my-auto'>
                                    <a id="addNewVirtualInviteRow"> <i class='fas fa-plus'></i> </a>
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class='col text-center'>
                                    <button id="sendVirtualInviteButton" class="btn btn-sm modal-confirm-button">
                                        Invite<i class="fas fa-paper-plane pl-2"></i>
                                    </button>
                                </div>
                            </div>
                        </fieldset>
                    </div>
                </div>
            </div>
        </div>
    
        <div data-html2canvas-ignore class="modal fade" id="addAtendeeVirtualGuestsModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-notify modal-info modal-lg" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col-11">
                                <div class="modal-main-heading">Add attendees</div>
                            </div>
                            <div class="col-1">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" class="black-text">&times;</span>
                                </button>
                            </div>
                        </div>                
                        <div class="row">
                            <div class="col">
                                <div class="modal-sub-heading">
                                    Add attendees to <span id="addAtendeeVEventName"></span>.<br>
                                    A confirmation email will be sent out immediately.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body">
                        <fieldset id="uploadFileVirtualAddAtendeeFS" class="campaignSettingsBlockFS">
                        </fieldset>
                        <fieldset class="campaignSettingsBlockFS">
                            <legend class="campaignSettingsBlockLegend">Add Manually</legend>
                            <div id="addAtendeeVirtualRows" class="pr-4 pl-4">
                            </div>
                            <div class="row pr-4 pl-4">
                                <div class='col-1'></div>
                                <div class='col'></div>
                                <div class='col'></div>
                                <div class='col-1 my-auto'>
                                    <a id="addNewVirtualAddAtendeeRow"> <i class='fas fa-plus'></i> </a>
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class='col text-center'>
                                    <button id="sendVirtualAddAtendeeButton" class="btn btn-sm modal-confirm-button">
                                        Add<i class="fas fa-paper-plane pl-2"></i>
                                    </button>
                                </div>
                            </div>
                        </fieldset>
                    </div>
                </div>
            </div>
        </div>

        <div data-html2canvas-ignore class="modal fade" id="addPaddle" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content paybee-modal-content paybee-modal-content--addPaddle">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col-11">
                                <div class="headline-5 mb-3">Add Pledges</div>
                            </div>
                            <div class="col-1">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" class="black-text">×</span>
                                </button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="modal-sub-heading">Add multiple pledges to donor carts</div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body custom-material-form updated-dropdown smaller-inputs">
                        <div class="col-10 text-left pl-4 subtitle-1--weight-bold mb-3">1. Select Campaign and Option.</div>
                        <div id="addPaddleModalCampaignBlock" class="row justify-content-center  mb-4" >
                            <div class="col-10 text-left p-0"> 
                                <div class="text-left subtitle-2">Choose Campaign </div>
                                <fieldset id="addPaddleModalCampaignFS" class="form-group noMargin">
                                </fieldset>
                                <small class="red-text" id="addPaddleModalCampaignSelectError"></small>
                            </div>
                        </div>
                        <div id="addPaddleModalOptionBlock" class="row justify-content-center">
                            <div class="col-10 text-left md-form d-flex p-0" style="margin-bottom: 0!important;">
                                <div class="w-100">
                                    <div class="text-left subtitle-2">Choose the Pledge Option</div>
                                    <input min="1" step="1" type="number" id="addPaddleModalOptionInput" class="form-control validate mb-0 disabled">
                                    <fieldset id="addPaddleModalOptionFS" class="form-group noMargin">
                                    </fieldset>
                                    <small class="red-text" id="addPaddleOptionSelectError"></small>
                                </div>
                                <div id="addPaddleModalQuantityBlock" class="ml-4">
                                    <div class="text-left subtitle-2">Quantity</div>
                                    <input min="1" step="1" type="number" id="addPaddleModalOptionQuantity" class="form-control validate mb-1 pb-0">
                                    <small class="red-text" id="addPaddleModalQuantityError"></small>
                                </div>
                            </div>
                        </div>
                        <div id="addToCartBlock">
                            <div class="col-10 text-left pl-4 subtitle-1--weight-bold mb-1 mt-5">2. Add to cart.</div>
                            <div class="col-12 pl-4 mb-3 input-description text-dark" id="addToCartDescr">Add paddle numbers and press enter to add to cart.</div>
                            <div class="row justify-content-center  mb-3" id="addPaddleNumberRow">
                                <div class="col-10 d-flex align-items-start p-0">
                                    <div class="md-form w-100 mr-4 d-flex" style="margin-bottom: 0 !important; ">
                                        <div class="w-100">
                                            <div id='paddleNumberLabel'class="text-left subtitle-2">Paddle Number</div>
                                            <input min="1" step="1" type="number" id="addPaddleModalPaddleNum" class="form-control validate mb-0 pb-0">
                                            <small class="red-text" id="addPaddleModalPaddleNumError"></small>
                                        </div>
                                        <div id="addPaddleModalAmountRow" class="ml-2">
                                            <div class="text-left subtitle-2">Amount</div>
                                            <input min="1" step="0.01" type="number" id="addPaddleModalOptionAmount" class="form-control validate mb-0 pb-0">
                                        </div>
                                    </div>
                                    <a id="addPaddleNumButton" class="btn btn-sm modal-success-button waves-effect waves-light mt-4" style="height: 35px !important; width: 200px;">Add </a>
                                </div>
                            </div>
                            <small class="red-text" id="addPaddleItemError"></small>
                            <div id="paddlesListBlock" class="row justify-content-center mb-4" >
                                <div class="col-10 text-left p-0">
                                    <span class="subtitle-1--weight-regular">Just Added</span>
                                    <div id='paddleListBlock'>
                                        <ul id="paddleList" class="pt-2 list-group overflow-auto d-flex flex-row pb-4">
                                        </ul>
                                    </div>
                                    <div id='paddleEmptyBlock'>
                                        <div  class="w-100 p-0 overflow-auto noPaddlesBlock d-flex justify-content-center align-items-center">
                                            <span  class="body-2">No paddles added yet</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
    
                    </div>
                    <div class="modal-footer paybee-modal-footer" style="background-color: white !important;border-top: 1px solid #DFDFDF;">
                        <a class="btn btn-sm modal-cancel-button" data-dismiss="modal">Close</a>
                    </div>
                </div>
            </div>
        </div>
    
        <div data-html2canvas-ignore class="modal fade" id="uploadMusicModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-notify modal-info modal-lg" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col-11">
                                <div class="modal-main-heading">Music</div>
                            </div>
                            <div class="col-1">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" class="black-text">&times;</span>
                                </button>
                            </div>    
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="modal-sub-heading">
                                    Upload Music File
                                </div>                            
                            </div>
                        </div>
                    </div>
                    <div class="modal-body" id="musicUploadBlock">
                        <div class="file-upload-wrapper" id="uploadMusicFileWrapper">
                            <input type="file" id="uploadMusicFile" class="file-upload" data-max-file-size="5M" />
                        </div>
                        <div class="row mt-2">
                            <div class="col text-center">
                                <div class="red-text small" id="uploadMusicFileError"></div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body" id="musicUploadDone">
                        <div class="row align-items-center">
                            <div class="col text-center" id="musicUploadPreviewCol"></div>
                        </div>
                        <div class="row">
                            <div class="col form-group text-center">
                                <input type="checkbox" class="form-check-input filled-in" id="setSameMusicForOther">
                                <label class="form-check-label" for="setSameMusicForOther">Set same music for the <span id="musicSetOther"></span></label>
                            </div>
                        </div>
                        <div class="row mt-4 pt-4">
                            <div class="col form-group text-center">
                                <div id="rightCheckError" class="red-text small"></div>
                                <input type="checkbox" class="form-check-input filled-in" id="assertMusicRightsCheck">
                                <label class="form-check-label" for="assertMusicRightsCheck">I confirm to have rights for the music to play in my virtual gala.</label>
                            </div>
                        </div>
                        <div class="row text-center">
                            <div class="col mb-0">
                                <button class="btn btn-sm modal-confirm-button" id="updateMusic">Update</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    
        <div data-html2canvas-ignore class="modal fade" id="inviteActionModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-notify modal-info modal-lg" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header pb-0">
                        <div class="row">
                            <div class="col-10">
                                <div class="modal-main-heading">Invitation Details</div>
                            </div>
                            <div class="col-2">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" class="black-text">&times;</span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col">
                                <div class="d-flex mb-4">
                                    <img class="mr-4" src="/images/svg/quickpay/mail-circle-large@2x.svg" height="48" width="48">
                                    <div class="d-block">
                                        <div class="d-flex align-items-center mb-1">
                                            <div class="subtitle-1 mr-3" id="inviteeName"></div>
                                            <div class="body-2 mr-3" id="inviteeEmail"></div>
                                            <div class="d-flex align-items-center" id="inviteStatus"></div>
                                        </div>
                                        <div class="body-2 purple-text" id="inviteDesc"></div>
                                    </div>
                                </div>
                                <div class="d-block">
                                    <p id="inviteStatusDate"></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    
        <div data-html2canvas-ignore class="modal fade" id="ticketActionModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-notify modal-info modal-lg" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col-10">
                                <div class="modal-main-heading">Ticket Details</div>
                            </div>
                            <div class="col-2">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" class="black-text">&times;</span>
                                </button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="modal-sub-heading">Ticket and guest details.</div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body" id="ticketGuestList">
                        <div class="row">
                            <div class="col">
                                <div class="row">
                                    <div class="col-3">
                                        <div class="row"><div class="col">
                                            <p class="text-center"><i class="fas fas fa-qrcode fa-4x"></i></p>
                                        </div></div>
                                        <div class="row"><div class="col text-center">
                                            <a  target="_blank" id="seeGuestView" href="#" class="blue-text h6" style="text-decoration: underline;">Captain's view</a>
                                        </div></div>
                                    </div>
    
                                    <div class="col-9">
                                        <div>
                                            <span id="ticketDetailName" class="h4" style="margin-right: 1rem"></span>
                                            <span id="ticketDetailEmail" class="h6" style="font-weight: 300"></span>
                                        </div>
                                        <h5 id="ticketDetailOption" style="margin-right: 1rem;margin-top: 1rem;"></h5>
                                    </div>
                                </div>
                            </div>
                        </div>
    
                        <div id="confirmedGuestInfoDiv">
                            <div class="row mt-4">
                                <div class="col">
                                    Confirmed Guests <a id="adminAddGuestButton" class="blue-text ml-2 h6" style="text-decoration: underline;">Add Guests</a>
                                </div>
                                <div class="col text-right">
                                    <a class="blue-text h6" id="adminAddGuestReminderButton" style="text-decoration: underline;">Send Add Guest Reminder</a>
                                </div>
                            </div>
                            <table class="table table-hover">
                                <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Email</th>
                                    <th>Preference</th>
                                </tr>
                                </thead>
                                <tbody id="confirmedGuestInfo">
                                </tbody>
                            </table>
                        </div>
    
                        <div id="invitedGuestInfoDiv">
                            <div class="row mt-4">
                                <div class="col">
                                    Invitations <a id="adminInviteButton" class="blue-text h6 ml-2" style="text-decoration: underline;">Invite</a>
                                </div>
                            </div>
                            <table class="table table-hover">
                                <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Email</th>
                                    <th>Count</th>
                                    <th>Status</th>
                                </tr>
                                </thead>
                                <tbody id="invitedGuestInfo">
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="modal-body" id="sendAdminInvitations">
                        <h4 class="card-title text-purple text-center" style="font-weight: 300;">Invite Guests on Behalf of <b id="captainNameInvite"></b></h4>
                        <p class="card-title text-purple text-center" style="font-weight: 300;"><span id="inviteRemainingCount"></span> Seat(s) Remaining</p>
                        <p style="font-weight: 300;" class="teal-text text-muted text-center">Please select the number of guests and invite via email.</p>
                        <div class="row  justify-content-center" style="margin-top: 3rem;">
                            <div class="col">
                                <form class="text-center" style="color: #757575;" action="#!">
                                    <div class="row  justify-content-center">
                                        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-4">
                                            <select class="browser-default custom-select" id="selectInviteCount">
                                            </select>
                                        </div>
                                    </div>
    
                                    <div class="row  justify-content-center">
                                        <div class="col-xs-12 col-sm-12 col-md-10 col-lg-8 col-xl-8">
                                            <div class="md-form">
                                                <input
                                                        type="text"
                                                        id="inviteTicketGuestName"
                                                        autocomplete='name'
                                                        required
                                                        class="form-control validate">
                                                <label
                                                        id="inviteTicketGuestNameLabel"
                                                        class="inputLabel"
                                                        for="inviteTicketGuestName"
                                                        data-error="Invalid"
                                                        data-success="">Guest Name</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row  justify-content-center">
                                        <div class="col-xs-12 col-sm-12 col-md-10 col-lg-8 col-xl-8">
                                            <div class="md-form">
                                                <input
                                                        type="email"
                                                        id="inviteTicketGuestEmail"
                                                        autocomplete='email'
                                                        required
                                                        class="form-control validate">
                                                <label
                                                        id="inviteTicketGuestEmailLabel"
                                                        class="inputLabel"
                                                        for="inviteTicketGuestEmail"
                                                        data-error="Invalid"
                                                        data-success="">Guest Email</label>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
    
                        <div class="row  justify-content-center" style="padding-top: 3rem;padding-bottom: 2rem; width: 70%; margin: auto">
                            <div class="col">
                                <button id="inviteTicketGuestsDone" class="btn btn-light btn-block">Back</button>
                            </div>
                            <div class="col">
                                <button id="inviteTicketGuests" class="btn btn-info btn-block">Invite</button>
                            </div>
                        </div>
    
                    </div>
                    <div class="modal-body" id="addAdminGuests">
                        <div class="row  justify-content-center">
                            <div class="col-xs-12 col-sm-12 col-md-10 col-lg-8 col-xl-8 card-title">
                                <h4 class="card-title text-purple text-center" style="font-weight: 300;">Add Guests on Behalf of <b id="captainNameAddGuests"></b></h4>
                                <p class="card-title text-purple text-center" style="font-weight: 300;"><span id="inviteGuestSelfRemainingCount"></span> Seats Remaining</p>
                                <p style="font-weight: 300;" class="teal-text text-muted text-center">Please select the number of guests and complete the required guest information.</p>
                            </div>
                        </div>
                        <div class="row  justify-content-center">
                            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 card-title">
                                <div class="col" style="margin-top: auto; margin-bottom: auto">
                                    <select class="browser-default custom-select noMargin validate" id="addGuestSelfCountSelect">
                                    </select>
                                </div>
                            </div>
                        </div>
    
                        <div class="row  justify-content-center">
                            <div class="col-xs-12 col-sm-12 col-md-10 col-lg-8 col-xl-8">
                                <div id="addGuestSelfBlock">
    
                                </div>
                            </div>
                        </div>
                        <div class="row  justify-content-center" style="padding-top: 3rem;padding-bottom: 2rem; width: 70%; margin: auto">
                            <div class="col">
                                <a id="backToDetail" class="btn btn-light btn-block">Cancel</a>
                            </div>
                            <div class="col">
                                <button id="addGuestSelfButton" class="btn btn-info btn-block">Add Guest</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    
        <div data-html2canvas-ignore class="modal fade" id="editEventTableModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-notify modal-info" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header border-bottom">
                        <div class="row">
                            <div class="col-10">
                                <div class="modal-main-heading">Edit Table</div>
                            </div>
                            <div class="col-2">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" class="black-text">&times;</span>
                                </button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div id="editEventTableModalSubHeader" class="modal-sub-heading"></div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="modal-body pb-0">
                        <div class="row mb-4">
                            <div class="col">
                                <div class="subtitle-1--weight-regular green-text mb-2">Table Number <span id="tableNumUpdateDisplay" class="ml-3"></span></div>
                                <div class="d-flex">
                                    <div class="subtitle-2 black-text mr-5">Assigned <span id="tableAssignedSeatsDisplay" class="ml-3"></span></div>
                                    <div class="subtitle-2 black-text">Open <span id="tableOpenSeatsDisplay" class="ml-3"></span></div>
                                </div>
                            </div>
                        </div>
                        <div class="row custom-material-form">
                            <div class="col-9 d-flex text-center">
                                <div class="md-form w-100">
                                    <input type="text" id="tableNameUpdate" maxlength="16" required="" class="form-control validate mb-0">
                                    <label id="tableNameUpdateLabel" class="inputLabel" for="tableNameUpdate" data-error="Invalid" data-success="">
                                        Table Name (optional)
                                    </label>
                                </div>
                            </div>
                            <i class="blue-text far fa-question-circle cursor--pointer ml-2 mt-3 h-25 ml-n1" data-toggle="tooltip" data-placement="top" title="If tables at your event go by a different name or alphanumeric value, use this field to add names to your table. If table name is present, table number will not be shown on the paddle."></i>
                            
                            <div class="col-9 form-group text-center mb-0">
                                <div class="md-form">
                                    <input type="text" id="tableCategoryUpdate" maxlength="16" required="" class="form-control validate mb-0">
                                    <label id="tableCategoryUpdateLabel" class="inputLabel" for="tableCategoryUpdate" data-error="Invalid" data-success="">
                                        Category (optional)
                                    </label>
                                </div>
                            </div>

                            <div id="assignedSeatingBlock" class="col-12 p-0 form-group text-center d-flex align-items-center justify-content-between">
                                <div class="custom-control custom-switch ml-3 mb-2 d-flex ">
                                    <input type="checkbox" class="custom-control-input" id="assignedSeatingEdit">
                                    <label id="assignedSeatingEditLabel" class="custom-control-label subtitle-1" for="assignedSeatingEdit">Guest will have assigned seats</label>
                                </div>
                            </div>
                            <div id="numOfSeatsBlock" class="col-6 form-group text-center m-0">
                                <div class="md-form" style="margin-bottom: 0 !important;">
                                    <input type="number" id="tableNumSeatsUpdate" required="" class="form-control validate mb-3">
                                    <label id="tableNumSeatsUpdateLabel" class="inputLabel" for="tableNumSeatsUpdate" data-error="Invalid" data-success="">
                                        No. of Seats
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer paybee-modal-footer">
                        <a class="btn btn-sm modal-cancel-button" data-dismiss="modal">Cancel</a>
                        <a id="updateEventTableButton" class="btn btn-sm modal-confirm-button">Update</a>
                    </div>
                </div>
            </div>
        </div>

        <div data-html2canvas-ignore class="modal fade" id="editEventGolfHoleModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-notify modal-info" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header border-bottom">
                        <div class="row">
                            <div class="col-10">
                                <div class="modal-main-heading">Edit Golf Hole</div>
                            </div>
                            <div class="col-2">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" class="black-text">&times;</span>
                                </button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div id="editEventGolfHoleModalSubHeader" class="modal-sub-heading"></div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="modal-body pb-0">
                        <div class="row mb-4">
                            <div class="col">
                                <div class="subtitle-1--weight-regular green-text mb-2">Hole Number <span id="holeNumUpdateDisplay" class="ml-3"></span></div>
                                <div class="d-flex">
                                    <div class="subtitle-2 black-text mr-5">Assigned <span id="holeAssignedCountDisplay" class="ml-3"></span></div>
                                    <div class="subtitle-2 black-text">Open <span id="holeOpenCountDisplay" class="ml-3"></span></div>
                                </div>
                            </div>
                        </div>
                        <div class="row custom-material-form">
                            <div class="col-9 d-flex text-center">
                                <div class="md-form w-100">
                                    <input type="text" id="holeNameUpdate" maxlength="16" required="" class="form-control validate mb-0">
                                    <label id="holeNameUpdateLabel" class="inputLabel" for="holeNameUpdate" data-error="Invalid" data-success="">
                                        Hole Name (optional)
                                    </label>
                                </div>
                            </div>
                            <i class="blue-text far fa-question-circle cursor--pointer ml-2 mt-3 h-25 ml-n1" data-toggle="tooltip" data-placement="top" title="If holes at your event go by a different name or alphanumeric value, use this field to add names to your hole. If hole name is present, hole number will not be shown on the paddle."></i>
                        </div>
                    </div>
                    <div class="modal-footer paybee-modal-footer">
                        <a class="btn btn-sm modal-cancel-button" data-dismiss="modal">Cancel</a>
                        <a id="updateEventGolfHoleButton" class="btn btn-sm modal-confirm-button">Update</a>
                    </div>
                </div>
            </div>
        </div>
    
        <div data-html2canvas-ignore class="modal fade" id="editGuestModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-notify modal-info modal-lg" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col-10">
                                <div class="modal-main-heading">Edit Guest Details</div>
                            </div>
                            <div class="col-2">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" class="black-text">&times;</span>
                                </button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="modal-sub-heading">Edit Guest information</div>
                            </div>
                        </div>
                    </div>
    
                    <div class="modal-body" id="editGuest">
                        <div style="display:none" id="editGuestData"></div>
                        <div class="row justify-content-center">
                            <div class="col-xs-12 col-sm-12 col-md-10 col-lg-8 col-xl-8">
                                <div id="editGuestBlock">
                                </div>
                            </div>
                        </div>
                        <div class="row justify-content-center">
                            <div class="col-xs-12 col-sm-12 col-md-10 col-lg-8 col-xl-8 caret-up" id="updateGuestTableCol">
                            </div>
                        </div>
                        <div class="row justify-content-center">
                            <div class="col-xs-12 col-sm-12 col-md-10 col-lg-8 col-xl-8 caret-up" id="updateGuestTableSeatCol">
                            </div>
                            <div id="updateSeatColError" class="col-xs-12 col-sm-12 col-md-10 col-lg-8 col-xl-8 body-2 pl-3 red-text" style="display: none;">Please select seat</div>
                        </div>

                        <div class="row justify-content-center">
                            <div class="col-xs-12 col-sm-12 col-md-10 col-lg-8 col-xl-8 caret-up" id="updateGuestGolfHoleCol">
                            </div>
                        </div>
                        <div class="row justify-content-center">
                            <div class="col-xs-12 col-sm-12 col-md-10 col-lg-8 col-xl-8 caret-up" id="updateGuestGolfHoleCartCol">
                            </div>
                            <div id="updateGuestGolfHoleCartColError" class="col-xs-12 col-sm-12 col-md-10 col-lg-8 col-xl-8 body-2 pl-3 red-text" style="display: none;">Please select cart</div>
                        </div>
                    </div>
                    <div class="modal-footer paybee-modal-footer">
                        <a class="btn btn-sm modal-cancel-button" data-dismiss="modal">Cancel</a>
                        <a id="updateGuestButton" class="btn btn-sm modal-confirm-button">Update</a>
                    </div>
                </div>
            </div>
        </div>
    
        <div data-html2canvas-ignore class="modal fade" id="editGuestTableModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-notify modal-info modal-xl" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col-10">
                                <div class="modal-main-heading">Manage Guest Tables</div>
                            </div>
                            <div class="col-2">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" class="black-text">&times;</span>
                                </button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div id="editGuestTableModalSubHeader" class="modal-sub-heading">See and move table for guests.</div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body">
                        <div class="text-center purple-text" style="display:none" id="addGuestTableDisplay"></div>
    
                        <div class="row justify-content-center" id="addGuestTableData">
                            <div class="col">
                                <div class="table--paybee">
                                    <table class="table dataTable">
                                        <thead class="thead-light">
                                            <tr>
                                                <th>Name</th>
                                                <th>Email</th>
                                                <th>Table</th>
                                                <th>Seat</th>
                                                <th>Status</th>
                                            </tr>
                                        </thead>
                                        <tbody id="guestTableTable">
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div class="row justify-content-center" style="margin-top: 2rem;">
                            <div class="col text-center" id="noGuestAssignTableCol">
                                <h5>No guest added to this ticket</h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div data-html2canvas-ignore class="modal fade" id="editGuestGolfHoleModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-notify modal-info modal-xl" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col-10">
                                <div class="modal-main-heading">Manage Guest Golf Holes</div>
                            </div>
                            <div class="col-2">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" class="black-text">&times;</span>
                                </button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div id="editGuestGolfHoleModalSubHeader" class="modal-sub-heading">See and move golf hole for guests.</div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body">
                        <div class="text-center purple-text" style="display:none" id="addGuestGolfHoleDisplay"></div>
    
                        <div class="row justify-content-center" id="addGuestGolfHoleData">
                            <div class="col">
                                <div class="table--paybee">
                                    <table class="table dataTable">
                                        <thead class="thead-light">
                                            <tr>
                                                <th>Name</th>
                                                <th>Email</th>
                                                <th>Hole</th>
                                                <th>Cart</th>
                                                <th>Status</th>
                                            </tr>
                                        </thead>
                                        <tbody id="guestGolfHoleTable">
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div class="row justify-content-center" style="margin-top: 2rem;">
                            <div class="col text-center" id="noGuestAssignGolfHoleCol">
                                <h5>No guest added to this ticket</h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    
        <div data-html2canvas-ignore class="modal fade" id="virtualAttendeeSessionModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">                    
                        <div class="row">
                            <div class="col-11">
                                <div class="modal-main-heading">Session For <span id="virtualAttendeeSessionName"></span></div>
                            </div>
                            <div class="col-1">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" class="black-text">&times;</span>
                                </button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="modal-sub-heading">Session logs for current user</div>
                            </div>
                        </div>     
                    </div>
                    <div class="modal-body">
                        <div class="row justify-content-center">
                            <div class="col">
                                <table class="table table-hover">
                                    <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Start</th>
                                        <th>End</th>
                                        <th style="white-space: nowrap;">Total Time</th>
                                    </tr>
                                    </thead>
                                    <tbody id="virtualAttendeeSessionTable">
                                        <tr>
                                            <td>1</td>
                                            <td>01/13/2020 7:30pm</td>
                                            <td>01/13/2020 8:29pm</td>
                                            <td>59 Minutes</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer paybee-modal-footer">
                        <a class="btn btn-sm modal-cancel-button" data-dismiss="modal">Cancel</a>
                    </div>
                </div>
            </div>
        </div>
    
        <div data-html2canvas-ignore class="modal fade" id="donorDetailModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">                    
                        <div class="row">
                            <div class="col-11">
                                <div id="donorName" class="modal-main-heading"></div>
                            </div>
                            <div class="col-1">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" class="black-text">&times;</span>
                                </button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="modal-sub-heading">Donor History.</div>
                            </div>
                        </div>                    
                    </div>
                    <div class="modal-body">
                        <div class="row justify-content-center">
                            <div class="col-11">
                                <div class="table--paybee">
                                    <table id ="donorTransactions" class="table" cellspacing="0" style="width: 100%;">
                                        <thead class="thead-light">
                                            <tr>
                                                <th>Campaign </th>
                                                <th>Option </th>
                                                <th>Status </th>
                                                <th>Amount</th>
                                                <th>Date </th>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    
        <div data-html2canvas-ignore class="modal fade" id="donorAnnualReceiptModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">                    
                        <div class="row">
                            <div class="col-11">
                                <div id="donorNameReceipt" class="modal-main-heading"></div>
                            </div>
                            <div class="col-1">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" class="black-text">&times;</span>
                                </button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="modal-sub-heading">Send consolidated annual donation receipt. Select year and edit email id to send to email different from current email on the account.</div>
                            </div>
                        </div>                    
                    </div>
                    <div class="modal-body">
                        <div class="row justify-content-center custom-material-form updated-dropdown" id="sendReceiptRow" style="margin-bottom: 2rem">
                            <div class="col-11" style="padding-bottom: 1rem;">
                                <div style="display:none" id="currentUserId"></div>
                                <div class="row justify-content-center">
                                    <div class="col-7 text-center">
                                        <div class="md-form" style="margin-bottom: 2rem;">
                                            <input type="email" id="taxReceiptEmail" autocomplete='email' required class="form-control validate">
                                            <label id="taxReceiptEmailLabel" class="inputLabel" for="taxReceiptEmail" data-error="Invalid" data-success="">
                                                Send to Email Address
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="row justify-content-center">
                                    <div class="col-7 text-center">                                    
                                        <div class="text-left" style="font-size: 14px; color: #757575; font-weight: 300;" >Select Year</div>
                                        <select id="taxReceiptYear" class="select-wrapper mdb-select mdb-select--paybee">
                                            <option value="2025" selected>YTD 2025</option>
                                            <option value="2024">2024</option>
                                            <option value="2023">2023</option>
                                            <option value="2022">2022</option>
                                            <option value="2021">2021</option>
                                            <option value="2020">2020</option>
                                            <option value="2019">2019</option>
                                        </select>                                    
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer paybee-modal-footer">
                        <div class="row justify-content-center w-100">
                            <div class="col text-left">
                                <a id="taxReceiptPreview" class="btn btn--paybee btn--green button waves-effect waves-light">Preview Receipt</a>
                            </div>
                            <div class="col text-center">
                                <a class="btn btn-sm modal-cancel-button" data-dismiss="modal">Cancel</a>
                                <a id="sendDonorReceipt" class="btn btn-sm modal-confirm-button">Send <span id="taxYear">2022</span> Receipt</a>                    
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>


        <div data-html2canvas-ignore class="modal fade right" id="donorAddEditNotesModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-full-height notes-modal" role="document">
                <div class="modal-content paybee-modal-content custom-material-form" style="margin-bottom: 6rem;border-top-right-radius: 0px !important;border-bottom-right-radius: 0px !important;">
                    <div class="paybee-modal-header">                    
                        <div class="row">
                            <div class="col-11">
                                <div id="donorNameNotes" class="modal-main-heading"></div>
                            </div>
                            <div class="col-1">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" class="black-text">&times;</span>
                                </button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="modal-sub-heading" id="noteSubHeaderModal">Add or edit notes for this donor</div>
                            </div>
                        </div>                    
                    </div>
                    <div class="modal-body custom-material-form updated-dropdown">
                        <div id="noteListScreen">
                            <div id="notesList" style="max-height:calc(100vh - 460px); overflow:scroll">
                            </div>
                        </div>
                        <span id="noNotest" class="body-1 text-center mt-3">You do not have any notes for this donor. Create one.</span>
                    </div>
                    <div class="modal-footer paybee-modal-footer">
                        <div class="md-form flex-column justify-content-end align-items-end w-100 quill-editor--paybee">
                            <div id="notesQuill" class="form-control md-textarea overflow-visible resize-vertical" style="height: 100px !important;">
                            </div>
                            <button class="position-absolute modal-secondary-button purple" id="sendNoteBtn" style="top: 5px;right: 10px;">Add A Note</button>
                            <div id='editButtonsBlock' class="position-absolute" style="top: 5px;right: 10px;display: none;">
                                <button class=" modal-secondary-button mr-1 purple" id="canselNoteEditBtn">Cancel</button>
                                <button class=" modal-secondary-button white" id="updateNoteBtn">Update</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    
        <div data-html2canvas-ignore class="modal fade" id="donorAnnualReceiptPreviewModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">                    
                        <div class="row">
                            <div class="col-11">
                                <div id="donorNameReceiptPreview" class="modal-main-heading"></div>
                            </div>
                            <div class="col-1">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" class="black-text">&times;</span>
                                </button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="modal-sub-heading">Preview email and PDF receipt</div>
                            </div>
                        </div>                    
                    </div>
                    <div class="modal-body">
                        <div class="row justify-content-center">
                            <div class="col text-center">
                                <div class="text-left body-1">Email Preview</div>
                                <div id="textReceiptEmailHtml" class="text-left" style="margin-top: 15px"></div>
                            </div>
                        </div>
                        <div class="row justify-content-center">
                            <div class="col text-center">
                                <div class="text-left body-1 mt-4 mb-2">PDF Receipt Preview</div>
                                <object id="taxReceiptReviewPDF" type="application/pdf" style="height: 640px; width: 490px" data=""></object>                            
                            </div>
                        </div>           
                    </div>
                    <div class="modal-footer paybee-modal-footer">
                        <a class="btn btn-sm modal-cancel-button" data-dismiss="modal">Close</a>
                    </div>
                </div>
            </div>
        </div>
    
        <div data-html2canvas-ignore class="modal fade" id="editDonorModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col">
                                <div class="modal-main-heading">Edit Donor Details: <span id="editDonorName"></span></div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="modal-sub-heading">Update donor details.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body pt-0 custom-material-form updated-dropdown">
                        <div class="row justify-content-center">
                            <div class="col-11">
                                <div>
                                    <div class="md-form">
                                        <input type="text" id="editDonorNameInput" class="form-control">
                                        <label class="inputLabel" data-error="Invalid" data-success="" id="editDonorNameInputLabel" for="editDonorNameInput" class="form-label">Name</label>
                                    </div>
                                    <div class="md-form">
                                        <input onfocus="this.setAttribute('autocomplete','chrome-off')" name="randomnocomplete" class="form-control" type="text" placeholder="Search for address" id="editDonorStreetAddress">
                                        <button id="editDonorStreetAddressCanselBtn" type="button" class="matGoogleMapsAutocomplete-clear cansel-org-side">
                                            <i class="fas fa-times"></i>
                                        </button>
                                    </div>    
                                    <div class="row">
                                        <div class="col-8">
                                            <div class="md-form">
                                                <input class="form-control" type="text" id="editDonorStreetAddressUnit">
                                                <label id="editDonorStreetAddressUnitLabel"
                                                    class="inputLabel"
                                                    for="editDonorStreetAddressUnit"
                                                    data-error="Invalid"
                                                    data-success="">Unit/Apartment# (optional)</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col">
                                            <small class="red-text" id="editDonorResolveError"></small>
                                        </div>
                                    </div>                    
                                </div>                    
                                <div class="md-form pb-2">
                                    <input type="text" id="editDonorPhone" class="form-control">
                                    <label class="inputLabel" data-error="Invalid" data-success="" id="editDonorPhoneLabel" for="editDonorPhone" class="form-label">Phone</label>
                                </div>
                                <div class="md-form pb-2">
                                    <input type="text" id="editDonorExternalId" class="form-control">
                                    <label class="inputLabel" data-error="Invalid" data-success="" id="editDonorExternalIdLabel" for="editDonorExternalId" class="form-label">External Donor Id</label>
                                </div>                                                
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer paybee-modal-footer">
                        <a class="btn btn-sm modal-cancel-button" data-dismiss="modal">Cancel</a>
                        <a id="updateDonorButton" class="btn btn-sm modal-confirm-button">Update</a>
                    </div>
                </div>
            </div>
        </div>
    
        <div data-html2canvas-ignore class="modal fade" id="recurringDetailModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-notify modal-info modal-lg" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-12 d-flex justify-content-between mb-4">
                                <div class="d-flex align-items-center">
                                    <div id="recurringDonorNameTitle" class="user-name body-2"></div>
                                    <div class="mx-1">/</div>
                                    <div id="recurringDonorEMailTitle" class="user-email body-2"></div>
                                </div>
                                <div class="d-flex">
                                    <div id="recurring_dropdown" x-placement='bottom-end'>
                                        <a
                                            id='recurring_dropdown_toggle'
                                            class="btn btn-sm modal-outline-button waves-effect waves-light my-0 ml-2 mr-0 px-3"
                                            type='button'
                                            data-toggle='dropdown'
                                            aria-haspopup='true'
                                            aria-expanded='false'
                                            style="min-width:auto;"
                                        >
                                            <i class='black-text fas fa-ellipsis-h mt-0'></i>
                                        </a>
                                        <div id='recurring_dropdown_menu' class='dropdown-menu dropdown-menu-right' aria-labelledby='dropdownMenuMenu'>
                                            <button class='dropdown-item body-2 py-2 %showSendReminder%' type='button' title='Send Reminder'>
                                                Update Payment
                                            </button>
                                            <button class='dropdown-item body-2 py-2 %showSendAddGuestReminder%' type='button' title='Send Add Guest Reminder'>
                                                Cancel Recurring
                                            </button>
                                            <button class='dropdown-item body-2 py-2 %showDelete%' type='button'>
                                                Send Update Link
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 d-flex align-items-center mb-4">
                                <div id="recurringFrequency" class="headline-6 black-text mr-3"></div>
                                <div id="recurringStatus" class="d-flex align-items-center"></div>
                            </div>
                            <div class="col-12 d-flex align-items-center justify-content-between mb-4">
                                <div class="d-flex align-items-center">
                                    <img id="recurringImage" height="60" width="120" class="mr-3" />
                                    <div id="recurringName" class="body-1 black-text"></div>
                                </div>
                                <div class="d-flex align-items-center ml-5">
                                    <div id="recurringAmount" class="headline-6 green-text"></div>
                                </div>
                            </div>
                            <div class="col-12">
                                <ul class="nav nav-tabs md-tabs md-tabs--paybee md-tabs__bottom-border p-0" role="tablist">
                                    <li class="nav-item">
                                        <a class="nav-link active" id="recurringDetailsTabNav" data-toggle="tab" href="#recurringDetailsTab" role="tab" aria-controls="recurringDetailsTab"
                                           aria-selected="true">Details</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" id="recurringTransactionsTabNav" data-toggle="tab" href="#recurringTransactionsTab" role="tab" aria-controls="recurringTransactionsTab"
                                           aria-selected="false">Transactions</a>
                                    </li>
                                </ul>
                                <div class="tab-content pt-4">
                                    <div class="tab-pane fade show active" id="recurringDetailsTab" role="tabpanel" aria-labelledby="recurringDetailsTabNav">
                                        <div class="row">
                                            <div class="col-6">
                                                <div class="row">
                                                    <div class="col-12 d-flex align-items-center justify-content-between border__bottom py-3">
                                                        <div class="subtitle-2 black-text">Amount</div>
                                                        <div id="recurringAmount2" class="body-1 grey-text"></div>
                                                    </div>
                                                    <div class="col-12 d-flex align-items-center justify-content-between border__bottom py-3">
                                                        <div class="subtitle-2 black-text">Start Date</div>
                                                        <div id="recurringStartDate" class="body-1 grey-text"></div>
                                                    </div>
                                                    <div class="col-12 d-flex align-items-center justify-content-between border__bottom py-3">
                                                        <div class="subtitle-2 black-text">End Date</div>
                                                        <div id="recurringEndDate" class="body-1 grey-text"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="tab-pane fade show" id="recurringTransactionsTab" role="tabpanel" aria-labelledby="recurringTransactionsTabNav">
                                        <div class="table--paybee">
                                            <div class='text-center no-data-text' style="display: none" id="emptyRecurringTransactions">No donations yet.</div>
                                            <table id ="recurringTransactions" class="table" cellspacing="0" style="width: 100%;">
                                                <thead class="thead-light">
                                                    <tr>
                                                        <th>Date</th>
                                                        <th>Amount</th>
                                                        <th>Status</th>
                                                    </tr>
                                                </thead>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    
        <div data-html2canvas-ignore class="modal fade" id="p2pTransactionDetailsModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-md" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col-11">
                                <div class="modal-main-heading" id="p2pTransactionDetailsModalHeading"></div>                            
                            </div>
                            <div class="col-1 text-right">                                                    
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" class="black-text">&times;</span>
                                </button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div id='p2pTransactionDetailsModalSubheader' class="modal-sub-heading"></div>
                            </div>
                        </div>                    
                    </div>
                    <div id="p2pTransactionDetailsDiv" class="modal-body pt-0 custom-material-form updated-dropdown body-1 text-left">
                        
                    </div>
                    <div class="modal-footer paybee-modal-footer">
                        <div class="row">
                            <div class="col">
                                <a data-dismiss="modal" class="btn btn-sm modal-outline-button">
                                    Close
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div data-html2canvas-ignore class="modal fade" id="inKindTransactionDetailsModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-md" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col-11">
                                <div class="modal-main-heading" id="inKindTransactionDetailsModalHeading"></div>                            
                            </div>
                            <div class="col-1 text-right">                                                    
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" class="black-text">&times;</span>
                                </button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div id='inKindTransactionDetailsModalSubheader' class="modal-sub-heading"></div>
                            </div>
                        </div>                    
                    </div>
                    <div class="modal-body pt-0 custom-material-form updated-dropdown">
                        <div id="inKindTransactionDetailsName" class="body-1 text-left mb-3"></div>
                        <div id="inKindTransactionDetailsValue" class="body-1 text-left mb-3"></div>
                        
                        <div id="inKindTransactionDetailsCategoriesDiv" class="mb-3">
                            <div class="body-1 mb-2 text-left">Categories</div>
                            <div id="inKindTransactionDetailsCategoriesList" class="body-2 d-flex flex-wrap"></div>
                        </div>
                        
                        <div style="overflow-y: auto; max-height: 60vh;">
                            <div id="inKindTransactionDetailsDescriptionDiv" class="mb-3">
                                <div class="body-1 mb-2 text-left">Description</div>
                                <div id="inKindTransactionDetailsDescription" class="body-2 quill-description"></div>
                            </div>
                            
                            <div id="inKindTransactionDetailsImagesDiv" class="d-flex flex-wrap"></div>
                        </div>
                    </div>
                    <div class="modal-footer paybee-modal-footer">
                        <div class="row">
                            <div class="col">
                                <a data-dismiss="modal" class="btn btn-sm modal-outline-button">
                                    Close
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div data-html2canvas-ignore class="modal fade" id="updateDonationModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col-11">
                                <div class="modal-main-heading" id="updateDonationModalHeading"></div>                            
                            </div>
                            <div class="col-1 text-right">                                                    
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" class="black-text">&times;</span>
                                </button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div id='updateDonationModalSubHeder' class="modal-sub-heading"></div>
                            </div>
                        </div>                    
                    </div>
                    <div id="updateTransaction">
                        <div class="modal-body text-center pt-0 px-0 custom-material-form updated-dropdown">
                            <div class="row justify-content-center  mt-3"> 
                                <div class="col-5 pr-0" id="updateDonationEMailRow">
                                    <div class="md-form">
                                        <input type="text" id="updateDonationEMail" class="form-control">
                                        <label
                                            id="updateDonationEMailLabel"
                                            for="updateDonationEMail"
                                            class="inputLabel"
                                            data-error="Invalid"
                                            data-success=""
                                        >E-Mail</label>

                                        <div id='updateDonationEMailClear' type="button" class="input-clear input-clear--fix">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                                <path d="M11 1L1 11M1 1L11 11" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-6" id="updateDonationNameRow">
                                    <div class="md-form">
                                        <input type="text" id="updateDonationName" class="form-control">
                                        <label
                                            id="updateDonationNameLabel"
                                            for="updateDonationName"
                                            class="inputLabel"
                                            data-error="Invalid"
                                            data-success=""
                                        >Name</label>

                                        <div id='updateDonationNameClear' type="button" class="input-clear input-clear--fix">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                                <path d="M11 1L1 11M1 1L11 11" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
        
                            <div class="row justify-content-center" id="selectUpdateCampaign">
                                <div class="col-11 mb-4">
                                    <div class="text-left" style="color: #757575; font-size: 0.8rem;">Select Campaign</div>
                                    <fieldset class="form-group noMargin" id="selectUpdateDonationCampaignFS">
                                    </fieldset>
                                    <small id='updateDonationCampaignModalError' class='red-text' style="display: none"></small>
                                </div>
                            </div>
                            <div class="row justify-content-center" id="selectUpdateOption">
                                <div class="col-11 mb-4">
                                    <div class="text-left" style="color: #757575; font-size: 0.8rem;">Select Option</div>
                                    <fieldset class="form-group noMargin " id="selectUpdateOptionFS">
                                    </fieldset>
                                    <small id='updateDonationOptionModalError' class='red-text' style="display: none"></small>
                                </div>
                            </div>
                            <div class="row justify-content-center">
                                <div class="col-5 pr-0" id="updateDonationAmountRow">
                                    <div class="md-form">
                                        <input type="number" id="updateDonationAmount" class="form-control">
                                        <label
                                                id="updateDonationAmountLabel"
                                                for="updateDonationAmount"
                                                class="inputLabel"
                                                data-error="Invalid"
                                                data-success="">Amount</label>
                                    </div>
                                </div>
                                <div class="col-6" id="updateTicketQuantityRow">
                                    <div class="md-form">
                                        <input type="number" id="updateTicketQuantity" class="form-control">
                                        <label
                                                id="updateTicketQuantityLabel"
                                                for="updateTicketQuantity"
                                                class="inputLabel"
                                                data-error="Invalid"
                                                data-success="">Quantity</label>
                                    </div>
                                </div>
                            </div>
                            <div class="row justify-content-center">
                                <div class="col-11">
                                    <div class="md-form">
                                        <input placeholder="Donation date" type="text" id="updateDonationDate" class="form-control datepicker" style="cursor: pointer;">
                                        <label id="updateDonationDateLabel" for="updateDonationDate" class="disabled">Donation Date</label>
                                        <i class="far fa-calendar-alt calendar-icon--paybee" onclick="document.getElementById('updateDonationDate').focus()" style="cursor:pointer"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="row justify-content-center mb-3" id="accordionUpdateDonationModal" style="display: none">
                                <div class=" md-accordion md-accordion--addToCard  col-11" id="accordionExampleUpdateDonationModal">
                                    <div class="card card--guest accordion z-depth-0">
                                        <div class="card-header card-header--guest p-0 d-flex justify-content-between" id='headerUpdateDonationModal'>
                                            <button
                                                class="btn btn-link btn-link--text-decoration-none btn-link--text-transform-none collapsed d-flex align-items-center pl-0 m-0"
                                                type="button"
                                                id='header_buttonUpdateDonationModal'
                                                data-toggle="collapse"
                                                data-target="#contentUpdateDonationModal"
                                                aria-expanded="true"
                                                aria-controls="accordionUpdateDonationModal"
                                            >
                                                <i class="fas fa-angle-down rotate-icon fa-2x mr-3" style="font-size: 1.5rem;"></i>
                                                <span class="body-1--weight-medium  black-text" data-toggle="tooltip-edit-ticket" data-placement="right" title="This information is required on the donor side, but you can skip this step.">Additional information (Optional)</span>
                                            </button>
                                        </div>
                                        <div id="contentUpdateDonationModal" class="collapse"
                                            aria-labelledby="headerUpdateDonationModal"
                                            data-parent="#accordionExampleUpdateDonationModal"
                                        >
                                            <div class="card-body">
                                                <div class="row justify-content-center mb-3" id="streetAddressDivUpdateDonationModal" >
                                                    <div class="col-12">
                                                        <div class="d-flex flex-row">
                                                            <div class="md-form no-bottom-margin col-9 px-0">
                                                                <div class="position-relative black-text text-left">
                                                                    <input class="form-control input-default mb-0" type="text" placeholder="Search for address" id="streetAddressUpdateDonationModal" onfocus="this.setAttribute('autocomplete','chrome-off')">
                                                                    <button id="streetAddressCanselBtnUpdateDonationModal" type="button" class="matGoogleMapsAutocomplete-clear cansel-org-side">
                                                                        <i class="fas fa-times"></i>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            <div class="col-3 pr-0">
                                                                <div class="md-form no-bottom-margin">
                                                                    <input class="form-control mb-0" type="text" id="streetAddressUpdateDonationModalUnit">
                                                                    <label id="streetAddressUnitLabelUpdateDonationModal" class="inputLabel" for="streetAddressUpdateDonationModalUnit" data-error="Invalid" data-success="">Unit/Apt#</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row justify-content-center mb-3"  id="phoneNumDivUpdateDonationModal">
                                                    <div class="col-12">
                                                        <div class='md-form no-bottom-margin'>
                                                            <input type='text' id='phoneNumUpdateDonationModal' autocomplete='chrome-off' class='form-control validate mb-0'>
                                                            <label id="phoneNumLabelUpdateDonationModal" class='inputLabel active' for='phoneNumUpdateDonationModal' data-success=''>
                                                                Phone
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row justify-content-center mb-3" id="additionalInfoDivUpdateDonationModal"  style="display: none">
                                                    <div  class="col-12">
                                                        <div class="md-form no-bottom-margin" style="margin-bottom: 4rem">
                                                            <input
                                                                type="text"
                                                                required
                                                                id="additionalInfoTextUpdateDonationModal"
                                                                maxlength="512"
                                                                class="form-control validate mb-0">
                                                            <label
                                                                class="inputLabel"
                                                                id="additionalInfoTextLabelUpdateDonationModal"
                                                                for="additionalInfoTextUpdateDonationModal"
                                                                data-error="Invalid"
                                                                data-success="">
                                                                Additional Info
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div id="additionalInfoSelectDiv" class="col-12 p-0" style="margin-bottom: 20px">
                                                    <h6 class="text-left sectionHeading" id="additionalInfoSelectDesc"></h6>
                                                    <fieldset class="form-group noMargin" id="additionalInfoSelectList"></fieldset>
                                                    <small style="display: none" class="red-text text-left" id="additionalInfoSelectError"></small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row justify-content-center">
                                <div class="col-11">
                                    <div class="md-form">
                                        <input type="text" length="256" maxlength="256" id="donationUpdateMemo" class="form-control">
                                        <label class="inputLabel" data-error="Invalid" data-success="" id="donationUpdateMemoLabel" for="donationUpdateMemo" class="form-label">Memo</label>
                                    </div>
                                </div>
                            </div>
        
                            <div class="row justify-content-center">
                                <div class="col-11">
                                <div id="transactionUpdateError" class="red-text" style="display:none">Error</div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer paybee-modal-footer">
                            <div class="row">
                                <div class="col">
                                    <a data-dismiss="modal" class="btn btn-sm modal-cancel-button">
                                        Cancel
                                    </a>
                                    <a id="updateDonationButton" class="btn btn-sm modal-confirm-button">
                                        Update
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="updateCampaignFormData">
                        <div id="updateCampaignFormDataBody" style="max-height: calc(90vh - 100px - 75px);overflow: scroll;" class="modal-body custom-material-form updated-dropdown">
                        </div>
                        <div class="modal-footer paybee-modal-footer pt-4">
                            <a id="updateCampaignFormDataBackButton" class="btn btn-sm modal-cancel-button waves-effect waves-light">Back</a>
                            <a id="updateCampaignFormDataSubmitButton" class="btn btn-sm modal-confirm-button waves-effect waves-light">Update</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div data-html2canvas-ignore class="modal fade" id="resendReceiptModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col-11">
                                <div class="modal-main-heading" id="resendReceiptModalHeading">Resend Receipt</div>                            
                            </div>
                            <div class="col-1 text-right">                                                    
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" class="black-text">&times;</span>
                                </button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div id='resendReceiptModalSubHeader' class="modal-sub-heading"></div>
                            </div>
                        </div>                    
                    </div>
                    <div class="modal-body pb-0 custom-material-form">
                        <div class="row">
                            <div id="selectedTransactionBlock" class="col-12 text-center">
                            </div>
                            <div id="relatedTransactionsBlock" class="col-12 text-center">
                            </div>
                            <div id="allTransactionsCheckboxBlock" class="col-12 mb-2">
                                <div class="black-text custom-control custom-switch">
                                    <input type="checkbox" id="allTransactionsCheckbox" class="custom-control-input">
                                    <label for="allTransactionsCheckbox" class="custom-control-label subtitle-1">Include all transactions in this receipt.</label>
                                </div>
                            </div>
                            <div id="resendReceiptEmailBlock" class="col-12 mt-3">
                                <div class="md-form">
                                    <input type="text" id="resendReceiptEmail" class="form-control">
                                    <label id="resendReceiptEmailLabel" for="resendReceiptEmail" data-error="Invalid" data-success="" class="inputLabel">Send receipt to different email instead</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer paybee-modal-footer pt-4">
                        <a id="resendReceiptModalCancel" class="btn btn-sm modal-cancel-button waves-effect waves-light" data-dismiss="modal">Cancel</a>
                        <a id="resendReceiptModalSend" class="btn btn-sm modal-confirm-button waves-effect waves-light">Send</a>
                    </div>
                </div>
            </div>
        </div>

        <div data-html2canvas-ignore class="modal fade" id="campaignItemUpdateModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col-11">
                                <div class="modal-main-heading" id="campaignItemUpdateModalHeader"></div>                            
                            </div>
                            <div class="col-1 text-right">                                                    
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" class="black-text">&times;</span>
                                </button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div id='campaignItemUpdateModalSubbeader' class="modal-sub-heading"></div>
                            </div>
                        </div>                    
                    </div>
                    <div id="campaignItemUpdateCampaignFormDataBody" style="max-height: calc(90vh - 100px - 75px);overflow: scroll;" class="modal-body custom-material-form updated-dropdown">
                    </div>
                    <div class="modal-footer paybee-modal-footer pt-4">
                        <a id="campaignItemUpdateCampaignFormDataBackButton" class="btn btn-sm modal-cancel-button waves-effect waves-light">Cancel</a>
                        <a id="campaignItemUpdateCampaignFormDataSubmitButton" class="btn btn-sm modal-confirm-button waves-effect waves-light">Update</a>
                    </div>
                </div>
            </div>
        </div>
    
        <div data-html2canvas-ignore class="modal fade" id="updateTransactionModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col-11">
                                <div class="modal-main-heading" id="updateTransactionModalHeading">Update Transaction</div>                            
                            </div>
                            <div class="col-1 text-right">                                                    
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" class="black-text">&times;</span>
                                </button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="modal-sub-heading">Edit transaction and attributes.</div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body text-center pt-0">
                        <div class="row justify-content-center" id="updateTransactionCampaign">
                            <div class="col-11">
                                <div class="text-left" style="color: #757575; font-size: 0.8rem;">Select Campaign</div>
                                <fieldset class="form-group noMargin" id="updateTransactionCampaignFS">
                                </fieldset>
                                <small id='updateTransactionCampaignError' class='red-text' style="display: none"></small>
                            </div>
                        </div>
                        <div class="row justify-content-center" id="updateTransactionOption">
                            <div class="col-11">
                                <div class="text-left" style="color: #757575; font-size: 0.8rem;">Select Option</div>
                                <fieldset class="form-group noMargin" id="updateTransactionOptionFS">
                                </fieldset>
                                <small id='updateTransactionOptionError' class='red-text' style="display: none"></small>
                            </div>
                        </div>
    
                        <div class="row justify-content-center" id="updateTransactionAmount">
                            <div class="col-11">
                                <div class="md-form">
                                    <input type="number" id="updateTransactionAmountField" class="form-control">
                                    <label
                                            id="updateTransactionAmountLabel"
                                            for="updateTransactionAmountField"
                                            class="inputLabel"
                                            data-error="Invalid"
                                            data-success="">Amount</label>
                                </div>
                            </div>
                        </div>
                        <div class="row justify-content-center" id="updateTransactionQuantity">
                            <div class="col-11">
                                <div class="md-form">
                                    <input type="number" id="updateTransactionQuantityField" class="form-control">
                                    <label
                                            id="updateTransactionQuantityLabel"
                                            for="updateTransactionQuantityField"
                                            class="inputLabel"
                                            data-error="Invalid"
                                            data-success="">Quantity</label>
                                </div>
                            </div>
                        </div>
    
                        <div class="row justify-content-center" id="updateTransactionInfo">
                            <div class="col-11">
                                <div class="md-form">
                                    <input type="text" length="512" maxlength="512" id="updateTransactionInfoField" class="form-control">
                                    <label class="inputLabel" data-error="Invalid" data-success="" id="updateTransactionInfoLabel" for="updateTransactionInfoField" class="form-label">Additional Info</label>
                                </div>
                            </div>
                        </div>
    
                        <div class="row justify-content-center" id="updateTransactionInfoSelect">
                            <div class="col-11">
                                <div class="text-left" style="color: #757575; font-size: 0.8rem;" id="updateTransactionInfoSelectLabel">Select One</div>
                                <fieldset class="form-group noMargin" id="updateTransactionInfoSelectFS">
                                </fieldset>
                                <small id='updateTransactionInfoSelectError' class='red-text' style="display: none"></small>
                            </div>
                        </div>
    
                        <div class="row justify-content-center">
                            <div class="col-11">
                                <div class="md-form">
                                    <input type="text" length="256" maxlength="256" id="updateTransactionMemoField" class="form-control">
                                    <label class="inputLabel" data-error="Invalid" data-success="" id="updateTransactionMemoLabel" for="updateTransactionMemoField" class="form-label">Memo</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer paybee-modal-footer">
                        <div class="row">
                            <div class="col">
                                <a data-dismiss="modal" class="btn btn-sm modal-cancel-button">
                                    Cancel
                                </a>
                                <a id="updateTransactionButton" class="btn btn-sm modal-confirm-button">
                                    Update
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    
        <div data-html2canvas-ignore class="modal fade" id="offlineDonationResolveModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col-11">
                                <div class="modal-main-heading" id="resolveModalHeading">Resolve Donation</div>                            
                            </div>
                            <div class="col-1 text-right">                                                    
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" class="black-text">&times;</span>
                                </button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="modal-sub-heading">Update the data to resolve the issue.</div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body text-center">
                        <div class="row justify-content-center" id="selectUser">
                            <div class="col-8">
                                <div class="text-left" style="color: #757575; font-size: 0.8rem;">Select User</div>
                                <fieldset class="form-group noMargin" style="margin-bottom: 2rem;" id="selectUserFS">
                                </fieldset>
                                <small id='offlineUserModalError' class='red-text' style="display: none"></small>
                            </div>
                        </div>
                        <div class="row justify-content-center" id="offlineResolveAddDonor">
                            <div class="col-8">
                                <form onsubmit="return false">
                                    <div class="md-form" style="margin-bottom: 2rem;">
                                        <input
                                                type="text"
                                                id="offlineResolveName"
                                                autocomplete='name'
                                                required
                                                class="form-control validate">
                                        <label
                                                id="offlineResolveNameLabel"
                                                class="inputLabel"
                                                for="offlineResolveName"
                                                data-error="Invalid"
                                                data-success="">Donor Name</label>
                                    </div>
                                    <div class="md-form" style="margin-bottom: 2rem;">
                                        <input
                                                type="email"
                                                id="offlineResolveEmail"
                                                autocomplete='email'
                                                required
                                                class="form-control validate">
                                        <label
                                                id="offlineResolveEmailLabel"
                                                class="inputLabel"
                                                for="offlineResolveEmail"
                                                data-error="Invalid"
                                                data-success="">Donor Email</label>
                                    </div>
                                    <h5>Or</h5>
                                    <div id="streetAddressResolveDiv">
                                        <h6 class="text-left sectionHeading" style="color: black">Donor Street Address</h6>
                                        <div class="md-form">
                                            <input onfocus="this.setAttribute('autocomplete','chrome-off')" name="randomnocomplete" class="form-control" type="text" placeholder="Search for address" id="offlineResolveStreetAddress">
                                        </div>
    
                                        <div class="row">
                                            <div class="col-md-8 col-md-10">
                                                <div class="md-form">
                                                    <input class="form-control" type="text" id="offlineResolveStreetAddressUnit">
                                                    <label id="offlineResolveStreetAddressUnitLabel"
                                                           class="inputLabel"
                                                           for="offlineResolveStreetAddressUnit"
                                                           data-error="Invalid"
                                                           data-success="">Unit/Apartment# (optional)</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col">
                                                <small class="red-text" id="addressResolveError"></small>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
    
                        <div class="row justify-content-center" id="selectCampaign">
                            <div class="col-8">
                                <div class="text-left" style="color: #757575; font-size: 0.8rem;">Select Campaign</div>
                                <fieldset class="form-group noMargin caret-up" style="margin-bottom: 2rem;" id="selectCampaignFS">
                                </fieldset>
                                <small id='offlineCampaignModalError' class='red-text' style="display: none"></small>
                            </div>
                        </div>
                        <div class="row justify-content-center" id="selectOption">
                            <div class="col-8">
                                <div class="text-left" style="color: #757575; font-size: 0.8rem;">Select Option</div>
                                <fieldset class="form-group noMargin caret-up" style="margin-bottom: 2rem;" id="selectOptionFS">
                                </fieldset>
                                <small id='offlineOptionModalError' class='red-text' style="display: none"></small>
                            </div>
                        </div>
    
                        <div class="row justify-content-center" id="offlineResolveAmountRow">
                            <div class="col-8">
                                <div class="md-form">
                                    <input type="number" id="offlineResolveAmount" class="form-control">
                                    <label
                                        id="offlineResolveAmountLabel"
                                        for="offlineResolveAmount"
                                        class="inputLabel"
                                        data-error="Invalid"
                                        data-success="">Amount</label>
                                </div>
                            </div>
                        </div>
    
                        <div id="otherOfflineAttribute">
                            <div class="row justify-content-center">
                                <div class="col-8">
                                    <div class="md-form">
                                        <input placeholder="Donation date" type="text" id="editOfflineDonationDate" class="form-control datepicker">
                                        <label id="editOfflineDonationDateLabel" for="editOfflineDonationDate">Donation Date</label>
                                    </div>
                                </div>
                            </div>
                            <div class="row justify-content-center">
                                <div class="col-8">
                                    <div class="md-form">
                                        <input type="text" length="256" maxlength="256" id="editMemoOffline" class="form-control">
                                        <label id="editMemoOfflineLabel" for="editMemoOffline" class="form-label">Memo (optional)</label>
                                    </div>
                                </div>
                            </div>
                            <div class="row justify-content-center">
                                <div class="col-8 text-left">
                                    <fieldset class="form-group noMargin" id="editSelectDonationType" style="margin-bottom: 2rem;">
                                        <select id="editDonationType" class="mdb-select noMargin mdb-select--paybee validate">
                                            <option value="0" selected>Donation</option>
                                            <option value="1">Corp Matching</option>
                                            <option value="2">Charitable Trust Donation</option>
                                        </select>
                                    </fieldset>
                                </div>
                            </div>
                            <div class="row justify-content-center" id="editOfflineMatchingCompanyRow">
                                <div class="col-8">
                                    <div class="md-form">
                                        <input type="text" length="256" maxlength="256" id="editOfflineMatchingCompany" class="form-control">
                                        <label id="editOfflineMatchingCompanyLabel" for="editOfflineMatchingCompany" class="form-label">Matching Company Name (optional)</label>
                                    </div>
                                </div>
                            </div>
                            <div class="row justify-content-center">
                                <div class="col-8 text-left">
                                    <fieldset class="form-group noMargin caret-up" id="editSelectDonationBy" style="margin-bottom: 2rem;">
                                        <div class="text-left" style="color: #757575; font-size: 0.8rem;">Donation By</div>
                                        <select id="editDonationBy" class="mdb-select noMargin mdb-select--paybee validate">
                                            <option value="0" selected>Check</option>
                                            <option value="1">Cash</option>
                                            <option value="2">Other</option>
                                            <option value="3">In Kind</option>
                                            <option value="4">Stock</option>
                                        </select>
                                    </fieldset>
                                </div>
                            </div>
                            <div class="row justify-content-center" id="editOfflineInKindItemRow">
                                <div class="col-8">
                                    <div class="md-form">
                                        <input type="text" length="256" maxlength="256" id="editOfflineInKindItem" class="form-control">
                                        <label id="editOfflineInKindItemLabel" for="editOfflineInKindItem" class="form-label">InKind Donation Item (optional)</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row justify-content-center" style="margin-top: 2rem">
                            <div class="col-8">
                                <a id="offlineResolveButton" class="btn btn-success">Resolve</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    
        <div data-html2canvas-ignore class="modal fade" id="guestInfoAddModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-notify modal-info" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <p class="heading lead">Add Guest Info</p>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true" class="white-text">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" >
                        <div class="row">
                        <div class="col form-group">
                            <input type="checkbox" class="form-check-input filled-in" id="guestInfoRequired">
                            <label class="form-check-label" for="guestInfoRequired">Required Info</label>
                        </div>
    
                        <div class="col form-group">
                            <input type="checkbox" class="form-check-input filled-in" id="guestInfoAddedByAdmin">
                            <label class="form-check-label" for="guestInfoAddedByAdmin">To be added by admin</label>
                        </div>
                        </div>
                        <div class="md-form form-sm inputCustom">
                            <input
                                    type="text"
                                    id="guestInfoName"
                                    class="form-control
                                        validate">
                            <label
                                    class="inputLabel"
                                    id="guestInfoNameLabel"
                                    data-error="invalid"
                                    data-success=""
                                    for="guestInfoName">
                                Name
                            </label>
                        </div>
                        <fieldset class="form-group noMargin" style="margin-bottom: 2rem;">
                            <div class="text-left" style="color: #757575; font-size: 0.8rem;">Type</div>
                            <select id="guestInfoType" class="mdb-select noMargin validate">
                                <option value="1">Text -- Free from text</option>
                                <option value="2">Selection - To be selected from options</option>
                                <option value="3">Street Address</option>
                                <option value="4">Phone Number</option>
                            </select>
                        </fieldset>
                        <div id="guestSelectionOptions">
                            <p class="mb-4">Type a option and press enter to add. Click <strong>X</strong> to remove it.</p>
                            <div id="guestInfoSelectChips" class="chips"></div>
                            <small class="red-text" id="selectOptionError" style="display: none"> </small>
                        </div>
                    </div>
                    <div class="modal-footer justify-content-center">
                        <a id="addGuestInfoBtn" class="btn btn-sm btn-info">Add</a>
                    </div>
                </div>
            </div>
        </div>
    
        <div data-html2canvas-ignore class="modal fade" id="guestAssignPaddleModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col-11">
                                <div class="modal-main-heading" id="assignPaddleUserName"></div>
                            </div>
                            <div class="col-1">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" class="black-text">×</span>
                                </button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="modal-sub-heading">Assign paddle and table for current attendee.</div>
                            </div>
                        </div>  
                    </div>
                    <div class="modal-body custom-material-form">
                        <div class="row">
                            <div class="col">
                                <div class="md-form" style="margin-top: 20px">
                                    <input
                                            type="number"
                                            id="assignPaddleNum"
                                            required
                                            class="form-control validate">
                                    <label
                                            id="assignPaddleNumLabel"
                                            class="inputLabel"
                                            for="assignPaddleNum"
                                            data-error="Invalid"
                                            data-success="">
                                        Paddle Number
                                    </label>
                                </div>
                                <div class="caption blue-text mt-n3 mb-4" id="guestAttendeeAssignNextPaddleNumberBlock">
                                    <span class="cursor--pointer" id="guestRemovePaddleNumber">Remove Paddle</span>
                                    <span class="cursor--pointer" id="guestAssignNextPaddleNumber">Get Next Available Paddle Number</span>
                                </div>
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col">
                                <div class="text-left" style="color: #757575; font-size: 0.8rem;">Select Table</div>
                                <select id="assignTable" class="select-wrapper mdb-select mdb-select--paybee validate"></select>
                                <span id="assignTableInfo" style="display: none;" class="grey-text body-2">Create a table and then assign it to the attendee.</span>
                            </div>
                        </div>
                        <div class="row" id="selectSeatRow">
                            <div class="col">
                                <div class="text-left" style="color: #757575; font-size: 0.8rem;">Select Seat</div>
                                <select id="assignTableSeat" class="select-wrapper mdb-select mdb-select--paybee validate">
                                </select>
                                <span id="guestAssignPaddleModalSeatError" class="red-text body-3 ">Please select seat</span>

                            </div>
                        </div>
                    </div>
                    <div class="modal-footer paybee-modal-footer">
                        <a class="btn btn-sm modal-cancel-button waves-effect waves-light" data-dismiss="modal">Cancel</a>
                        <a id="assignPaddleTableBtn" class="btn btn-sm modal-confirm-button waves-effect waves-light">Assign</a>
                    </div>
                </div>
            </div>
        </div>
    

        <div data-html2canvas-ignore class="modal fade" id="updateEmailOrCard" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col-11">
                                <div class="modal-main-heading">Update email</div>
                            </div>
                            <div class="col-1">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" class="black-text">×</span>
                                </button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="modal-sub-heading">Update your email or unite cards if we have card with this email</div>
                            </div>
                        </div>
                        
                    </div>
                    <div class="modal-body">
                        <div class="row justify-content-center" id="updateEmail">
                            <div class="col-10">
                                <div class="md-form">
                                    <input  type="email" id="updateEmailinput" class="form-control validate">
                                    <label id="updateEmailLabel" class="inputLabel" for="updateEmailinput">
                                        Email
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col text-center">
                            <div class="small red-text" id="addToCartModalError"></div>
                        </div>
                    </div>
                    <div class="modal-footer paybee-modal-footer">
                        <a id="updateEmailOrCardModalCancelButton" class="btn btn-sm modal-cancel-button waves-effect waves-light" data-dismiss="modal">Cancel</a>
                        <a id="updateEmailOrCardModalButton" class="btn btn-sm modal-confirm-button waves-effect waves-light">Update email</a>
                    </div>
                </div>
            </div>
        </div>
        <div data-html2canvas-ignore class="modal fade" id="updateOrNot" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col-11">
                                <div class="modal-main-heading">We have user with this Email. Do you want to merge cards?</div>
                            </div>
                            <div class="col-1">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" class="black-text">×</span>
                                </button>
                            </div>
                        </div>                  
                    </div>
                    <div class="modal-body">
                    </div>
                    <div class="row">
                        <div class="col text-center">
                            <div class="small red-text" id="addToCartModalError"></div>
                        </div>
                    </div>
                    <div class="modal-footer paybee-modal-footer">
                        <a id="updateEmailOrCardModalCancelButton" class="btn btn-sm modal-cancel-button waves-effect waves-light" data-dismiss="modal">Cancel</a>
                        <a id="updateEmailOrCardModalButton" class="btn btn-sm modal-confirm-button waves-effect waves-light">Confirm</a>
                    </div>
                </div>
            </div>
        </div>
    
        <div data-html2canvas-ignore class="modal fade" id="addCampaigns" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog paybee-modal-dialog-750" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col-11">
                                <div class="modal-main-heading">Add Campaigns</div>
                            </div>
                            <div class="col-1">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" class="black-text">×</span>
                                </button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="modal-sub-heading">Add Campaigns to the event. All campaigns are added by default.</div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body">
                        <div class="col-12">
                            <div class="text-left" style="color: #757575; font-size: 0.8rem;">Select Campaigns</div>
                            <fieldset class="form-group noMargin caret-up mb-3" id="eventCampaignSelectFS">
                            </fieldset>
                            <div id="eventSelectedCampaigns"></div>
                        </div>
                    </div>
                    <div class="modal-footer paybee-modal-footer">
                        <a class="btn btn-sm modal-cancel-button waves-effect waves-light" data-dismiss="modal">Cancel</a>
                        <a id="eventCampaignSelectBtn2" class="btn btn-sm modal-confirm-button waves-effect waves-light">Select</a>
                    </div>
                </div>
            </div>
        </div>
    
        <div data-html2canvas-ignore class="modal fade" id="addAttendee"guestAssignPaddleModal tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col-11">
                                <div class="modal-main-heading">Add Attendee</div>
                            </div>
                            <div class="col-1">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" class="black-text">×</span>
                                </button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="modal-sub-heading">Add attendee to the event and assign paddle and Table.</div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body custom-material-form">
                        <div class="col-12" style="padding-bottom: 2rem;">
                            <div class="row">
                                <div class="col">
                                    <div class="row">
                                        <div class="col">
                                            <div class="autocomplete">
                                                <input id="eventDonorSearch" autocomplete="off" style="width:100%" type="search" placeholder="Enter email to search">
                                                <span id="eventSearchClear" style="bottom: 8px;color: rgba(0, 0, 0, .54);cursor: pointer;display: -webkit-box;position: absolute;right: 0;width: 24px;">
                                                    X
                                                    </span>
                                            </div>
                                            <small class="red-text" style="display: none" id="eventAddDonorEmailError"></small>
                                        </div>
                                    </div>
                                </div>
                            </div>
    
                            <div class="row">
                                <div class="col mt-4">
                                    <div class="md-form" style="margin-top: 20px">
                                        <input
                                                type="text"
                                                id="eventDonorName"
                                                required
                                                class="form-control validate">
                                        <label
                                                id="eventDonorNameLabel"
                                                class="inputLabel"
                                                for="eventDonorName"
                                                data-error="Invalid"
                                                data-success="">
                                            Name
                                        </label>
                                    </div>
                                </div>
                            </div>
    
                            <div class="row">
                                <div class="col">
                                    <div class="md-form" style="margin-top: 20px">
                                        <input
                                                type="number"
                                                id="paddleNum"
                                                required
                                                class="form-control validate">
                                        <label
                                                id="paddleNumLabel"
                                                class="inputLabel"
                                                for="paddleNum"
                                                data-error="Invalid"
                                                data-success="">
                                            Paddle Number
                                        </label>
                                    </div>
                                    <div class="caption blue-text mt-n3 mb-4" id="attendeeAssignNextPaddleNumberBlock">
                                        <span class="cursor--pointer" id="attendeeAssignNextPaddleNumber">Get Next Available Paddle Number</span>
                                    </div>
                                </div>
                            </div>
    
                            <div class="row">
                                <div class="col">
                                    <div class="text-left" style="color: #757575; font-size: 0.8rem;">Select Table</div>
                                    <select id="assignTableAddAttendee" class="select-wrapper mdb-select mdb-select--paybee validate">
                                    </select>
                                    <span id="assignTableAddAttendeeInfo" style="display: none;" class="grey-text body-2">Create a table and then assign it to the attendee.</span>
                                </div>
                            </div>
                            <div class="row" id="addAttendeeSeatRow">
                                <div class="col">
                                    <div class="text-left" style="color: #757575; font-size: 0.8rem;">Select Seat</div>
                                    <select id="addAttendeeTableSeat" class="select-wrapper mdb-select mdb-select--paybee validate">
                                    </select>
                                    <span id="addAttendeePaddleModalSeatError" class="red-text body-3 ">Please select seat</span>
                                </div>
                            </div>
    
                            <small class="red-text" style="display: none" id="eventAddDonorError"></small>
                        </div>
                    </div>
                    <div class="modal-footer paybee-modal-footer">
                        <a class="btn btn-sm modal-cancel-button waves-effect waves-light" data-dismiss="modal">Cancel</a>
                        <a id="assignPaddleToDonor" class="btn btn-sm modal-confirm-button waves-effect waves-light">Assign</a>
                    </div>
                </div>
            </div>
        </div>

        <div data-html2canvas-ignore class="modal fade" id="addPaddle" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col-11">
                                <div class="modal-main-heading">Add Pledges</div>
                            </div>
                            <div class="col-1">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" class="black-text">×</span>
                                </button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="modal-sub-heading">Add multiple pledges to donor carts.</div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body custom-material-form" style="padding-right: 70px; padding-bottom: 40px;">
                        <div id="addPaddleModalCampaignBlock" class="row justify-content-center row-custom mb-4" >
                            <div class="col-10 text-left">
                                <div class="text-left" style="color: #757575; font-size: 0.8rem;">Select Campaign</div>
                                <fieldset id="addPaddleModalCampaignFS" class="form-group noMargin">
                                </fieldset>
                                <small class="red-text" id="addPaddleModalCampaignSelectError"></small>
                            </div>
                        </div>
                        <div id="addPaddleModalOptionBlock" class="row justify-content-center row-custom mb-4">
                            <div class="col-10 text-left">
                                <div class="text-left" style="color: #757575; font-size: 0.8rem;">Select Option</div>
                                <fieldset id="addPaddleModalOptionFS" class="form-group noMargin">
                                </fieldset>
                                <small class="red-text" id="addPaddleOptionSelectError"></small>
                            </div>
                        </div>
                        <div class="row justify-content-center row-custom " id="addPaddleModalQuantityBlock">
                            <div class="col-10">
                                <div class="md-form" style="margin-bottom: 0!important;">
                                    <input min="1" step="1" type="number" id="addPaddleModalOptionQuantity" class="form-control validate mb-3">
                                    <label id="addPaddleModalOptionQuantityLabel" class="inputLabel" data-error="Invalid Quantity" data-success="" for="addPaddleModalOptionQuantity">
                                      Enter Quantity
                                    </label>
                                </div>
                            </div>
                        </div> 
                        <div id='paddleListBlock' class="row justify-content-center row-custom  mb-4" >
                            <div class="col-10 text-left">
                                <div class="text-left" style="color: #757575; font-size: 0.8rem;">Added Paddles</div>
                                <ul id="paddleList" class="w-100 p-0 list-group overflow-auto paddle-list-paybee">
                                </ul>
                            </div>
                        </div>
                        <div class="row justify-content-center row-custom " id="addPaddleModalAmountRow">
                            <div class="col-10">
                                <div class="md-form">
                                    <input min="1" step="0.01" type="number" id="addPaddleModalOptionAmount" class="form-control validate" style="margin-bottom: 25px;">
                                    <label id="addPaddleModalOptionAmountLabel" class="inputLabel" data-error="Invalid Amount" data-success="" for="addPaddleModalOptionAmount">
                                       Enter Amount
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="row justify-content-center row-custom" id="addPaddleNumberRow" style="margin-right: -120px;">
                            <div class="col-10 d-flex align-items-center pl-1">
                                <div class="md-form w-100 mr-4" style="margin-bottom: 0!important;">
                                    <input min="1" step="1" type="number" id="addPaddleModalPaddleNum" class="form-control validate mb-0">
                                    <label id="addPaddleModalPaddleNumLabel" class="inputLabel" data-error="Invalid Paddle" data-success="" for="addPaddleModalPaddleNum">
                                        Enter Paddle
                                    </label>
                                </div>
                                <a id="addPaddleNumButton" class="btn btn-sm modal-confirm-button waves-effect waves-light modal-confirm-button-small">Add </a>
                            </div>
                        </div>
                        <small class="red-text" id="addPaddleItemError"></small>
    
                    </div>
                </div>
            </div>
        </div>
    
        <div data-html2canvas-ignore class="modal fade" id="attendeeCartDetailModal"  tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content paybee-modal-content paybee-modal-content-attendeeCartDetailModal">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col-11">
                                <div class="modal-main-heading" id="attendeeName"></div>
                            </div>
                            <div class="col-1">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" class="black-text">×</span>
                                </button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="modal-sub-heading" id="attendeeCartDetailSubHeader">Current pending pledges</div>
                            </div>
                        </div>
                    </div>
                    <div id="cartInfo" style="padding: 0 10px;">
                        <div class="modal-body custom-material-form updated-dropdown" style="max-height: 65vh; overflow:scroll">
                            <div class="row mb-2">
                                <div class="col-3 pr-0 d-flex flex-column justify-content-center">
                                    <div class="d-flex align-items-center memo">
                                      <p class="mb-0 mr-1">Memo:</p>
                                      <span id="cartMemoText" class="text-truncate mr-2" style="max-width: 150px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; color: #616161;">
                                        [None]
                                      </span>
                                      <i id="editCartMemoButton" class="black-text fas fa-pencil-alt mt-0 mr-2" style="cursor: pointer;"></i>
                                    </div>
                                  </div>
                                <div class="col-9 d-flex justify-content-end" id="bodyButtonsBlock" >
                                    <a id="addToCartButton" class="btn btn-sm modal-outline-button waves-effect waves-light"><i class="fas fa-plus mr-2"></i>Add More</a>
                                    <span                    
                                        data-toggle="popover-hover-modal"
                                        data-trigger="hover"
                                        data-placement="left"
                                        title='Move all items from cart or change email for cart.'
                                        id="updateCartElementWrapper"
                                        
                                        class="ml-2"
                                    >
                                    <a id="moveCartButton" class="btn btn-sm modal-outline-button waves-effect waves-light">
                                        <i class="fa fa-clone mr-2"></i>
                                        Move Entire Cart
                                    </a>
                                    </span>
                                    <a 
                                        id="cartReminderButton" 
                                        class="btn btn-sm modal-outline-button waves-effect waves-light ml-2"
                                        data-toggle="popover-hover-modal"
                                        data-trigger="hover"
                                        data-placement="left"
                                        title='Send a payment reminder for all items in this cart.'
                                    >
                                        <i class="fas fa-paper-plane mr-2"></i>
                                        Send Cart Reminder...
                                    </a>
                                </div>
                            </div>
                            <table class="table table-sm table--paybee">
                                <thead id="cartColumnList" style="background-color: #F8F9FC">
                                <tr>
                                    <th scope="col"></th>
                                    <th scope="col">#</th>
                                    <th scope="col">Campaign</th>
                                    <th scope="col">Option</th>
                                    <th scope="col">Date</th>
                                    <th scope="col">Amount</th>
                                    <th scope="col">AddedBy</th>
                                    <th scope="col"></th>
                                </tr>
                                </thead>
                                <tbody id="cartList">
                                </tbody>
                            </table>
                        </div>
                        <div class="modal-footer paybee-modal-footer pt-4" id="attendeeModalFooter" style="margin: 0 -10px;">
                            <span id="cartSelectedItems" class="body-2 mr-3">Selected Items</span>
                            <a id="cartShowCheckoutButton" class="btn btn-sm modal-success-button modal-outline-button-new waves-effect waves-light mr-2">Checkout</a>
                        </div>
                        <div class="modal-footer paybee-modal-footer pt-4" id="attendeeReopenModalFooter" style="display: none;margin: 0 -10px;">
                            <a id="attendeeModalCloseButton"class="btn btn-sm modal-outline-button modal-outline-button-new waves-effect waves-light">Close</a>
                        </div>
                    </div>
                    <div id="cartUpdateInfo" style="display: none">
                        <div class="modal-body custom-material-form" style="max-height: 65vh; overflow:scroll">
                            <div class="row mb-2">
                                <div class="col copyCartToInfo d-flex flex-column">
                                    <div id="copyToDonorSubtitle" class="m-0 text-danger"></div>
                                    <p class="m-0 text-danger"> Confirming this move would merge all the items below into the same cart.</p>
    
                                </div>
                            </div>
                            <table class="table table-sm table--paybee">
                                <thead id="cartColumnListUpdateCart" style="background-color: #FFF4F5">
                                <tr>
                                    <th scope="col">#</th>
                                    <th scope="col">Campaign</th>
                                    <th scope="col">Option</th>
                                    <th scope="col">Date</th>
                                    <th scope="col">Amount</th>
                                </tr>
                                </thead>
                                <tbody id="cartListUpdateCart">
                                </tbody>
                            </table>
                        </div>
                        <div class="modal-footer paybee-modal-footer">
                            <a id="cartCancelButton" class="btn btn-sm modal-outline-button modal-outline-button-new waves-effect waves-light">Cancel</a>
                            <a id="cartApproveButton" class="btn btn-sm modal-success-button waves-effect waves-light">Confirm</a>
                        </div>
                    </div>
    
                    <div id="checkoutCart" style="display: none">
                        <div class="modal-body custom-material-form">
                            <div class="row justify-content-center" style="margin-bottom: 1.5rem;">
                                <div class="col-10 text-center">
                                    <h4 class="purple-text">Amount: <span id="cartCheckoutAmount"></span></h4>
                                </div>
                            </div>
                            <div class="row justify-content-center">
                                <div class="col-10 text-left">
                                    <div class="text-left" style="color: #757575; font-size: 0.8rem;">Donation Method</div>
                                    <fieldset id="selectCheckoutCartMethodFS" class="form-group noMargin" style="margin-bottom: 1rem;">
                                    </fieldset>
                                    <small class="red-text" id="selectCheckoutCartMethodError"></small>
                                </div>
                            </div>
                            <div class="row justify-content-center" id="feesPaidByDonorBlock">
                                <div class="col-10 text-left">
                                    <div class="form-check md-form pl-0">
                                        <input type="checkbox" class="form-check-input filled-in" id="feesPaidByDonor">
                                        <label  class="form-check-label" for="feesPaidByDonor">Transaction Fee Covered By Donor.</label>
                                    </div>
                                </div>
                            </div>
                            <div class="row justify-content-center" >
                                <div class="col-10">
                                    <div class="md-form">
                                        <input type="text" length="128" maxlength="128" id="memoCartCheckout" class="form-control">
                                        <label id="memoCartCheckoutLabel" for="memoCartCheckout" class="form-label">Memo (optional)</label>
                                    </div>
                                </div>
                            </div>
                            <div class="row justify-content-center" >
                                <div class="col-10">
                                    <div class="form-check md-form pl-0">
                                        <input type="checkbox" class="form-check-input filled-in" id="sendNotifyCartCheckout" checked>
                                        <label  class="form-check-label" for="sendNotifyCartCheckout">Send donor acknowledgement.</label>
                                    </div>
                                </div>
                            </div>
                            <div class="row justify-content-center">
                                <div class="col-12 text-center" id="checkoutCartError"></div>
                            </div>
                        </div>
                        <div class="modal-footer paybee-modal-footer pt-4">
                            <a id="cartCheckoutCancelButton" class="btn btn-sm modal-cancel-button waves-effect waves-light">Cancel</a>
                            <a id="cartCheckoutButton" class="btn btn-sm modal-confirm-button waves-effect waves-light">Submit</a>
                        </div>
                    </div>
                    <div id="addToCart" style="display: none">
                        <div class="modal-body px-0 custom-material-form updated-dropdown">
                            <div class="row justify-content-center" id="addToCardFieldSetRow">
                                <div class="col-11 text-left">
                                    <div class="text-left" style="color: #757575; font-size: 0.8rem;">Select Campaign</div>
                                    <fieldset id="addToCartCampaignFS" class="form-group noMargin" style="margin-bottom: 1rem;">
                                    </fieldset>
                                    <small class="red-text" id="addToCartCampaignSelectError"></small>
                                </div>
                            </div>
                            <div id="addToCartOptionBlock" class="row justify-content-center mb-3" style="display: none">
                                <div class="col-11 text-left">
                                    <div class="text-left" style="color: #757575; font-size: 0.8rem;">Select Option</div>
                                    <fieldset id="addToCartOptionFS" class="form-group noMargin form-group-addToCartOptionFS--disabled" style="margin-bottom: 1rem;">
                                    </fieldset>
                                    <small class="red-text" id="addToCartOptionSelectError"></small>
                                </div>
                            </div>
                            <div class="row justify-content-center" id="addToCartAmountRow">
                                <div class="col-11">
                                    <div class="md-form">
                                        <input type="text" pattern="^\$\d{1,3}(,\d{3})*(\.\d+)?$" data-type="currency" min="1" step="0.01" id="addToCartOptionAmount" class="form-control validate">
                                        <label id="addToCartOptionAmountLabel" class="inputLabel" data-error="Invalid Amount" data-success="" for="addToCartOptionAmount">
                                            Amount
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="row justify-content-center mb-3" id="addToCartQuantityBlock">
                                <div class="col-11">
                                    <div class="md-form no-bottom-margin">
                                        <input min="1" step="0.01" type="number" id="addToCartOptionQuantity" class="form-control validate mb-0">
                                        <label id="addToCartOptionQuantityLabel" class="inputLabel" data-error="Invalid Quantity" data-success="" for="addToCartOptionQuantity">
                                            Quantity
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="row justify-content-center mb-3" id="accordionBlock" style="display: none">
                                <div class=" md-accordion md-accordion--addToCard  col-11" id="accordionExample">
                                    <div class="card accordion card--guest z-depth-0">
                                        <div class="card-header card-header--guest p-0 d-flex justify-content-between" id='header'>
                                            <button
                                                class="btn btn-link btn-link--text-decoration-none btn-link--text-transform-none collapsed d-flex align-items-center pl-0 m-0"
                                                type="button"
                                                id='header_button'
                                                data-toggle="collapse"
                                                data-target="#content"
                                                aria-expanded="true"
                                                aria-controls="accordionAtendeeCartDetailModal"
                                            >
                                                <i class="fas fa-angle-down rotate-icon fa-2x mr-3" style="font-size: 1.5rem;"></i>
                                                <span class="body-1--weight-medium  black-text" data-toggle="tooltip-add-to-cart" data-placement="right" title="This information is required on the donor side, but you can skip this step.">Additional information (Optional)</span>
                                            </button>
                                        </div>
                                        <div id="content" class="collapse"
                                            aria-labelledby="header"
                                            data-parent="#accordionExample"
                                        >
                                            <div class="card-body">
                                                <div id="streetAddressDivAttendeeCartDetailModal"  class="row justify-content-center mb-3" style="display: none">
                                                    <div class="col-12" >
                                                        <div class="row">
                                                            <div class="md-form no-bottom-margin col-9 pr-0">
                                                                <input class="form-control input-default mb-0" type="text" placeholder="Search for address" id="streetAddressAttendeeCartDetailModal" onfocus="this.setAttribute('autocomplete','chrome-off')">
                                                                <button id="streetAddressCanselBtnAttendeeCartDetailModal" type="button" class="matGoogleMapsAutocomplete-clear cansel-org-side">
                                                                    <i class="fas fa-times"></i>
                                                                </button>
                                                            </div>
                                                            <div class="col-3">
                                                                <div class="md-form no-bottom-margin">
                                                                    <input class="form-control mb-0" type="text" id="streetAddressAttendeeCartDetailModalUnit">
                                                                    <label id="streetAddressUnitLabelAttendeeCartDetailModal" class="inputLabel" for="streetAddressAttendeeCartDetailModalUnit" data-error="Invalid" data-success="">Unit/Apt#</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div  id="phoneNumDivAttendeeCartDetailModal" class="row justify-content-center mb-3"   style="display: none">
                                                    <div class="col-12">
                                                        <div class='md-form no-bottom-margin'>
                                                            <input type='text' id='phoneNumAttendeeCartDetailModal' autocomplete='chrome-off' class='form-control validate mb-0'>
                                                            <label id="phoneNumLabelAttendeeCartDetailModal" class='inputLabel active' for='phoneNumAttendeeCartDetailModal' data-success=''>
                                                                Phone
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row justify-content-center mb-3" id="additionalInfoDivAttendeeCartDetailModal"  style="display: none">
                                                    <div  class="col-12">
                                                        <div class="md-form no-bottom-margin" style="margin-bottom: 4rem">
                                                            <input
                                                                type="text"
                                                                required
                                                                id="additionalInfoTextAttendeeCartDetailModal"
                                                                maxlength="512"
                                                                class="form-control validate mb-0">
                                                            <label
                                                                class="inputLabel"
                                                                id="additionalInfoTextLabelAttendeeCartDetailModal"
                                                                for="additionalInfoTextAttendeeCartDetailModal"
                                                                data-error="Invalid"
                                                                data-success="">
                                                                Additional Info
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row justify-content-center" id="additionalInfoSelectDiv"  style="display: none">
                                                    <div  class="col-12" style="margin-bottom: 20px">
                                                        <h6 class="text-left " id="additionalInfoSelectDesc"></h6>
                                                        <fieldset class="form-group noMargin" id="additionalInfoSelectList"></fieldset>
                                                        <small style="display: none" class="red-text text-left" id="additionalInfoSelectError"></small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="addToCartEventBlock" class="row justify-content-center">
                                <div class="mb-3 col-11 text-left">
                                    <div class="text-left" style="color: #757575; font-size: 0.8rem;">Tag To Event (Optional)</div>
                                    <select id='selectEventTypeReportCampaign' class='select-wrapper mdb-select mdb-select--paybee'>
                                        <option value="-1" selected disabled>Select Event Type</option>
                                        <option id="isTicketingForVirtualEventReportCampaign" value="1">Virtual</option>
                                        <option id="isTicketingForInPersonEventReportCampaign" value="0">In-Person</option>
                                    </select>
                                    <div class='text-left red-text small' id='selectEventTypeError'></div>
                                </div>
                                <div class="col-11 text-left" >
                                    <div id="addToCartEventSelectBlock">
                                        <div class="text-left" style="color: #757575; font-size: 0.8rem;" >Select Event</div>
                                        <fieldset id="addToCartEventReportFS" class="form-group noMargin form-group-addToCartEventFS--disabled" style="margin-bottom: 1rem;">
                                        </fieldset>
                                        <small class="red-text" id="addToCartEventSelectError"></small>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col text-center">
                                <div class="small red-text" id="addToCartError"></div>
                            </div>
                        </div>
                        <div class="modal-footer paybee-modal-footer pt-4">
                            <a id="addToCartCancelButton" class="btn btn-sm modal-cancel-button waves-effect waves-light">Cancel</a>
                            <a id="addToCartAddButton" class="btn btn-sm modal-confirm-button waves-effect waves-light">Add to Cart</a>
                        </div>
                    </div>
                    <div id="addToCartCampaignForm" style="display: none">
                        <div id="addToCartCampaignFormBody" class="modal-body custom-material-form updated-dropdown">
                        </div>
                        <div class="modal-footer paybee-modal-footer pt-4">
                            <a id="addToCartCampaignFormBackButton" class="btn btn-sm modal-cancel-button waves-effect waves-light">Back</a>
                            <a id="addToCartCampaignFormSubmitButton" class="btn btn-sm modal-confirm-button waves-effect waves-light">Add To Cart</a>
                        </div>
                    </div>
                    <div id="mooveCart" style="display: none">
                    </div>
                    <div id ='cartRemainder' style="display: none">
                        <div class="modal-body custom-material-form updated-dropdown">
                            <label class="body-2">
                                Add optional message to email 
                            </label>
                            <div class="text-center">
                                <div class="md-form flex-column justify-content-end align-items-end">
                                    <div id="atendeeCartReminderAllMessage" class="form-control md-textarea quill--paybee overflow-visible resize-vertical">
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 mb-4">
                                    <div class="black-text custom-control custom-switch">
                                        <input type="checkbox" class="custom-control-input" id="attendeeSendCartReminderAllText">
                                        <label class="custom-control-label subtitle-1" for="attendeeSendCartReminderAllText">Send Text Message to guest(s) with phone number.</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer paybee-modal-footer d-flex justify-content-between">
                            <a id="sendAttendeeCartReminderPreview" class="btn btn--paybee btn--green button waves-effect waves-light">Preview</a>
    
                            <div class="ml-auto">
                                <a class="btn btn-sm modal-cancel-button" id="cartRemindeCancelBtn">Cancel</a>
                                <a id="attendeeCartReminderAllSendBtn" class="btn btn-sm modal-confirm-button">Send</a>
                            </div>
                        </div>
                    </div>
                    <div id ='basketRaffleBlock' style="display: none">
                        <div class="modal-body" id="basketRaffleItemListModalContainer">
                        </div>
                        <div class="modal-footer paybee-modal-footer">
                            <a id="basketRaffleItemCancelButton" class="btn btn-sm modal-cancel-button waves-effect waves-light">Cancel</a>
                            <a id="basketRaffleItemListModalSave" class="btn btn-sm modal-confirm-button disabled">Save</a>
                        </div>
                    </div>
                    <div id="editCartMemo" style="display: none">
                        <div class="modal-body custom-material-form updated-dropdown">
                            <div class="row justify-content-center" >
                                <div class="col-10">
                                    <div class="md-form">
                                        <input type="text" length="128" maxlength="128" id="memoCartCheckoutInput" class="form-control">
                                        <label id="memoCartCheckoutInputLabel" for="memoCartCheckoutInput" class="form-label">Memo (optional)</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer paybee-modal-footer pt-4">
                            <a id="editCartMemo_cancellButton" class="btn btn-sm modal-cancel-button waves-effect waves-light">Cancel</a>
                            <a id="editCartMemo_saveButton" class="btn btn-sm modal-confirm-button waves-effect waves-light">Save</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div data-html2canvas-ignore class="modal fade" id="attendeeAddToCartModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content paybee-modal-content custom-material-form">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col-11">
                                <div class="modal-main-heading">Add to Cart</div>
                            </div>
                            <div class="col-1">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" class="black-text">×</span>
                                </button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="modal-sub-heading">Add pending pledge by Campaign.</div>
                            </div>
                        </div>
                    </div>
                    <div id="addToCart" style="display: none">
                        <div class="modal-body modal-body--add-to-cart px-0 custom-material-form updated-dropdown">
                            <div class="row justify-content-center">
                                <div class="col-11 text-left">
                                    <div class="text-left" style="color: #757575; font-size: 0.8rem;">Select Campaign</div>
                                    <fieldset id="addToCartModalCampaignFS" class="form-group noMargin" style="margin-bottom: 1rem;">
                                    </fieldset>
                                    <small class="red-text" id="addToCartModalCampaignSelectError"></small>
                                </div>
                            </div>
                            <div id="addToCartModalOptionBlock" class="row justify-content-center" style="display: none">
                                <div class="col-11 text-left">
                                    <div class="text-left" style="color: #757575; font-size: 0.8rem;">Select Option</div>
                                    <fieldset id="addToCartModalOptionFS" class="form-group noMargin" style="margin-bottom: 1rem;">
                                    </fieldset>
                                    <small class="red-text" id="addToCartModalOptionSelectError"></small>
                                </div>
                            </div>
                            <div class="row justify-content-center" id="addToCartModalAmountRow">
                                <div class="col-11">
                                    <div class="md-form">
                                        <input min="1" step="0.01" type="number" id="addToCartModalOptionAmount" class="form-control validate">
                                        <label id="addToCartModalOptionAmountLabel" class="inputLabel" data-error="Invalid Amount" data-success="" for="addToCartModalOptionAmount">
                                            Amount
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="row justify-content-center" id="addToCartModalQuantityBlock">
                                <div class="col-11">
                                    <div class="md-form">
                                        <input min="1" step="1" type="number" id="addToCartModalOptionQuantity" class="form-control validate">
                                        <label id="addToCartModalOptionQuantityLabel" class="inputLabel" data-error="Invalid Quantity" data-success="" for="addToCartModalOptionQuantity">
                                            Quantity
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="row justify-content-center" id="accordionBlockAttendeeAddToCartModal" style="display: none">
                                <div class=" md-accordion md-accordion--addToCard  col-11" id="accordionExampleAttendeeAddToCartModal">
                                    <div class="card accordion card--guest z-depth-0">
                                        <div class="card-header card-header--guest p-0 d-flex justify-content-between" id='headerAttendeeAddToCartModal'>
                                            <button
                                                class="btn btn-link btn-link--text-decoration-none btn-link--text-transform-none collapsed d-flex align-items-center pl-0 m-0"
                                                type="button"
                                                id='header_buttonAttendeeAddToCartModal'
                                                data-toggle="collapse"
                                                data-target="#contentAttendeeAddToCartModal"
                                                aria-expanded="true"
                                                aria-controls="accordionAttendeeAddToCartModal"
                                            >
                                                <i class="fas fa-angle-down rotate-icon fa-2x mr-3" style="font-size: 1.5rem;"></i>
                                                <span class="body-1--weight-medium  black-text" data-toggle="tooltip-attendee-add-to-cart" data-placement="right" title="This information is required on the donor side, but you can skip this step.">Additional information (Optional)</span>
                                            </button>
                                        </div>
                                        <div id="contentAttendeeAddToCartModal" class="collapse"
                                            aria-labelledby="headerAttendeeAddToCartModal"
                                            data-parent="#accordionExampleAttendeeAddToCartModal"
                                        >
                                            <div class="card-body">
                                                <div id="streetAddressDivAttendeeAddToCartModal"  class="row justify-content-center mb-3" style="display: none">
                                                    <div class="col-12" >
                                                        <div class="d-flex flex-row">
                                                            <div class="md-form no-bottom-margin p-0 col-9">
                                                                <input class="form-control input-default mb-0" type="text" placeholder="Search for address" id="streetAddressAttendeeAddToCartModal" onfocus="this.setAttribute('autocomplete','chrome-off')">
                                                                <button id="streetAddressCanselBtnAttendeeAddToCartModal" type="button" class="matGoogleMapsAutocomplete-clear cansel-org-side">
                                                                    <i class="fas fa-times"></i>
                                                                </button>
                                                            </div>
                                                            <div class="col-3 pr-0">
                                                                <div class="md-form no-bottom-margin">
                                                                    <input class="form-control mb-0" type="text" id="streetAddressAttendeeAddToCartModalUnit">
                                                                    <label id="streetAddressUnitLabelAttendeeAddToCartModal" class="inputLabel" for="streetAddressAttendeeAddToCartModalUnit" data-error="Invalid" data-success="">Unit/Apt#</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div  id="phoneNumDivAttendeeAddToCartModal" class="row justify-content-center mb-3"   style="display: none">
                                                    <div class="col-12">
                                                        <div class='md-form no-bottom-margin'>
                                                            <input type='text' id='phoneNumAttendeeAddToCartModal' autocomplete='chrome-off' class='form-control validate mb-0'>
                                                            <label id="phoneNumLabelAttendeeAddToCartModal" class='inputLabel active' for='phoneNumAttendeeAddToCartModal' data-success=''>
                                                                Phone
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row justify-content-center mb-3" id="additionalInfoDivAttendeeAddToCartModal"  style="display: none">
                                                    <div  class="col-12">
                                                        <div class="md-form no-bottom-margin" style="margin-bottom: 4rem">
                                                            <input
                                                                type="text"
                                                                required
                                                                id="additionalInfoTextAttendeeAddToCartModal"
                                                                maxlength="512"
                                                                class="form-control validate mb-0">
                                                            <label
                                                                class="inputLabel"
                                                                id="additionalInfoTextLabelAttendeeAddToCartModal"
                                                                for="additionalInfoTextAttendeeAddToCartModal"
                                                                data-error="Invalid"
                                                                data-success="">
                                                                Additional Info
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row justify-content-center" id="additionalInfoSelectDiv"  style="display: none">
                                                    <div  class="col-12" style="margin-bottom: 20px">
                                                        <h6 class="text-left sectionHeading" id="additionalInfoSelectDesc"></h6>
                                                        <fieldset class="form-group noMargin" id="additionalInfoSelectList"></fieldset>
                                                        <small style="display: none" class="red-text text-left" id="additionalInfoSelectError"></small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="addToCartModalEventBlock" class="row justify-content-center">
                                <div class="col-10 text-left">
                                    <div class="text-left" style="color: #757575; font-size: 0.8rem;">Select Event</div>
                                    <fieldset id="addToCartModalEventFS" class="form-group noMargin" style="margin-bottom: 1rem;">
                                    </fieldset>
                                    <small class="red-text" id="addToCartModalEventSelectError"></small>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col text-center">
                                <div class="small red-text" id="addToCartModalError"></div>
                            </div>
                        </div>
                        <div class="modal-footer paybee-modal-footer">
                            <a id="addToCartModalCancelButton" class="btn btn-sm modal-cancel-button waves-effect waves-light" data-dismiss="modal">Cancel</a>
                            <a id="addToCartModalAddButton" class="btn btn-sm modal-confirm-button waves-effect waves-light">Add to Cart</a>
                        </div>
                    </div>
                    <div id="addToCartCampaignForm" style="display: none">
                        <div id="addToCartCampaignFormBody" class="modal-body custom-material-form updated-dropdown">
                        </div>
                        <div class="modal-footer paybee-modal-footer pt-4">
                            <a id="addToCartCampaignFormBackButton" class="btn btn-sm modal-cancel-button waves-effect waves-light">Back</a>
                            <a id="addToCartCampaignFormSubmitButton" class="btn btn-sm modal-confirm-button waves-effect waves-light">Add To Cart</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div data-html2canvas-ignore class="modal fade" id="userRecentDonationsModal"  tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content paybee-modal-content paybee-modal-content-userRecentDonations">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col-11">
                                <div class="modal-main-heading mb-0">Attendee Details</div>
                            </div>
                            <div class="col-1">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" class="black-text">×</span>
                                </button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="modal-sub-heading">Includes attendee details, pending and paid transactions</div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body custom-material-form updated-dropdown" style="padding: 1.2rem;">
                        <div class="d-flex align-items-center justify-content-between mb-2">
                            <div class="d-flex align-items-center pl-1">
                                <div class="mr-3">
                                    <div class="body-1" id="userRecentDonationsAttendeeName"></div>
                                    <div class="body-2 grey-text" id="userRecentDonationsEMail"></div>
                                </div>
                                <div id="userRecentDonationsCheckedInSection" class="d-flex">
                                    <div id="userRecentDonationsCheckedInStatus" class="badget--2x8 badget--radius-12 body-2"></div>
                                </div>
                            </div>
                        </div>
                        <ul class="nav nav-tabs md-tabs md-tabs--paybee md-tabs__bottom-border p-0" role="tablist">
                            <li class="nav-item">
                                <a class="nav-link active" id="userRecentDonationsDetailsTabNav" data-toggle="tab" href="#userRecentDonationsDetailsTab" role="tab" aria-controls="userRecentDonationsDetailsTab"
                                   aria-selected="true">Details</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" id="userRecentDonationsTransactionsTabNav" data-toggle="tab" href="#userRecentDonationsTransactionsTab" role="tab" aria-controls="userRecentDonationsTransactionsTab"
                                   aria-selected="false">Transactions</a>
                            </li>
                        </ul>
                        <div class="tab-content pt-4">
                            <div class="tab-pane fade show active" id="userRecentDonationsDetailsTab" role="tabpanel" aria-labelledby="userRecentDonationsDetailsTabNav">
                                <div class="row justify-content-between">
                                    <div class="col-5">
                                        <div class="row">
                                            <div id="userRecentDonationsPaddleSection" class="col-12 d-flex align-items-center justify-content-between border__bottom py-3">
                                                <div class="subtitle-2 black-text">Paddle</div>
                                                <div id="userRecentDonationsPaddle" class="d-flex align-items-center body-1 grey-text"></div>
                                            </div>
                                            <div id="userRecentDonationsTableSection" class="col-12 d-flex align-items-center justify-content-between border__bottom py-3">
                                                <div class="subtitle-2 black-text">Table</div>
                                                <div id="userRecentDonationsTable" class="body-1 grey-text"></div>
                                            </div>
                                            <div id="userRecentDonationsSavedCardSection" class="col-12 d-flex align-items-center justify-content-between border__bottom py-3">
                                                <div class="subtitle-2 black-text">Saved Card</div>
                                                <div id="userRecentDonationsSavedCard" class="body-1 grey-text"></div>
                                            </div>
                                            <div class="col-12 d-flex align-items-center justify-content-between border__bottom py-3">
                                                <div class="subtitle-2 black-text">Total Paid</div>
                                                <div id="userRecentDonationsTotalPaid" class="body-1 grey-text"></div>
                                            </div>
                                            <div class="col-12 d-flex align-items-center justify-content-between border__bottom py-3">
                                                <div class="subtitle-2 black-text">Total Pending</div>
                                                <div id="userRecentDonationsTotalPending" class="body-1 grey-text"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-6 d-none payment-card-details " id="saveAttendeeCardBlock" >
                                        <form id="handlePaymentSubmission">
                                            <label for="card-element">Card Details</label>
                                            <div id="card-element">
                                        
                                            </div>
                                        </form>
                                        <div class="mt-4">
                                            <fieldset id="donorFeeCheckCardDivCheckIn">
                                                <label class="paybee-switch form-check-label" style="margin-bottom: 0rem;" for="donorFeeCheckCardCheckIn">
                                                    <input type="checkbox" class="switcher" id="donorFeeCheckCardCheckIn" checked>
                                                    <span class="switcher"></span>
                                                    <h6 class="label fee-text" id="donorFeeCheckCardLabelCheckIn">Attendee will cover card fees</h6>
                                                </label>
                                            </fieldset>                                                     
                                            <div class="d-flex justify-content-center mt-2">
                                                <button id="cardPaymentButton" type="submit" class="btn modal-success-button btn-sm">Save Card</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="tab-pane fade show" id="userRecentDonationsTransactionsTab" role="tabpanel" aria-labelledby="userRecentDonationsDetailsTabNav">
                                <div class="table--paybee table--paybee--important mt-3">
                                    <table id ="userRecentDonationList" class="table" cellspacing="0" style="width: 100%;">
                                        <thead class="thead-light">
                                            <tr>
                                                <th>Campaign</th>
                                                <th>Option</th>
                                                <th style="min-width:75px;">Date</th>
                                                <th>Amount</th>
                                                <th>Status</th>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer paybee-modal-footer pt-4" id="userRecentDonationFooter">
                        <a id="userRecentDonationCancel" class="btn btn-sm modal-cancel-button waves-effect waves-light">Cancel</a>
                        <a id="userRecentDonationCart" class="btn btn-sm modal-confirm-button waves-effect waves-light">See Cart (<span id="userRecentDonationCartItems"></span>)</a>
                    </div>
                </div>
            </div>
        </div>

        <div data-html2canvas-ignore class="modal fade" id="userCheckInModal"  tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content paybee-modal-content paybee-modal-content-userRecentDonations">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col-11">
                                <div id="userCheckInModalHeader" class="modal-main-heading mb-0">Check In Guest(s)</div>
                            </div>
                            <div class="col-1">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" class="black-text">×</span>
                                </button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="modal-sub-heading" id='guestsToBeCheckInSub'>This action will check in the guest(s) selected below.</div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col text-center">
                                <p id="guestsToBeCheckInHtml"></p>
                            </div>
                        </div>
                        <div id="checkInModal-secondScreen">
                            <div class="mr-3" id="userDetails">
                                <div class="body-1" id="userRecentDonationsAttendeeNameCheckIn"></div>
                                <div class="body-2 grey-text" id="userRecentDonationsEMailCheckIn"></div>
                            </div>
                            <div class="tab-pane fade show active" id="userRecentDonationsDetailsCheckIn">
                                <div class="accordion md-accordion" id="guestListAccordion" role="tablist" aria-multiselectable="true"></div>
                            </div>  
                        </div>
                    </div>
                    <div class="modal-footer paybee-modal-footer pt-4" id="userRecentDonationFooter">
                        <a id="userCheckInCansel" class="btn btn-sm modal-cancel-button waves-effect waves-light">Close</a>
                        <a id="userCheckInBtn" class="btn btn-sm modal-confirm-button waves-effect waves-light">Check In</a>
                    </div>
                </div>
            </div>
        </div>
    
        <div data-html2canvas-ignore class="modal fade" id="addEventTablesModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-notify modal-warning" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header border-bottom">
                        <div class="row">
                            <div class="col-10">
                                <div class="modal-main-heading">Add Tables</div>
                            </div>
                            <div class="col-2">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" class="black-text">×</span>
                                </button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="modal-sub-heading">Fill in the information below to add a guest table</div>
                            </div>
                        </div>
                    </div>

                    <div class="modal-body pb-0">
                        <div class="row custom-material-form updated-dropdown">
                            <div class="col-6 form-group text-center">
                                <div class="md-form">
                                    <input
                                            type="number"
                                            id="tableStartNum"
                                            required
                                            class="form-control validate mb-0">
                                    <label
                                            id="tableStartNumLabel"
                                            class="inputLabel"
                                            for="tableStartNum"
                                            data-error="Invalid"
                                            data-success="">
                                        Starting Table Number
                                    </label>
                                </div>
                            </div>
                            <div class="col-6 form-group text-center">
                                <div class="md-form">
                                    <input
                                            type="number"
                                            id="tableEndNum"
                                            required
                                            class="form-control validate mb-0">
                                    <label
                                            id="tableEndNumLabel"
                                            class="inputLabel"
                                            for="tableEndNum"
                                            data-error="Invalid"
                                            data-success="">
                                        Ending Table Number
                                    </label>
                                </div>
                            </div>
                            <div class="col-6 form-group text-center">
                                <div class="md-form">
                                    <input
                                            type="number"
                                            id="tableNumSeats"
                                            required
                                            class="form-control validate">
                                    <label
                                            id="tableNumSeatsLabel"
                                            class="inputLabel"
                                            for="tableNumSeats"
                                            data-error="Invalid"
                                            data-success="">
                                        No. of Seats
                                    </label>
                                </div>
                            </div>
                            <div class="col-6 text-center d-flex">
                                <div class="md-form w-100">
                                    <input
                                            type="text"
                                            id="tableCategory"
                                            maxlength="16"
                                            required
                                            class="form-control validate mb-0">
                                    <label
                                            id="tableCategoryLabel"
                                            class="inputLabel"
                                            for="tableCategory"
                                            data-error="Invalid"
                                            data-success="">
                                        Category (optional)
                                    </label>

                                </div>
                                <i class="blue-text far fa-question-circle cursor--pointer ml-2 mt-3 h-25" data-toggle="tooltip" data-placement="top" title="If tables at your event belong to a specific category, use this field to add them. Categories are displayed along with table numbers/names on paddles."></i>
                            </div>
                            <div class="col-7 form-group text-center">
                                <div class="d-flex align-items-center ml-2">
                                    <div class="black-text custom-control custom-switch">
                                        <input type="checkbox" class="custom-control-input" id="assignedSeating">
                                        <label class="custom-control-label subtitle-1" for="assignedSeating">Guest will be assigned specific seats in table</label>
                                    </div>
                                    <i data-toggle="tooltip" data-placement="top" title="" class="blue-text far fa-question-circle cursor--pointer ml-2" data-original-title="If you are assigning guests to specific tables and specific seats within the table, switch this ON. If seating within the table is not important, leave it OFF. For eg., a guest could be assigned Seat A in Table 1."></i>
                                </div>
                            </div>
                        </div>

                        <div class="d-flex align-items-center justify-content-end my-3">
                            <a class="btn btn-sm modal-cancel-button waves-effect waves-light mr-2" data-dismiss="modal" aria-label="Cancel">Cancel</a>
                            <a id="addNewTables" class="btn btn-sm modal-confirm-button waves-effect waves-light">Add</a>
                        </div>
                        <div class="divider my-4"></div>

                        <div class="row">
                            <div class="col">
                                <p class="body-1 black-text">Existing Tables: </p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="table--paybee table--mb-5">
                                    <table class="table" id="existingTableList" cellspacing="0" style="width: 100%;">
                                        <thead class="thead-light">
                                            <tr>
                                                <th scope="col">#</th>
                                                <th scope="col">Seats</th>
                                                <th scope="col">Category</th>
                                                <th scope="col">Guests Assigned</th>
                                                <th scope="col"></th>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div data-html2canvas-ignore class="modal fade" id="addEventGolfHolesModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-notify modal-warning" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header border-bottom">
                        <div class="row">
                            <div class="col-10">
                                <div class="modal-main-heading">Add Golf Holes</div>
                            </div>
                            <div class="col-2">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" class="black-text">×</span>
                                </button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="modal-sub-heading">Fill in the information below to add a golf hole</div>
                            </div>
                        </div>
                    </div>

                    <div class="modal-body pb-0">
                        <div class="row custom-material-form updated-dropdown black-text">
                            <div class="col-6 text-center">
                                <div class="md-form">
                                    <div class="body-2 text-left mb-1 ">Number of Holes</div>
                                    <select id="numberOfHolesSelect" class="mdb-select mdb-select--paybee">
                                        <option value="9">9</option>
                                        <option value="18" selected >18</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-6 text-center">
                                <div class="md-form">
                                    <div class="body-2 text-left mb-1 ">Foursomes per hole</div>
                                    <select id="foursomesPerHoleSelect" class="mdb-select mdb-select--paybee">
                                        <option value="1">1</option>
                                        <option value="2" selected >2</option>
                                        <option value="3">3</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div class="d-flex align-items-center justify-content-end my-3">
                            <a class="btn btn-sm modal-cancel-button waves-effect waves-light mr-2" data-dismiss="modal" aria-label="Cancel">Cancel</a>
                            <a id="addNewGolfHoles" class="btn btn-sm modal-confirm-button waves-effect waves-light">Add</a>
                        </div>
                        <div class="divider my-4"></div>

                        <div class="row">
                            <div class="col">
                                <p class="body-1 black-text">Existing Golf Holes: </p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="table--paybee table--mb-5">
                                    <table class="table" id="existingGolfHoleList" cellspacing="0" style="width: 100%;">
                                        <thead class="thead-light">
                                            <tr>
                                                <th scope="col">#</th>
                                                <th scope="col">Group Size</th>
                                                <th scope="col">Guests Assigned</th>
                                                <th scope="col">Group Letter</th>
                                                <th scope="col"></th>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    
        <div data-html2canvas-ignore class="modal fade" id="volunteerDetailModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-notify modal-info modal-xl" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">
                        <div id="modelTitle" class="modal-main-heading">Volunteer Details</div>
                        <div class="modal-sub-heading">Donations accepted by <b><span id="volunteerDetailNames"></span></b></div>
                    </div>           
                    <div class="modal-body text-center" id="volunteerReportNoDonations" style="display:none">
                        <p class="no-data-text">No Donations accepted yet.</p>
                    </div>
                    <div class="modal-body" id="volunteerDetailMainBody">
                        <div class="row justify-content-center">
                            <div class="table--paybee">
                                <table id ="volunteerDonations" class="table" cellspacing="0" style="width: 100%;">
                                    <thead class="thead-light">
                                    <tr>
                                        <th>Donor</th>
                                        <th>Email</th>
                                        <th>Option </th>
                                        <th>Status</th>
                                        <th>Amount</th>
                                        <th>Date </th>
                                        <th>Method</th>
                                        <th>Memo</th>
                                    </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div data-html2canvas-ignore class="modal fade" id="unsettledDetail" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-notify modal-info" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">
                        <div id="modelTitle" class="modal-main-heading">Donation Details</div>
                        <div id="modelSubTitle" class="modal-sub-heading"></div>
                        <div id="loginMessage" class="modal-sub-heading"></div>
                        <div id="loginError" class="modal-sub-heading red-text" style="display:none"></div>
                    </div>  
                    <div class="modal-body">
                        <div class="text-center">
                            <div class="row justify-content-center">
                                <div class="col">
                                    <h5 class="text-center">Memo</h5>
                                    <p id="donationMemo"></p>
                                </div>
                            </div>
                            <div class="row justify-content-center" style="margin-top: 25px;">
                                <div class="col">
                                    <h5>Front Of Check</h5>
                                    <img id="checkFront" src="/images/check.png" style="margin-top: 5px; width: 300px">
                                </div>
                            </div>
                            <div class="row justify-content-center" style="margin-top: 25px;">
                                <div class="col">
                                    <h5>Back Of Check</h5>
                                    <img id="checkBack" src="/images/check.png" style="margin-top: 5px; width: 300px">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    
        <div data-html2canvas-ignore class="modal fade" id="saveReportModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-notify modal-info">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col">
                                <div class="modal-main-heading">Save Report</div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body">
                        <form onsubmit="return false">
                            <div class="md-form">
                                <input type="text" id="saveReportName" class="form-control validate" maxlength="16" length="5120">
                                <label class="inputLabel" id="saveReportNameLabel" for="saveReportName">
                                    Report Name
                                </label>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer paybee-modal-footer">
                        <a class="btn btn-sm modal-confirm-button waves-effect waves-light" id="saveReportModalButton">Save</a>
                    </div>
                </div>
            </div>
        </div>
    
        <div data-html2canvas-ignore class="modal fade" id="sendGenericNotificationModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-notify modal-info">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col">
                                <div class="modal-main-heading">Send Text Message</div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="modal-sub-heading">
                                    This message will be send via text to all attendees of this event who have valid phone number.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body">
                        <form onsubmit="return false">
                            <div class="md-form">
                                <input type="text" id="genericMessage" class="form-control validate" maxlength="256" length="256">
                                <label class="inputLabel" id="genericMessageLabel" for="genericMessage">
                                    Message
                                </label>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer paybee-modal-footer">
                        <a class="btn btn-sm modal-confirm-button waves-effect waves-light" id="sendGenericMessageBtn">Send</a>
                    </div>
                </div>
            </div>
        </div>
     
        <div data-html2canvas-ignore class="modal fade" id="sendJoinReminderToAllModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col">
                                <div class="modal-main-heading">Send Join Reminder</div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="modal-sub-heading">
                                    Join reminder to all attendees.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body custom-material-form updated-dropdown">
                        <div class="d-flex justify-content-between mb-2">
                            <span class="body-2">
                                Optional header in reminder emails
                            </span>
                        </div>
                        <div class="text-center">
                            <div class="md-form flex-column justify-content-end align-items-end">
                                <div id="sendJoinReminderToAllMessage-header" class="form-control md-textarea quill--paybee--small quill-scrollablle--small">
                                </div>
                                <span id="sendJoinReminderToAllMessage-headerLength"  class="character-counter character-counter-jquery"></span>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between mb-2">
                            <span  class="body-2">
                                Optional footer in reminder emails
                            </span>
                        </div>
                        <div class="text-center">
                            <div class="md-form flex-column justify-content-end align-items-end">
                                <div id="sendJoinReminderToAllMessage-footer" class="form-control md-textarea quill--paybee quill-scrollablle">
                                </div>
                                <span id="sendJoinReminderToAllMessage-footerLength"  class="character-counter character-counter-jquery"></span>
                            </div>
                        </div>
                        <div class="col-12 px-0">
                            <div class="black-text custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" id="sendSMSJoinReminder">
                                <label class="custom-control-label subtitle-1" for="sendSMSJoinReminder">Check the box for Text reminders.</label>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer paybee-modal-footer d-flex justify-content-between">
                        <a id="sendJoinReminderToAllPreview" class="btn btn--paybee btn--green button waves-effect waves-light">Preview</a>
                        <div class="ml-auto">
                            <a class="btn btn-sm modal-cancel-button" data-dismiss="modal">Cancel</a>
                            <a class="btn btn-sm modal-confirm-button waves-effect waves-light" id="sendJoinReminderToAllBtn">Send</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    
        <div data-html2canvas-ignore class="modal fade" id="sendAuctionClosingReminderModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col">
                                <div class="modal-main-heading">Send Auction Closing Reminder Now</div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="modal-sub-heading">
                                    <div class="mb-3">Send auction closing reminders now to all bidders via email and text.</div>
                                    <div class="black-text">Example: "Auction: 
                                        <span id="closingCampaignName">Campaign Name</span> 
                                        is closing in 
                                        <span id="closinginMinutes">10</span> 
                                        minutes. See all your bids at https://..."
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body custom-material-form updated-dropdown" style="padding: 1.2rem;">
                        <form onsubmit="return false">
                            <div class="row">
                                <div id="sendAuctionClosingReminderTimeBlock" class="col-12">
                                    <label class="body-2">Bidding end time is not set, please specify the time in minutes auction is closing.</label>
                                    <div class="md-form">
                                        <input type="number" id="sendAuctionClosingReminderMinutes" class="form-control validate m-0" min="1" step="1" onkeypress="return event.charCode >= 48 && event.charCode <= 57">
                                        <label class="inputLabel" id="sendAuctionClosingReminderMinutesLabel" for="sendAuctionClosingReminderMinutes">
                                            Auction closing in minutes
                                        </label>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <label class="body-2">
                                        Optional message to be added to the reminder email
                                    </label>
                                    <div class="text-center">
                                        <div class="md-form flex-column justify-content-end align-items-end">
                                            <div id="sendAuctionClosingReminderMessage" class="form-control md-textarea quill--paybee overflow-visible resize-vertical">
                                            </div>
                                        </div>
                                    </div>
                                </div>   
                                <div class="col-12">
                                    <div class="black-text custom-control custom-switch">
                                        <input type="checkbox" class="custom-control-input" id="sendSMSAuctionClosingReminder">
                                        <label class="custom-control-label subtitle-1" for="sendSMSAuctionClosingReminder">Check the box for Text reminders.</label>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer paybee-modal-footer d-flex justify-content-between">
                        <a id="sendAuctionClosingReminderPreviewBtn" class="btn btn--paybee btn--green button waves-effect waves-light">Preview</a>
                        <div class="ml-auto">
                            <a class="btn btn-sm modal-cancel-button" data-dismiss="modal">Cancel</a>
                            <a class="btn btn-sm modal-confirm-button waves-effect waves-light" id="sendAuctionClosingReminderBtn">Send</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    
        <div data-html2canvas-ignore class="modal fade" id="addVolunteerModel" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-notify modal-info" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col">
                                <div class="modal-main-heading">Add Volunteer</div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="modal-sub-heading">
                                    Add volunteers by email. They will get email with instructions to proceed. Volunteers get special prvilage in the PayBee app to accept donations, checkin etc. 
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body">
                        <div class="text-center custom-material-form updated-dropdown">
                            <form id="addVolunteerForm" onsubmit="return orgMain.addVolunteer()">
                                <div class="md-form">
                                    <input
                                        type="email"
                                        id="volunteerEmail"
                                        class="form-control validate">
                                    <label
                                        class="inputLabel"
                                        id="volunteerEmailLabel"
                                        for="volunteerEmail">
                                        Volunteer email
                                    </label>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div class="modal-footer paybee-modal-footer">
                        <a class="btn btn-sm modal-cancel-button" data-dismiss="modal">Cancel</a>
                        <a id="addVolunteerButton" onclick="return orgMain.addVolunteer()" class="btn btn-sm modal-confirm-button">Add</a>
                    </div>
                </div>
            </div>
        </div>

        <div data-html2canvas-ignore class="modal fade" id="addNewAccountModel" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-notify modal-info" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col">
                                <div class="modal-main-heading">Add Account Admin</div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="modal-sub-heading">Add other users to administrate this account. They will get email with instructions.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body">
                        <div class="text-center custom-material-form updated-dropdown">
                            <form onsubmit="return orgMain.addAccountUser()">
                                <div class="md-form">
                                    <input
                                            type="email"
                                            id="accountUserEmail"
                                            class="form-control validate">
                                    <label
                                            class="inputLabel"
                                            id="accountUserEmailLabel"
                                            for="accountUserEmail">
                                        Account user email
                                    </label>
                                </div>
                                <div class="md-form">
                                    <input
                                            type="text"
                                            id="accountUserName"
                                            class="form-control validate">
                                    <label
                                            class="inputLabel"
                                            id="accountUserNameLabel"
                                            for="accountUserName">
                                        Account user name
                                    </label>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div class="modal-footer paybee-modal-footer">
                        <a class="btn btn-sm modal-cancel-button" data-dismiss="modal">Cancel</a>
                        <a onclick="return orgMain.addAccountUser()" class="btn btn-sm modal-confirm-button">Add</a>
                    </div>
                </div>
            </div>
        </div>
    
        <div id="qrPreviewModel" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true" style="display: none;">
            <div class="modal-dialog modal-sm">
                <div class="modal-content" align="center" style="background-color: #FAF7CE;max-height:100%;max-width:100%;">
                    <div class="modal-header" style="background-color: #F2D93A;">
                        <h4 class="modal-title">QR Code Preview</h4>
                    </div>
                    <div class="modal-body" style="background-color:white;">
                        <div id="previewImage" style="padding-top:20px;">
                        </div>
                    </div>
                    <div class="modal-footer text-align-center" style="background-color: white;">
                        <a id="btn-Convert-Html2Image" class="btn btn-success btn-block">Download</a>
                    </div>
                </div>
            </div>
        </div>
    
        <div id="eventLinksModel" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true" style="display: none;">
            <div class="modal-dialog modal-lg">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header px-4 pt-4 pb-2 position-relative">
                        <div class="row align-items-center">
                            <div class="col col-3" id="eventLinksImageBlock">
                                <img id="eventLinksImage" class="eventLinksImage" src="" alt="">
                            </div>
                            <div class="col text-left">
                                <div class="d-flex flex-column">
                                    <div class="headline-6 mb-3" id="eventLinksEventName"></div>
                                    <div class="body-3 grey-text mb-2"> 
                                        Spread the word, share the event links with your attendees
                                    </div>
                                    <div class="body-2--weight-medium" id="linkName" style="display: none;"></div>
                                </div>
                            </div>
                        </div>
                        <button type="button" class="close position-absolute" data-dismiss="modal" aria-label="Close" style="top: 30px;right: 30px;">
                            <span aria-hidden="true" class="black-text">×</span>
                        </button>
                    </div>
        
                    <div class="modal-body px-5 py-0" style="background-color:white;border-top: 1px solid rgba(0, 0, 0, 0.08)">
                        <div id="streamInfo" class="mt-3">
                            <h5 style="font-weight: 500" class="mb-4">Paybee Live Stream Info: </h5>
                            <div class="d-flex align-items-center justify-content-between py-3" style="border-bottom: 1px solid rgba(0, 0, 0, 0.08);">
                                <div class="col col-5 d-flex flex-column p-0">
                                    <span class="link-title mr-2">Playback Link: </span>
                                    <span class="body-3 grey-text"> Link to watch the real-time playback of your PayBee livestream. </span>
                                    <!-- <div class="d-flex flex-column px-2">
                                        <div id="playBackUrl" class="body-3 grey-text"></div>
                                    </div> -->
                                </div>
                                <div class="d-flex" style="margin-right: 140px;">
                                    <a class="link-url modal-open-button btn mr-3" target="_blank" href="" id="playBackUrl" style="color: #666">Open in new tab</a>
                                    <a onclick="copyURI(event)" class="link-url modal-copy-button btn mr-3 waves-effect waves-light" target="_blank" href="" id="copyPlayBackUrl" style="color: #666">Copy Link</a>
                                </div>
                            </div>
                            <div class="d-flex align-items-center justify-content-between py-3" style="border-bottom: 1px solid rgba(0, 0, 0, 0.08);">
                                <div class="col col-5 d-flex flex-column p-0">
                                    <span class="link-title mr-2">RTMP Link: </span>
                                    <span class="body-3 grey-text"> Link to be copied to your streaming tool when creating your PayBee livestream. </span>
                                    <!-- <div class="d-flex flex-column px-2">
                                        <div id="RTMLUrl" class="body-3 grey-text"></div>
                                    </div> -->
                                </div>
                                <div class="d-flex" style="margin-right: 140px;">
                                    <a onclick="copyURI(event)" class="link-url modal-copy-button btn mr-3 waves-effect waves-light" target="_blank" href="" id="copyRTMLUrl" style="color: #666">Copy Link</a>
                                </div>
                            </div>
                            <div class="d-flex align-items-center justify-content-between py-3"  style="border-bottom: 1px solid rgba(0, 0, 0, 0.08);">
                                <div class="col col-5 d-flex flex-column p-0">
                                    <span class="link-title mr-2">Stream Key: </span>
                                    <span class="body-3 grey-text"> Key to copied to your streaming tool when creating your PayBee livestream. </span>
                                    <!-- <div class="d-flex flex-column px-2">
                                        <div id="streamKey" class="body-3 grey-text"></div>
                                    </div> -->
                                </div>
                                <div class="d-flex" style="margin-right: 140px;">
                                    <a onclick="copyURI(event, 'key')" class="link-url modal-copy-button btn mr-3 waves-effect waves-light" target="_blank" href="" id="copyStreamKey" style="color: #666">Copy key</a>
                                </div>
                            </div>
                        </div>
                        <div id="eventLinks">
                                <div class="row py-3" id='joinLine' style="border-bottom: 1px solid rgba(0, 0, 0, 0.08);">
                                    <div class="col col-5 d-flex flex-column">
                                        <span class="link-title">Join Link </span>
                                        <span class="body-3 grey-text"> Link to share for attendees to register and join your virtual event at the same time. </span>
                                    </div>
                                    <div class="col d-flex flex-row align-items-center justify-content-end">
                                        <a class="link-url modal-open-button btn mr-3" target="_blank" href="" id="joinUrlText" style="color: #666">Open in new tab</a>
                                        <a onclick="copyURI(event)" class="link-url modal-copy-button btn mr-3" target="_blank" href="" id="copyJoinUrlText" style="color: #666">Copy link</a>
                                        <div onclick="initShareTwitter(event)" id="copyJoinUrlTextTW" class="d-flex align-items-center justify-content-center share-icon--event-link event-link-x mr-3">
                                            <img src="images/svg/twiter-x.svg" width="15px" alt="">
                                        </div>
                                        <div onclick="initShareFacebook(event)" id="copyJoinUrlTextFB" class="d-flex align-items-center justify-content-center share-icon--event-link event-link-facebook mr-3">
                                            <i class="fab fa-facebook-f" style="color: #3258a1;"></i>
                                        </div>
                                        <div class="d-flex align-items-center justify-content-center share-icon--event-link event-link-qr mr-3" id="joinQRCodeButton">
                                            <img src="images/qr_default.png" width="15px" alt="">
                                        </div>
                                    </div>
                                </div>

                                <div class="row py-3" id='rsvpLine' style="border-bottom: 1px solid rgba(0, 0, 0, 0.08);">
                                    <div class="col col-5 d-flex flex-column">
                                        <span class="link-title">RSVP Link:</span>
                                        <span class="body-3 grey-text"> Link to share for attendees to register for your virtual event. When registration is complete, attendee receives a confirmation email along with a personal join link. </span>
                                    </div>
                                    <div class="col d-flex flex-row align-items-center justify-content-end">
                                        <a class="link-url modal-open-button btn mr-3" target="_blank" href="" id="rsvpUrlText" style="color: #666">Open in new tab</a>
                                        <a onclick="copyURI(event)" class="link-url modal-copy-button btn mr-3" target="_blank" href="" id="copyRsvpUrlText" style="color: #666">Copy link</a>
                                        <div onclick="initShareTwitter(event)" id="copyRsvpUrlTextTW" class="d-flex align-items-center justify-content-center share-icon--event-link event-link-x mr-3">
                                            <img src="images/svg/twiter-x.svg" width="15px" alt="">
                                        </div>
                                        <div onclick="initShareFacebook(event)" id="copyRsvpUrlTextFB" class="d-flex align-items-center justify-content-center share-icon--event-link event-link-facebook mr-3">
                                            <i class="fab fa-facebook-f" style="color: #3258a1;"></i>
                                        </div>
                                        <div class="d-flex align-items-center justify-content-center share-icon--event-link event-link-qr mr-3" id="rsvpQRCodeButton">
                                            <img src="images/qr_default.png" width="15px" alt="">
                                        </div>
                                    </div>
                                </div>

                                <div class="row py-3" id="partyLine" style="border-bottom: 1px solid rgba(0, 0, 0, 0.08);">
                                    <div class="col col-5 d-flex flex-column">
                                        <span class="link-title">Watch Party Link: </span>
                                        <span class="body-3 grey-text">  Link to share if attendees are joining a watch party on personal devices and watching the livestream on a big screen. Attendees can participate in all fundraising activities on their phones without the livestream playing on each device.</span>
                                    </div>
                                    <div class="col d-flex flex-row align-items-center justify-content-end">
                                        <a class="link-url modal-open-button btn mr-3" target="_blank" href="" id="partyUrlText"  style="color: #666">Open in new tab</a>
                                        <a onclick="copyURI(event)" class="link-url modal-copy-button btn mr-3" target="_blank" href="" id="copyPartyUrlText" style="color: #666">Copy link</a>
                                        <div onclick="initShareTwitter(event)" id="copyPartyUrlTextTW" class="d-flex align-items-center justify-content-center share-icon--event-link event-link-x mr-3">
                                            <img src="images/svg/twiter-x.svg" width="15px" alt="">
                                        </div>
                                        <div onclick="initShareFacebook(event)" id="copyPartyUrlTextFB" class="d-flex align-items-center justify-content-center share-icon--event-link event-link-facebook mr-3">
                                            <i class="fab fa-facebook-f" style="color: #3258a1;"></i>
                                        </div>
                                        <div class="d-flex align-items-center justify-content-center share-icon--event-link event-link-qr mr-3" id="partyQRCodeButton" >
                                            <img src="images/qr_default.png" width="15px" alt="">
                                        </div>
                                    </div>
                                </div>

                                <div class="row py-3" id="bigScreenLine" style="border-bottom: 1px solid rgba(0, 0, 0, 0.08);">
                                    <div class="col col-5 d-flex flex-column">
                                        <span class="link-title">Audience Monitor Link: </span>
                                        <span class="body-3 grey-text"> Link to share with your AV team to present the goal and all real-time bidding and pledging on a large screen to an in-person audience.</span>
                                    </div>
                                    <div class="col d-flex flex-row align-items-center justify-content-end">
                                        <a class="link-url modal-open-button btn mr-3" target="_blank" href="" id="bigScreenUrlText"   style="color: #666">Open in new tab</a>
                                        <a onclick="copyURI(event)" class="link-url modal-copy-button btn mr-3" target="_blank" href="" id="copyBigScreenUrlText" style="color: #666">Copy link</a>
                                        <div onclick="initShareTwitter(event)" id="copyBigScreenUrlTextTW" class="d-flex align-items-center justify-content-center share-icon--event-link event-link-x mr-3">
                                            <img src="images/svg/twiter-x.svg" width="15px" alt="">
                                        </div>
                                        <div onclick="initShareFacebook(event)" id="copyBigScreenUrlTextFB" class="d-flex align-items-center justify-content-center share-icon--event-link event-link-facebook mr-3">
                                            <i class="fab fa-facebook-f" style="color: #3258a1;"></i>
                                        </div>
                                        <div class="d-flex align-items-center justify-content-center share-icon--event-link event-link-qr mr-3" id="bigScreenQRCodeButton" >
                                            <img src="images/qr_default.png" width="15px" alt="">
                                        </div>
                                    </div>
                                </div>

                                <div class="row py-3 mb-4" id="eventPageLine" style="border-bottom: 1px solid rgba(0, 0, 0, 0.08);">
                                    <div class="col col-5 d-flex flex-column">
                                        <span class="link-title">Event Page Link: </span>
                                        <span class="body-3 grey-text">Link to share your customized event landing page with donors.</span>
                                    </div>
                                    <div class="col d-flex flex-row align-items-center justify-content-end">
                                        <a class="link-url modal-open-button btn mr-3" target="_blank" href="" id="eventPageUrlText"   style="color: #666">Open in new tab</a>
                                        <a onclick="copyURI(event)" class="link-url modal-copy-button btn mr-3" target="_blank" href="" id="copyEventPageUrlText" style="color: #666">Copy link</a>
                                        <div onclick="initShareTwitter(event)" id="copyEventPageUrlTextTW" class="d-flex align-items-center justify-content-center share-icon--event-link event-link-x mr-3">
                                            <img src="images/svg/twiter-x.svg" width="15px" alt="">
                                        </div>
                                        <div onclick="initShareFacebook(event)" id="copyEventPageUrlTextFB" class="d-flex align-items-center justify-content-center share-icon--event-link event-link-facebook mr-3">
                                            <i class="fab fa-facebook-f" style="color: #3258a1;"></i>
                                        </div>
                                        <div class="d-flex align-items-center justify-content-center share-icon--event-link event-link-qr mr-3" id="eventPageQRCodeButton" >
                                            <img src="images/qr_default.png" width="15px" alt="">
                                        </div>
                                    </div>
                                </div>

                            <!-- <div id='joinLine' class="justify-content-between mb-4">
                                <div id="joinQRDesc" class="d-flex">
                                    <span class="link-title mr-2">Join Link: </span>
                                    <div class="d-flex flex-column px-2">
                                        <div class="current-event-link-desc">
                                            Link to share if you want users to register and join at the same time.
                                        </div>
                                        <div class="d-flex">
                                            <a class="link-url modal-outline-button btn mr-3" target="_blank" href="" id="joinUrlText" style="color: #666">Open in new tab</a>
                                            <a onclick="copyURI(event)" class="link-url modal-outline-button btn mr-3" target="_blank" href="" id="copyJoinUrlText" style="color: #666">Copy link</a>
                                        </div>
        
                                    </div>
                                </div>
                                <div id="joinQR" class="qr-code d-flex flex-column">
                                    <div id="joinQRCode" class="d-flex">
                                        <img id="joinUrlQR" class="image qr-image" src="images/qr_default.png" style="margin: auto">
                                        <img src="images/powered_paybee.png">
                                    </div>
                                    <div class="d-flex justify-content-center">
                                        <a id="joinQRCodeButton"  class="qr-code-link campaign__action btn btn--paybee btn--outline-transparent mb-2 mt-2">
                                            <span class="cursor--pointer">Download QR code </span>
                                            <i class="fas fa-download ml-1"></i>
                                        </a>
                                    </div>
                                </div>
                            </div> -->
        
                            <!-- <div id='rsvpLine' class=" justify-content-between mb-4">
                                <div class="d-flex">
                                    <span class="link-title mr-2">RSVP Link: </span>
                                    <div class="d-flex flex-column px-2">
                                        <div class="current-event-link-desc">
                                            Link for attendees to register for the virtual event.
                                            It sends registration confirmation along with a personal join link.
                                        </div>
                                        <div class="d-flex">
                                            <a class="link-url modal-outline-button btn mr-3" target="_blank" href="" id="rsvpUrlText" style="color: #666">Open in new tab</a>
                                            <a onclick="copyURI(event)" class="link-url modal-outline-button btn mr-3" target="_blank" href="" id="copyRsvpUrlText" style="color: #666">Copy link</a>
                                        </div>
                                    </div>
                                </div>
                                <div class="qr-code d-flex flex-column">
                                    <div id="rsvpQRCode" class="d-flex">
                                        <img id="rsvpUrlQR" class="image qr-image" src="images/qr_default.png" style="margin: auto">
                                        <img src="images/powered_paybee.png">
                                    </div>
                                    <div class="d-flex justify-content-center">
                                        <a id="rsvpQRCodeButton"  class="qr-code-link campaign__action btn btn--paybee btn--outline-transparent mb-2 mt-2">
                                            <span class="cursor--pointer">Download QR code </span>
                                            <i class="fas fa-download ml-1"></i>
                                        </a>
                                    </div>
                                </div>
                            </div> -->
        
                            <!-- <div id="partyLine" class=" justify-content-between mb-4">
                                <div class="d-flex">
                                    <span class="link-title mr-2">Watch Party Join Link: </span>
                                    <div class="d-flex flex-column px-2">
                                        <div class="current-event-link-desc">
                                            If someone is joining the watch party where they are watching the video on the big screen.
                                            This link can be used for attendees to participate in the pledge drive,
                                            live auction, etc. from their phone without the video.
                                        </div>
                                        <div class="d-flex">
                                            <a class="link-url modal-outline-button btn mr-3" target="_blank" href="" id="partyUrlText" style="color: #666">Open in new tab</a>
                                            <a onclick="copyURI(event)" class="link-url modal-outline-button btn mr-3" target="_blank" href="" id="copyPartyUrlText" style="color: #666">Copy link</a>
                                        </div>
                                    </div>
                                </div>
                                <div class="qr-code d-flex flex-column">
                                    <div id="partyQRCode" class="d-flex">
                                        <img id="partyUrlQR" class="image qr-image" src="images/qr_default.png" style="margin: auto">
                                        <img src="images/powered_paybee.png">
                                    </div>
                                    <div class="d-flex justify-content-center">
                                        <a id="partyQRCodeButton"  class="qr-code-link campaign__action btn btn--paybee btn--outline-transparent mb-2 mt-2">
                                            <span class="cursor--pointer">Download QR code </span>
                                            <i class="fas fa-download ml-1"></i>
                                        </a>
                                    </div>
                                </div>
                            </div> -->
        
                            <!-- <div id="bigScreenLine" class=" justify-content-between mb-4">
                                <div class="d-flex">
                                    <span class="link-title mr-2">Big Screen Link: </span>
                                    <div class="d-flex flex-column px-2">
                                        <div class="current-event-link-desc">
                                            This link can be used to show an in-person audience on a big screen or TV.
                                            It shows real-time activity and goal line.
                                        </div>
                                        <div class="d-flex">
                                            <a class="link-url modal-outline-button btn mr-3" target="_blank" href="" id="bigScreenUrlText" style="color: #666">Open in new tab</a>
                                            <a  onclick="copyURI(event)" class="link-url modal-outline-button btn mr-3" target="_blank" href="" id="copyBigScreenUrlText" style="color: #666">Copy link</a>
                                        </div>
                                    </div>
                                </div>
                                <div class="qr-code d-flex flex-column">
                                    <div id="bigScreenQRCode" class="d-flex">
                                        <img id="bigScreenUrlQR" class="image qr-image" src="images/qr_default.png" style="margin: auto">
                                        <img src="images/powered_paybee.png">
                                    </div>
                                    <div class="d-flex justify-content-center">
                                        <a id="bigScreenQRCodeButton"  class="qr-code-link campaign__action btn btn--paybee btn--outline-transparent mb-2 mt-2">
                                            <span class="cursor--pointer">Download QR code </span>
                                            <i class="fas fa-download ml-1"></i>
                                        </a>
                                    </div>
                                </div>
                            </div> -->
        
                            <!-- <div id="eventPageLine" class=" justify-content-between mb-4">
                                <div class="d-flex">
                                    <span class="link-title mr-2">Event Page Link: </span>
                                    <div class="d-flex flex-column px-2">
                                        <div class="current-event-link-desc">
                                            Use this link to share your customized event page with donors.
                                        </div>
                                        <div class="d-flex">
                                            <a class="link-url modal-outline-button btn mr-3" target="_blank" href="" id="eventPageUrlText" style="color: #666">Open in new tab</a>
                                            <a  onclick="copyURI(event)" class="link-url modal-outline-button btn mr-3" target="_blank" href="" id="copyEventPageUrlText" style="color: #666">Copy link</a>
                                        </div>
                                    </div>
                                </div>
                                <div class="qr-code d-flex flex-column">
                                    <div id="eventPageQRCode" class="d-flex">
                                        <img id="eventPageUrlQR" class="image qr-image" src="images/qr_default.png" style="margin: auto">
                                        <img src="images/powered_paybee.png">
                                    </div>
                                    <div class="d-flex justify-content-center">
                                        <a id="eventPageQRCodeButton"  class="qr-code-link campaign__action btn btn--paybee btn--outline-transparent mb-2 mt-2">
                                            <span class="cursor--pointer">Download QR code </span>
                                            <i class="fas fa-download ml-1"></i>
                                        </a>
                                    </div>
                                </div>
                            </div> -->
                        </div>
        
                        <div id="QRCodesDownload" style="display: none">
                            <div class="row mb-2 justify-content-center">
                                <ul class="nav nav-tabs tabs-3 justify-content-center" role="tablist" style="width:100%;margin: 0px 0px 0px 0px">
                                    <li class="nav-item">
                                        <a id="displayQrSmall" class="nav-link" data-toggle="tab" role="tab">Small</a>
                                    </li>
                                    <li class="nav-item">
                                        <a id="displayQrMed" class="nav-link active" data-toggle="tab" role="tab">Medium</a>
                                    </li>
                                    <li class="nav-item">
                                        <a id="displayQrLarge" class="nav-link" data-toggle="tab" role="tab">Large</a>
                                    </li>
                                </ul>
                            </div>
                            <div id="smallQRCode" style="display: none;">
                                <div id="qr100" style="width: 172px; height: 160px; margin: auto">
                                    <div class="d-flex justify-content-center py-4" style="margin: auto;">
                                        <a style="margin: auto">
                                            <img id="image100" class="image" src="images/qr_default.png" style="margin: auto">
                                            <img src="images/powered_paybee.png">
                                        </a>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <a class="btn btn-sm modal-cancel-button dismiss-button-handler mr-3">Cancel</a>
                                    <a id="qr100Button" class="btn btn-sm modal-confirm-button">Download</a>
                                </div>
                            </div>
                            <div id="medQRCode" style="display: none;">
                                <div id="qr200" style="width: 280px; height: 260px; margin: auto;">
                                    <div class="d-flex justify-content-center py-4" style="margin: auto;">
                                        <a style="margin: auto">
                                            <img id="image200" class="image" src="images/default_qr_2x.png" style="margin: auto">
                                            <img src="images/powered_by_paybee2x.png">
                                        </a>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <a class="btn btn-sm modal-cancel-button dismiss-button-handler mr-3">Cancel</a>
                                    <a id="qr200Button" class="btn btn-sm modal-confirm-button">Download</a>
                                </div>
                            </div>
                            <div id="largeQRCode" style="display: none;">
                                <div id="qr400" style="width: 540px; height: 460px; margin: auto;">
                                    <div class="d-flex justify-content-center py-4" style="margin: auto">
                                        <a style="margin: auto">
                                            <img id="image400" class="image" src="images/qr_default4x.png" style="margin: auto">
                                            <img src="images/powered_by_paybee4x.png">
                                        </a>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <a class="btn btn-sm modal-cancel-button dismiss-button-handler mr-3">Cancel</a>
                                    <a id="qr400Button" class="btn btn-sm modal-confirm-button">Download</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    
        <div id="qrDownloadModel" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true" style="display: none;">
            <div class="modal-dialog modal-lg">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col">
                                <div class="modal-main-heading">QR Code Preview</div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="modal-sub-heading">Preview and download QR code.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body" style="background-color:white;">
                        <div class="row mb-2 justify-content-center">
                            <ul class="nav nav-tabs tabs-3 justify-content-center" role="tablist" style="width:100%;margin: 0px 0px 0px 0px">
                                <li class="nav-item">
                                    <a id="showQrSmall" class="nav-link" data-toggle="tab" role="tab">Small</a>
                                </li>
                                <li class="nav-item">
                                    <a id="showQrMed" class="nav-link active" data-toggle="tab" role="tab">Medium</a>
                                </li>
                                <li class="nav-item">
                                    <a id="showQrLarge" class="nav-link" data-toggle="tab" role="tab">Large</a>
                                </li>
                            </ul>
                        </div>
                        <div id="smallQRBlock" style="display: none;">
                            <div id="qrDownload100" class="d-flex justify-content-center">
                                
                                <div class="d-flex">
                                    <div class="row">
                                        <div class="col-12">
                                            <a>
                                                <div class="d-block w-100">
                                                    <img class="py-2 scanImg" style="width: 131px;" src="images/scan_donate_done.png">
                                                </div>
                                                <div class="d-flex">
                                                    <img id="qrImage100" class="image" src="images/qr_default.png">
                                                    <img class="pl-1 h-100" src="images/powered_paybee.png">
                                                </div>
                                            </a>
                                            <div class="row download-qrcode-url justify-content-center mt-2">
                                                <small id="donateUrl100" class="mb-1" style="color: #666"></small>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div class="modal-footer paybee-modal-footer" style="margin: 0 -1rem -1rem -1rem;">
                                <a class="btn btn-sm modal-cancel-button" data-dismiss="modal">Cancel</a>
                                <a id="qrDownload100Button" class="btn btn-sm modal-confirm-button">Download</a>
                            </div>
                        </div>
                        <div id="medQRBlock" style="display: none;">
                            <div id="qrDownload200" class="d-flex justify-content-center">
                                
                                <div class="d-flex">
                                    <div class="row">
                                        <div class="col-12">
                                            <a>
                                                <div class="d-block w-100">
                                                    <img class="py-3 w-100 scanImg" src="images/scan_donate_done2x.png">
                                                </div>
                                                <div class="d-flex">
                                                    <img id="qrImage200" class="image" src="images/default_qr_2x.png">
                                                    <img class="pl-2 h-100" src="images/powered_by_paybee2x.png">
                                                </div>
                                            </a>
                                            <div class="row download-qrcode-url justify-content-center mt-2">
                                                <h5 id="donateUrl200" class="mt-2" style="color: #666;"></h5>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
    
                            <div class="modal-footer paybee-modal-footer" style="margin: 0 -1rem -1rem -1rem;">
                                <a class="btn btn-sm modal-cancel-button" data-dismiss="modal">Cancel</a>
                                <a id="qrDownload200Button" class="btn btn-sm modal-confirm-button">Download</a>
                            </div>
                        </div>
                        <div id="largeQRBlock" style="display: none;">
                            <div id="qrDownload400" class="d-flex justify-content-center">
                                
                                <div class="d-flex">
                                    <div class="row">
                                        <div class="col-12">
                                            <a>
                                                <div class="d-block w-100">
                                                    <img class="py-3 w-100 scanImg" src="images/scan_donate_done4x.png">
                                                </div>
                                                <div class="d-flex">
                                                    <img id="qrImage400" class="image" src="images/qr_default4x.png">
                                                    <img class="pl-2 h-100" src="images/powered_by_paybee4x.png">
                                                </div>
                                            </a>
                                            <div class="row download-qrcode-url justify-content-center mt-2">
                                                <h3 id="donateUrl400" class="mt-2" style="color: #666"></h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
    
                            <div class="modal-footer paybee-modal-footer" style="margin: 0 -1rem -1rem -1rem;">
                                <a class="btn btn-sm modal-cancel-button" data-dismiss="modal">Cancel</a>
                                <a id="qrDownload400Button" class="btn btn-sm modal-confirm-button">Download</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div id="qrOptionBidDownloadModel" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true" style="display: none;">
            <div class="modal-dialog modal-lg">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col">
                                <div class="modal-main-heading">QR Code Preview</div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="modal-sub-heading">Preview and download QR code.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body" style="background-color:white;">
                        <div class="row mb-2 justify-content-center">
                            <ul class="nav nav-tabs tabs-3 justify-content-center" role="tablist" style="width:100%;margin: 0px 0px 0px 0px">
                                <li class="nav-item">
                                    <a id="showQrBidSmall" class="nav-link" data-toggle="tab" role="tab">Small</a>
                                </li>
                                <li class="nav-item">
                                    <a id="showQrBidMed" class="nav-link active" data-toggle="tab" role="tab">Medium</a>
                                </li>
                                <li class="nav-item">
                                    <a id="showQrBidLarge" class="nav-link" data-toggle="tab" role="tab">Large</a>
                                </li>
                            </ul>
                        </div>
                        <div id="smallQRBidBlock" style="display: none;">
                            <div id="qrBidDownload100" class="d-flex justify-content-center">
                                
                                <div class="d-flex">
                                    <div class="row">
                                        <div class="col-12">
                                            <a>
                                                <div class="d-block w-100">
                                                    <img class="py-1 scanImg" style="width: 131px;" src="images/scan_bid_done.png">
                                                </div>
                                                <div class="d-flex">
                                                    <img id="qrBidImage100" class="image" src="images/qr_default.png">
                                                    <img class="pl-1 h-100" src="images/powered_paybee.png">
                                                </div>
                                            </a>
                                            <div class="row download-qrcode-url justify-content-center mt-2">
                                                <small id="donateUrl100" class="mb-1" style="color: #666"></small>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div class="modal-footer paybee-modal-footer" style="margin: 0 -1rem -1rem -1rem;">
                                <a class="btn btn-sm modal-cancel-button" data-dismiss="modal">Cancel</a>
                                <a id="qrBidDownload100Button" class="btn btn-sm modal-confirm-button">Download</a>
                            </div>
                        </div>
                        <div id="medQRBidBlock" style="display: none;">
                            <div id="qrBidDownload200" class="d-flex justify-content-center">
                                
                                <div class="d-flex">
                                    <div class="row">
                                        <div class="col-12">
                                            <a>
                                                <div class="d-block w-100">
                                                    <img class="py-2 w-100 scanImg" src="images/scan_bid_done2x.png">
                                                </div>
                                                <div class="d-flex">
                                                    <img id="qrBidImage200" class="image" src="images/default_qr_2x.png">
                                                    <img class="pl-2 h-100" src="images/powered_by_paybee2x.png">
                                                </div>
                                            </a>
                                            <div class="row download-qrcode-url justify-content-center mt-2">
                                                <h5 id="donateUrl200" class="mt-2" style="color: #666;"></h5>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
    
                            <div class="modal-footer paybee-modal-footer" style="margin: 0 -1rem -1rem -1rem;">
                                <a class="btn btn-sm modal-cancel-button" data-dismiss="modal">Cancel</a>
                                <a id="qrBidDownload200Button" class="btn btn-sm modal-confirm-button">Download</a>
                            </div>
                        </div>
                        <div id="largeQRBidBlock" style="display: none;">
                            <div id="qrBidDownload400" class="d-flex justify-content-center">
                                
                                <div class="d-flex">
                                    <div class="row">
                                        <div class="col-12">
                                            <a>
                                                <div class="d-block w-100">
                                                    <img class="py-2 w-100 scanImg" src="images/scan_bid_done4x.png">
                                                </div>
                                                <div class="d-flex">
                                                    <img id="qrBidImage400" class="image" src="images/qr_default4x.png">
                                                    <img class="pl-2 h-100" src="images/powered_by_paybee4x.png">
                                                </div>
                                            </a>
                                            <div class="row download-qrcode-url justify-content-center mt-2">
                                                <h3 id="donateUrl400" class="mt-2" style="color: #666"></h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
    
                            <div class="modal-footer paybee-modal-footer" style="margin: 0 -1rem -1rem -1rem;">
                                <a class="btn btn-sm modal-cancel-button" data-dismiss="modal">Cancel</a>
                                <a id="qrBidDownload400Button" class="btn btn-sm modal-confirm-button">Download</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div id="qrOptionBuyDownloadModel" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true" style="display: none;">
            <div class="modal-dialog modal-lg">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col">
                                <div class="modal-main-heading">QR Code Preview</div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="modal-sub-heading">Preview and download QR code.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body" style="background-color:white;">
                        <div class="row mb-2 justify-content-center">
                            <ul class="nav nav-tabs tabs-3 justify-content-center" role="tablist" style="width:100%;margin: 0px 0px 0px 0px">
                                <li class="nav-item">
                                    <a id="showBuyQrSmall" class="nav-link" data-toggle="tab" role="tab">Small</a>
                                </li>
                                <li class="nav-item">
                                    <a id="showBuyQrMed" class="nav-link active" data-toggle="tab" role="tab">Medium</a>
                                </li>
                                <li class="nav-item">
                                    <a id="showBuyQrLarge" class="nav-link" data-toggle="tab" role="tab">Large</a>
                                </li>
                            </ul>
                        </div>
                        <div id="smallBuyQRBlock" style="display: none;">
                            <div id="qrBuyDownload100" class="d-flex justify-content-center">
                                
                                <div class="d-flex">
                                    <div class="row">
                                        <div class="col-12">
                                            <a>
                                                <div class="d-block w-100">
                                                    <img class="py-1 scanImg" style="width: 131px;" src="images/scan_buy_done.png">
                                                </div>
                                                <div class="d-flex">
                                                    <img id="qrBuyImage100" class="image" src="images/qr_default.png">
                                                    <img class="pl-1 h-100" src="images/powered_paybee.png">
                                                </div>
                                            </a>
                                            <div class="row download-qrcode-url justify-content-center mt-2">
                                                <small id="donateUrl100" class="mb-1" style="color: #666"></small>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div class="modal-footer paybee-modal-footer" style="margin: 0 -1rem -1rem -1rem;">
                                <a class="btn btn-sm modal-cancel-button" data-dismiss="modal">Cancel</a>
                                <a id="qrBuyDownload100Button" class="btn btn-sm modal-confirm-button">Download</a>
                            </div>
                        </div>
                        <div id="medBuyQRBlock" style="display: none;">
                            <div id="qrBuyDownload200" class="d-flex justify-content-center">
                                
                                <div class="d-flex">
                                    <div class="row">
                                        <div class="col-12">
                                            <a>
                                                <div class="d-block w-100">
                                                    <img class="py-2 w-100 scanImg" src="images/scan_buy_done2x.png">
                                                </div>
                                                <div class="d-flex">
                                                    <img id="qrBuyImage200" class="image" src="images/default_qr_2x.png">
                                                    <img class="pl-2 h-100" src="images/powered_by_paybee2x.png">
                                                </div>
                                            </a>
                                            <div class="row download-qrcode-url justify-content-center mt-2">
                                                <h5 id="donateUrl200" class="mt-2" style="color: #666;"></h5>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
    
                            <div class="modal-footer paybee-modal-footer" style="margin: 0 -1rem -1rem -1rem;">
                                <a class="btn btn-sm modal-cancel-button" data-dismiss="modal">Cancel</a>
                                <a id="qrBuyDownload200Button" class="btn btn-sm modal-confirm-button">Download</a>
                            </div>
                        </div>
                        <div id="largeBuyQRBlock" style="display: none;">
                            <div id="qrBuyDownload400" class="d-flex justify-content-center">
                                
                                <div class="d-flex">
                                    <div class="row">
                                        <div class="col-12">
                                            <a>
                                                <div class="d-block w-100">
                                                    <img class="py-2 w-100 scanImg" src="images/scan_buy_done4x.png">
                                                </div>
                                                <div class="d-flex">
                                                    <img id="qrBuyImage400" class="image" src="images/qr_default4x.png">
                                                    <img class="pl-2 h-100" src="images/powered_by_paybee4x.png">
                                                </div>
                                            </a>
                                            <div class="row download-qrcode-url justify-content-center mt-2">
                                                <h3 id="donateUrl400" class="mt-2" style="color: #666"></h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
    
                            <div class="modal-footer paybee-modal-footer" style="margin: 0 -1rem -1rem -1rem;">
                                <a class="btn btn-sm modal-cancel-button" data-dismiss="modal">Cancel</a>
                                <a id="qrBuyDownload400Button" class="btn btn-sm modal-confirm-button">Download</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
     
        <div data-html2canvas-ignore class="modal fade right" id="whatsNewModel" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-full-height" role="document">
                <div class="modal-content paybee-modal-content" style="margin-bottom: 6rem;border-top-right-radius: 0px !important;border-bottom-right-radius: 0px !important;">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col-11">
                                <p class="modal-main-heading">What&#39;s New</p>
                            </div>
                            <div class="col-1">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" class="black-text">&times;</span>
                                </button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="modal-sub-heading">
                                    Keep track of new features released.<br>
                                    Check more details at <a target="_blank" href="https://docs.paybee.io/home/paybee/product-updates">Latest Updates</a><br><br>
                                </div>
                            </div>
                        </div>
                    </div>
    
                    <div class="modal-body">
                        <div>
                            <h6 style="font-weight: 500;">Released on: July 1st, 2025</h6>
                            <h6 style="text-decoration: underline;">Private Tickets</h6>
                            Ticketing campaign can now be made private. It limits the access to purchase only to the people who has been invited. 
                            <br>
                            <b>To Enable:</b> Campaigns -> Edit Campaign  -> Ticketing Settings -> Make tickets private/invitation-only.
                            <br>
                            <b>To Invite:</b> Manage/Tickets and Guests -> Select Campaign -> Invitation tab
                            <br>
                            <br><br>
                        </div>
                        <div>
                            <h6 style="font-weight: 500;">Released on: June 6th, 2025</h6>
                            <h6 style="text-decoration: underline;">Golf Pack extension for events</h6>
                            When turned on in the event settings, guests can be assigned a starting hole and cart for the golf tournament, automatically create cart signs. 
                            <br>
                            <b>To enable:</b> Manage/Events -> Edit -> In Person Event Setting -> Golf Pack -> Enable Golf pack.
                            <br>
                            Once enabled, guest can be assigned a starting hole. 
                            <br>
                            <b>To add holes:</b> Manage/Tickets and Guests -> Select Campaign -> Golf Holes -> Create holes
                            <br>
                            <b>To assign holes:</b> Manage/Tickets and Guests -> Select Campaign -> Guest tab and assign. 
                            <br>
                            <b>To get cart sheet:</b> Manage/Events -> ... -> In Person Event Reports -> Paddle Tab.
                            <br><br>
                        </div> 
                        <div>
                            <h6 style="font-weight: 500;">Released on: April 29th, 2025</h6>
                            <h6 style="text-decoration: underline;">Silent Auction: Save Card before bidding</h6>
                            You can now enable a setting that requires bidders to log in and save a payment method (card or bank account) before placing bids in a silent auction. After the auction closes, 
                            <a href="https://docs.paybee.io/home/campaigns/silent-auction/manage-auctions#charging-auction-winners-on-their-saved-payment-methods">charge</a> 
                            all these saved cards. Find instructions you can share with donors 
                            <a href="https://docs.paybee.io/home/donors/donor-how-tos#save-payment-information-to-place-a-bid">here</a>. 
                            <br><br>
                            <h6 style="text-decoration: underline;">Manage Auction Improvements: </h6>
                            We have updated the tabs in the auction management to include paid and pending transactions, list of all auction bidders, latest bid activity. You can also now charged any saved  cards using the Bulk Checkout button found in Manage > Auctions > Pending tab.
                            <br><br>
                            <h6 style="text-decoration: underline;">Report Improvements:</h6>
                            Almost all reports now include the option to edit columns. Select the columns relevant to you and export if necessary.
                            <br><br>
                        </div> 
                        <div>
                            <h6 style="font-weight: 500;">Released on: March 26th, 2025</h6>
                            <h6 style="text-decoration: underline;">Peer to Peer Manage Improvements:</h6>
                            We have improved the reporting and pledge/milestone management. New reports include p2p details in all donation reports. Better donation and pledge reporting in Manage/Peer To Peer.
                            <br><br>
                        </div> 
                        <div>
                            <h6 style="font-weight: 500;">Released on: March 20th, 2025</h6>
                            <h6 style="text-decoration: underline;">New Campaign Type In-Kind donations:</h6>
                            This campaign type can be used by donors to record their in-kind donations and provide details like name/description, price, etc. It is especially useful for soliciting donations for the auction. All donations made for this type of campaign can be imported to Silent or Live auction campaigns. 
                            <br><br>
                            <h6 style="text-decoration: underline;">New reports and bid activity in Manage/Auctions: </h6>
                            Added bid activity, paid, pending, and bidders reports. It can be accessed for auction campaigns from Manage/Auctions, then click on the specific auction campaign.
                            <br><br>                            
                        </div> 
                        <div>
                            <h6 style="font-weight: 500;">Released on: March 1st, 2025</h6>
                            <h6 style="text-decoration: underline;">New UI for Manage functions:</h6>
                            It provides an overview of the campaign and easy access to some functions. 
                            <br><br>
                            <h6 style="text-decoration: underline;">New Ticket Types include raffle: </h6>
                            An easy way to manage raffle draw, save, and manage winners.
                            <br><br>
                            <h6 style="text-decoration: underline;">Secure text for guest  information:</h6>
                            Suitable for collecting more sensitive data like SSN, gets stored as encrypted and access is only allowed to account admins.
                            <br><br>
                            <h6 style="text-decoration: underline;">Guest/Attendee entry cutoff date:</h6>
                            You can set a cutoff date for adding attendees to a ticket for gala tickets.  It will help you avoid last-minute surprises on your guest list.
                            <br><br>
                            <h6 style="text-decoration: underline;">Display of summary on Auction grid</h6>
                            Summary of the item will be displayed on the auction item's grip for easy access. Item still needs to be clicked or tapped for more detailed description.
                            <br><br>
                        </div> 
                        <div>
                            <h6 style="font-weight: 500;">Released on: January 26th, 2025</h6>
                            <h6 style="text-decoration: underline;">New and improved Donor Experience:</h6>
                            This release includes across-the-board design improvement for donor experience for all campaign types. 
                            <br><br>
                            <h6 style="text-decoration: underline;">Page Background Color and Image:</h6>
                            You can now set the background color or image for the donor page. You can set these from the Account menu. Go to the "Donor Pages" tab to set color or image background and preview.
                            <br><br>
                            <h6 style="text-decoration: underline;">Embed Donor Pages to your website.</h6>
                            This release also includes the capability to embed donation ticketing and other campaign types to your website, in addition to the link and QR codes it already supports.
                            <br><br>
                            <h6 style="text-decoration: underline;">Party Signup updates:</h6>
                            Check-in functionality is now available via apps on both platforms. In addition to setting a specific day/time for each option, you can add bulk reminders for all party options at relative dates (for example, two days before or four hours before). 
                            <br>
                            <b>Promo Code support for Party Signup.</b>
                            <br><br>
                        </div> 
                        <div>
                            <h6 style="font-weight: 500;">Released on: October 9th, 2024</h6>
                            <h6 style="text-decoration: underline;">New PartySignup campaign:</h6>
                            Create parties, experiences or events that donors can sign up for.
                            Use this campaign to create parties, experiences or events that donors can sign up for by purchasing one or more spots. You can include event details like the start date and time, duration, event venue, event host, etc. for each party. Donor are able to sign up for multiple parties at the same time.
                            Read more <a href="https://docs.paybee.io/home/campaigns/party-sign-ups">here</a>.
                            <br><br>
                            <h6 style="text-decoration: underline;">Customizable Event Reminder:</h6>
                            Now you can create reusable templates with some predefined fields to sent as event reminder to all guests. Check it out at Manage/Tickets and Guests.
                            <br><br>
                            <h6 style="text-decoration: underline;">Donor Notes</h6>
                            You can add and keep notes to individual donors in report/donors. Go to report/dnors, click on ... and then add/see notes.
                            <br><br>
                            <h6 style="text-decoration: underline;">Merchandise Campaign report</h6>
                            Improved merchandise campaign report to select "all options" as another filter. 
                            <br><br>
                        </div> 
                        <div>
                            <h6 style="font-weight: 500;">Released on: September 25th, 2024</h6>
                            <h6 style="text-decoration: underline;">Updated merchandise campaign.</h6>
                            Added new manage/merchandise to manage the following: 
                            <ul>
                                <li>Manage promo codes.</li>
                                <li>Edit already purchased items.</li>
                                <li>Refund (refund is only allowed to users with all admin access and will need to be enabled for your account. Please reach out if you need it to be enabled).</li>
                                <li>Report for paid and pending items.</li>
                            </ul>    
                            <br>
                            This campaign type now also supports:
                            <ul>
                                <li>Start and stop date for each campaign option.</li>
                                <li>Tax collection for items if required.</li>
                            </ul>
                            <br><br>
                        </div> 
                        <div>
                            <h6 style="font-weight: 500;">Released on: August 28th, 2024</h6>
                            <h6 style="text-decoration: underline;">New Simple Audience Monitor</h6>
                            You can now configure a simple audience monitor to display the total amount raised, goal etc. Check it out at Manage/events.
                            <br><br>
                            <h6 style="text-decoration: underline;">Misc small bug fixes and improvments</h6>
                        </div>
                        <div>
                            <h6 style="font-weight: 500;">Released on: August 23rd, 2024</h6>
                            <h6 style="text-decoration: underline;">Promo Code Update</h6>
                            Added support for limiting the ticket count per redeem for promo codes in addition to number of reddems
                            <br><br>
                        </div>
                        <div>
                            <h6 style="font-weight: 500;">Released on: August 21st, 2024</h6>
                            <h6 style="text-decoration: underline;">New Campaign Type: Merchandise Campaign</h6>
                            Sell items to donors before, during, or after an event. 
                            <br>
                            This campaign is suitable for all kinds of goods to be sold to donors. An example may be t-shirts at a fundraising walk-a-thon or sandwiches and milkshakes at a food carnival.
                            <br><br>
                            Check <a target="_blank" href="https://docs.paybee.io/home/campaigns/merchandise">documentation</a> for more details. 
                            <br><br>
                        </div>
                        <div>
                            <h6 style="font-weight: 500;">Released on August 11, 2024</h6>
                            <h6 style="text-decoration: underline;">Admin user roles</h6>
                            Added support for various restricted roles for admins users. Check more details at <a target="_blank" href="https://docs.paybee.io/home/account/users#user-and-volunteer-roles">here</a>
                            <br>
                            <ul>
                                <li>Account Admin</li> 
                                <li>Campaign Manager</li>
                                <li>Event Manager</li>
                                <li>Finance Manager</li>
                            </ul>
                            <br><br>
                        </div>
                        <div>
                            <h6 style="font-weight: 500;">Released on: July 1st, 2024</h6>
                            <h6 style="text-decoration: underline;">Ticketing and Attendee Management</h6>
                            <ul>
                                <li>Ability to add attendees to the tickets before purchasing the ticket. We simplified the ticketing flow in a major way for ticket buyers to manage attendees. It allows for them to add some before buying the ticket and as well manage it after the purchase.</li>
                                <li>This can also be controlled from campaign settings using the flag "Disable guest entry before payment" under ticketing settings.</li>
                            </ul>    
                            <br>

                            <h6 style="text-decoration: underline;">Campaign Management</h6>
                            <ul>
                                <li>Added thumbnail images for every campign option. We use thumbnails to display options on smaller screens for better use of space and more aesthetic display.</li>
                                <li>You can use the option main image to generate the thumbnail automatically.</li>
                                <li>Added campaign and option summary to be used better to display the options in an optimized and clean way.</li>
                                <li>Ability to use AI to generate an automatic summary from the description.</li>
                                <li>Ability to select previously used images for any campign and options.</li>
                            </ul>
                            <br>

                            <h6 style="text-decoration: underline;">Donor Pages</h6>
                            <ul>
                                <li>We have significantly enhanced the donor pages using thumbnails, summaries, and other layout and display improvements.</li>
                                <li>All campaigns have a new layout and flow.</li>
                            </ul>
                            <br>

                            <h6 style="text-decoration: underline;">Account Management</h6>
                            New account management now allows for different account settings:
                            <ul>
                                <li>Address, phone number, and support email.</li>
                                <li>Cover fee settings allow the donors to cover both the PayBee Fee and Transaction fee or, by default, just the transaction fee.</li>
                            </ul>
                            <br>

                            Misc bug fixes and small improvements
                            <br><br>
                        </div> 
                        <div>
                            <h6 style="font-weight: 500;">Released on: May 4th, 2024</h6>
                            <h6 style="text-decoration: underline;">Email preview and custom headers for different ticket reminders. </h6>
                            We now allow you to set the header text of the email for each individual reminder along with the footer text. Also, you can see the preview of the email sent. 
                            <br>
                            Available for Event Reminder and Add Guest Reminder.
                            <br><br>

                            <h6 style="text-decoration: underline;">Added assign and preview paddle from tickets and guests</h6>
                            Paddle assignment to all guests can now be done from the guest tab in Manage/Tickets and Guests.
                            <br><br>

                            <h6 style="text-decoration: underline;">Donor Auction display improvement:</h6>
                            Header cleanup and better mobile layout.<br>
                            Item details are available even when the auction hasn't started yet.
                            <br><br>

                            <h6 style="text-decoration: underline;">Payment page improvement:</h6>
                            The new payment page layout allows easy toggling between Apple/Google Pay, card, and bank account payments. 
                            <br><br>

                            <h6 style="text-decoration: underline;">Add on donation for cart checkout and silent auction payment.</h6>
                            Add-on donations can now be added to the cart checkout, including the silent auction win payment. To enable this go to manage/all pending and use the button on the top right to enable and select the campign to be used for this purpose. 
                            <br><br>

                            Misc bug fixes and small improvements
                            <br><br>
                        </div>    
                        <div>
                            <h6 style="font-weight: 500;">Released on: March 4th, 2024</h6>
                            <h6 style="text-decoration: underline;">Better Inventory Enforcement for Tickets</h6>
                            You can now enforce inventory for tickets either across the campaign, individual options, or both. Please note when enforcing inventory for the entire campign, the count for all the options gets added, so helpful when all options point to the same kind of ticket.
                            <br><br>
                            <h6 style="text-decoration: underline;">Misc improvements and bug fixes</h6>
                            <ul>
                                <li>Additional Information and Additional Information Select can now be set for each option</li> 
                                <li>Perf. issue fixes for manage/tickets and guests. It was freezing when searched on the second page of teh result.</li>
                                <li>Basket raffle improvement to add/edit allocations from the cart.</li>
                            </ul>
                            <br><br>
                        </div>
                        <div>
                            <h6 style="font-weight: 500;">Released on: Feb 6th, 2024</h6>
                            <h6 style="text-decoration: underline;">Grid View for Ticketing Campaigns</h6>
                            This release includes a new donor view for ticketing campaigns. This is well suited for Party Signup, merchandise sales, and other simple ticketing situations with a larger number of items.
                            <br><br>
                            <h6 style="text-decoration: underline;">Misc improvements and bug fixes</h6>
                            <ul>
                                <li>Event Page image container improvements.</li> 
                                <li>Reminder tracking for ticket invitation.</li>
                                <li>Deposit destination in transfer report.</li>
                                <li>If you create your own paddles, Excel download for paddle QR Codes is excellent for mail merge.</li>
                            </ul>
                            <br><br>
                        </div>
                        <div>
                            <h6 style="font-weight: 500;">Released on: January 16th, 2024</h6>
                            <h6 style="text-decoration: underline;">New and Improved PeerToPeer</h6>
                            We have Completely revamped the PeerToPeer experience. It is now more intuitive and easier to use. Check out the documentation <a href="https://docs.paybee.io/home/campaigns/peer-to-peer">
                                here
                            </a>
                            <br><br>
                            <br><br>
                        </div>
                        <div>
                            <h6 style="font-weight: 500;">Released on: November 14th, 2023</h6>
                            <h6 style="text-decoration: underline;">Auction Slide Show</h6>
                            We have added a slide show created off any auction. It uses the images and names from the auction campign to create a slide show that is designed for the big screen. To get the URL for the auction slide show:
                            <ul>
                                <li>Go to Manage/Auctions</li> 
                                <li>Click on the auction from the list.</li>
                                <li>On the of the page, there is a link titled "Auction Slide Show". Copy and use it for the display.</li>
                            </ul>
                            <br><br>
                            <h6 style="text-decoration: underline;">Partial Cart Checkout </h6>
                            This feature enables you to select the items from the list of the donation cart. Go to reports/all pending, click on see the cart, and select the items you want to check out. 
                            <br><br>
                            <h6 style="text-decoration: underline;">Bulk image upload for Slide Show on Event Page</h6>
                            The event Page slide show section, now supports bulk uploading of images for the slide show.    
                            <br><br>
                            <br><br>
                        </div>
                        <div>
                            <h6 style="font-weight: 500;">Released on: September 20th, 2023</h6>
                            <h6 style="text-decoration: underline;">Individual Seat Assignments for tables</h6>
                            We have added support for individual seat assignments, the naming of seats, and the naming of tables. 
                            Suited for assigning seats in auditoriums, and name starting holes for golf events. 
                            It's an optional feature, and you can have a combination of tables with seat assignments and some with no assigned seating. 
                            Read more <a target="_blank" href="https://docs.paybee.io/home/events/paddles-and-table-assignments#assigning-tables">here.</a>
                            <br><br>
                            <br><br>
                        </div>
                        <div>
                            <h6 style="font-weight: 500;">Released on: Sept 4th, 2023</h6>
                            <h6 style="text-decoration: underline;">Basket Raffle.</h6>
                            We have added support for the basket raffle. It allows a ticketing campign to be set as the basket raffle and manage it from manage/tickets and guests. Also added support for drawing the winner for each basket. Buyers get asked to allocate the tickets to baskets after ticket purchase.  
                            <b>Important: There are State laws governing charity raffles. We only provide that technology to host the raffle. Please consult your state laws before hosting your raffle on PayBee.</b> 
                            <br><br>
                            <h6 style="text-decoration: underline;">Checkin Guests from the Dashboard.</h6>
                            You can now check-in guests from the PayBee dashboard. It also includes saving the card or removing the already saved card. To use this feature:
                            <ul>
                                <li>Go to Manage/Events</li>
                                <li>Click on ... next to the event and then In-Person event report.</li>
                                <li>You will see a check-in link for each attendee. </li>
                                <li>You can check in individual guests or groups together.</li> 
                            </ul>
                            <br><br>
                            <h6 style="text-decoration: underline;">Campign Image at the bottom.</h6>
                            We have added a campign image with unrestricted size. It is shown below options in the donor experience. Suitable for showing sponsors any additional information that needs to be shown to users. It is located under the general settings for the campaign. 
                            <br><br>
                            <h6 style="text-decoration: underline;">Full page Paddle: A4 size bid paddles.</h6>
                            Added a new paddle format for full-page A4 size. It can be printed double-sided on A4 size paper or on A3 and folded in the middle. Go to Manage/Events/.../In-person event report/paddles tab to try it out. 
                            <br><br>
                            <br><br>
                        </div>

                        <div>
                            <h6 style="font-weight: 500;">Released on: August 8th, 2023</h6>
                            <h6 style="text-decoration: underline;">Promo code for tickets.</h6>
                            We have added support for promo codes for all tickets. It can be configured as a percentage, fixed discount, or full complimentary. Go to manage/Tickets and Guests and the Promo Code tab to create and use it. Read more <a target="_blank" href="https://docs.paybee.io/home/guides/ticketing-and-registration-guide/tickets-and-guests#creating-and-managing-promo-discount-codes">here.</a>
                            <br><br>
                            <br><br>
                        </div>
                        <div>
                            <h6 style="font-weight: 500;">Released on: July 28th, 2023</h6>
                            <h6 style="text-decoration: underline;">Tap To Pay on Apple and Android Devices</h6>
                            PayBee app now supports Tap To Pay on iOS devices with NFC and Android. Update to the latest version of the PayBee app to use this feature for checkout at your next event. Read more <a target="_blank" href="https://docs.paybee.io/home/guides/ticketing-and-registration-guide/understanding-ticketing-on-paybee">here.</a>
                            <br><br>
                            <h6 style="text-decoration: underline;">Schedule Reminders for Event, Ticket and Pending Carts.</h6>
                            You can now schedule reminders for your events, tickets, and pending carts. Scheduling capability is included in respective pages for event reports, manage/tickets and guests, and report/all pending. 
                            <br><br>
                            <h6 style="text-decoration: underline;">New and Improved Manage/Auctions</h6>
                            New and improved design for managing your auctions. Check it out at manage/auctions.
                            <br><br>
                            <h6 style="text-decoration: underline;">New and Improved Manage/Peer To Peer</h6>
                            New and improved design for managing your PeerToPeer Campaigns. Check it out at manage/Peer2Peer. Includes features to edit fundraisers, and add new donations to the fundraisers.
                            <br><br>
                            
                            <br><br>
                        </div>
                        <div>
                            <h6 style="font-weight: 500;">Released on: June 11th, 2023</h6>
                            <h6 style="text-decoration: underline;">Combo Ticket:</h6>
                            A Combination ticket can be considered as a ticket package where multiple ticket options from the same campaign or other campaigns may be included (each of a specific quantity) along with the combination ticket option being purchased. You may choose to use the combination ticket option as an avenue of payment and include event tickets, raffle tickets, drink tickets, etc., from other campaigns or choose to use the combination ticket option as a table and include the other tickets from other campaigns.
                            <br>See more in new <a target="_blank" href="https://docs.paybee.io/home/guides/ticketing-and-registration-guide/understanding-ticketing-on-paybee">
                                 ticketing documentation. 
                            </a>
                            <br><br>
                            <h6 style="text-decoration: underline;">Bulk card checkout using a saved card:</h6>
                            Bulk checkout of multiple pending carts is available now in the in-person event report. This feature allows you to process all or selected carts using a saved card. 
                            <br><br>
                            <h6 style="text-decoration: underline;">Save cards from reminder emails for the ticketing campaign.</h6> 
                            A new setting is added to the ticketing campaign, which, if enabled, adds an additional button in the event reminder email, letting guests save their cards, which administrators can process later. Only available for ticketing campaigns connected to the in-person event and only available in the in-person event report for processing.
                            <br><br>
                            <br><br>
                        </div>
                        <div>
                            <h6 style="font-weight: 500;">Released on: May 24th, 2023</h6>
                            <h6 style="text-decoration: underline;">Donor Guest Management Improvements.</h6>
                            New and cleaned-up design for Donor Guest management.<br>
                            <br>
                            <h6 style="text-decoration: underline;">Quick Add Pledges by Paddle Number</h6>
                            The equivalent of "Add Multiple Pledges" in the PayBee app. It can be used to quickly add pledges and auction items to the donor cart using the paddle number. Available in the in-person event report.
                            <br>
                            <h6 style="text-decoration: underline;">Navigation improvements for Dashboard</h6>
                            <br>
                            <br><br><br>
                        </div>
                        <div>
                            <h6 style="font-weight: 500;">Released on: Feb 28th, 2023</h6>
                            <h6 style="text-decoration: underline;">New Description Formatting</h6>
                            1. Includes updated control to all descriptions, campaigns, Account, Events, etc., for easier text formatting.<br>
                            <br><br><br>
                        </div>
                        <div>
                            <h6 style="font-weight: 500;">Released on: January 14th, 2023</h6>
                            <h6 style="text-decoration: underline;">Annual Receipt for 2022 and Preview Receipt</h6>
                            1. Go to Reports/Donors from the left menu<br>
                            2. Select the date range on the top from January 1, 2022, to December 31, 2022.<br>
                            3. Click on the "..." next to the donor you want to see receipts for. <br>
                            4. Then click on "Preview/Send Annual Receipt..." and you will see a preview button.<br>
                            <br><br><br>
                        </div>
                        <div>
                            <h6 style="font-weight: 500;">Released on: January 7th, 2023</h6>
                            <h6 style="text-decoration: underline;">New Dashboard</h6>
                            New and improved dashboard. Please send your feedback to contact&#64;paybee.io.<br><br>
                            <h6 style="text-decoration: underline;">Report/AllDonations</h6>
                            Edit transaction now allows for updating donor email.<br><br>
                            <h6 style="text-decoration: underline;">Manage/Tickets and Guests</h6>
                            Edit tickets. Improved ticket and guest reminders.<br><br>
                            <h6 style="text-decoration: underline;">Manage/All Pending</h6>
                            Move cart and many other bugfixes and improvements.
                            <br><br><br>
                        </div>
                        <div>
                            <h6 style="font-weight: 500;">Released on: October 10h, 2022</h6>
                            <h6 style="text-decoration: underline;">Auto/Max Bid support for Silent Auction</h6>
                            Autobid/maxbid feature for Silent auctions is available for all silent auction campaigns. 
                            By default, it will be enabled for all new campaigns created. 
                            For existing campaigns, it can be switched on by editing the campaign. This setting is located under Campaign/Auction settings.
                            <br><br><br>
                        </div>
                        <div>
                            <h6 style="font-weight: 500;">Released on: September 6th, 2022</h6>
                            <h6 style="text-decoration: underline;">New paddle designs and name cards for events</h6>
                            1. Go to Manage/Events, ... and then in-person event report, select paddle tab.
                            <br><br><br>
                        </div>
                        <div>
                            <h6 style="font-weight: 500;">Released on: July 24th, 2022</h6>
                            <h6 style="text-decoration: underline;">Custom Color for Event Page</h6>
                            1. You can now copy an existing event page theme and customize the color for all sections.<br>
                            2. Go to Manage/Events and edit the event and then navigate to the Event Page Tab.<br>
                            3. Create a new theme from the existing theme and edit it to customize.<br>
                            <br>
                            <h6 style="text-decoration: underline;">Event Page Invitations</h6>
                            1. Guests can be invited to register via the event page for all event types.<br>
                            2. Go to Manage/Events, click on the ... and then Virtual or In Person event reports, select "Event Page Invitation" tab to invite one by one or upload for bulk invitations.
                            <br><br><br>
                        </div>
    
                        <div> 
                            <h6 style="font-weight: 500;">Released on: July 16th, 2022</h6> 
                            <h6 style="text-decoration: underline;">New & Improved Ticketing</h6>
                            1. New look and feel on the donor side while purchasing tickets and on your dashboard when managing tickets and guests.<br>
                            2. When adding guests to a ticket, your team and your donors can select placeholder emails if you don't have a guest's email address. You may also choose to have guests share email addresses and bidder numbers. <br>
                            3. Send ticket holders reminders to add guests to their ticket if there are empty spots on the ticket.<br>
                            4. While creating a ticketing campaign, you can decide if the tickets are to be connected to an in-person or virtual events so the appropriate fields are automatically adjusted.<br><br>
                            <h6 style="text-decoration: underline;">Videos On The Event Page</h6>
                            1. You can now embed a video from YouTube, Vimeo, Facebook or any other website with embeddable videos into your event landing page. You can also choose to include a title and description along with the video.<br><br>
                            <h6 style="text-decoration: underline;">Limited release of PayBee Low Latency Streming for Virtual and Hybrid Event:</h6>
                            You don't need to rely on third-party streaming services like YouTube or Twitch. It's a limited release for PayBee streaming, please contact us if you like to use this for your next event. It is low latency (2 seconds with most video services and sub-second latency with OBS-RTC.<br>
                            <br><br><br>
                        </div>
                        
                        <div> 
                            <h6 style="font-weight: 500;">Released on: April 26 2022</h6> 
                            <h6 style="text-decoration: underline;">Add On Donation for Ticketing campaigns</h6>
                            1. Now you can add a donation campaign to the ticketing campaign for people to add an optional donation to the ticket purchase whether it is a free or paid ticket. <br>
                            2. Edit the campaign, switch the option 'Enable Add On Donation', select a campaign and save. <br>
                            3. This option will show up after the ticket has been selected and right before the payment page for the donors.<br>
                            <h6 style="text-decoration: underline;">New Purple theme for Event Pages</h6>
                            <br><br>
                        </div>
                        <div> 
                            <h6 style="font-weight: 500;">Released on: December 30 2021</h6> 
                            <h6 style="text-decoration: underline;">Event Web Page:</h6>
                            1. When you create an event in the PayBee (all kinds), it automatically creates a barebones event page. You can customize the event page in minutes. Go to manage/events and edit the event to see it in action.
                            Find more information about event page <a target="_blank" href="https://docs.paybee.io/home/gala-settings/event-page">here</a>.
                            <br>2. Donation receipts to individual donors for 2021 can be sent from reports/donors. If you have not opted out, 2021 consolidated receipts to all donors will be sent out on 24th January.<br>                        
                            <br><br>
                        </div>
                        <div> 
                            <h6 style="font-weight: 500;">Released on: November 20 2021</h6> 
                            <h6 style="text-decoration: underline;">Silent Auction:</h6>
                            1. Silent Auction can now have items that are for Buy only. Just flip the flag called "Buy it now only Item, the bid button will not be shown" to enable it.
                            <br><br>
                        </div>
                        <div> 
                            <h6 style="font-weight: 500;">Released on: October 13 2021</h6> 
                            <h6 style="text-decoration: underline;">Campaign:</h6>
                            1. Each campaign option can have its own description.
                            <br>2. Sponsors can be added to each campaign. Once a sponsor group is created, it can be shared across many campaigns. 
                            <br>3. Old and not in use campaigns can be archived, reports will still be available, but they will not appear in various dropdowns across managing and reports, reducing clutter and confusion.
                            <br><br>
                            <h6 style="text-decoration: underline;">Donor Pages:</h6>
                            1. We have redesigned the campaign donor experience to be consistent, beautiful, and intuitive across any device size. Better controls and are even easier easy to navigate.
                            <br><br>
                            <h6 style="text-decoration: underline;">Event:</h6>
                            1. All relevant links are now available in one place. This includes event join, rsvp, big screen display, watch party join link, etc.
                            <br><br>Misc other fixes are included in the major release.
                            <br><br>
                        </div>
                        <div> 
                            <h6 style="font-weight: 500;">Released on: August 5th 2021</h6> 
                            1. Manage -> Virtual Events is now deprecated (all events can be found under Manage -> Events) <br><br>
                            2. New All Pending report is now available under Reports.<br><br>
                            3. Clean and new In-person event report.<br><br>
                            4. Buttons in the in-person and virtual reports have been updated.<br><br>
                            5. Paddle numbers of bidders/pledgers show up in Recent Activity (Auctioneer + Producer mode) and the Audience Monitor. <br><br>
                            6. Fixes and updates in All Donations reports<br><br>
                            7. Misc. other fixes and improvements. <br><br>         
                        </div>
                        <div> 
                            <h6 style="font-weight: 500;">Released on: August 30th 2021</h6> 
                            1. Added PDF download of Bid Sheet for offline silent auctions and online silent auctions. Check it out in manage/auctions, download Button on the right top.
                            2. Misc. other fixes and improvements.<br><br> 
                        </div>
                        <div> 
                            <h6 style="font-weight: 500;">Released on: August 5th 2021</h6> 
                            1. Manage -> Virtual Events is now deprecated (all events can be found under Manage -> Events) <br><br>
                            2. New All Pending report is now available under Reports.<br><br>
                            3. Clean and new In-person event report.<br><br>
                            4. Buttons in the in-person and virtual reports have been updated.<br><br>
                            5. Paddle numbers of bidders/pledgers show up in Recent Activity (Auctioneer + Producer mode) and the Audience Monitor. <br><br>
                            6. Fixes and updates in All Donations reports<br><br>
                            7. Misc. other fixes and improvements. <br><br>         
                        </div>
                        <div> 
                            <h6 style="font-weight: 500;">Released on: May 13th 2021</h6>
                            1. Added support for description for each ticket item. If added for the item will show up for ticket buyers.<br> <br>
                        </div>
                        <div> 
                            <h6 style="font-weight: 500;">Released on: May 4th 2021</h6> 
                            1. Brand new virtual event user interface. <br> <br> 
                            2. Improved chat with link recognition.  <br> <br> 
                            3. Cleaner UI where the organization content pops.<br> <br> 
                            4. Images in the full-color mode. <br> <br> 
                            5. Completely rethought experience on the phone.<br> <br> 
                            6. Separate Watch, Pledge, and Chat tabs with activity buttons so donors never miss a pledging or bidding opportunity.<br> <br> 
                            7. Enter Watch Party mode, so the video turns off. Guests will watch videos on the TV or large screen. Bidding and chat will continue on their own device.<br> <br> 
                            8. Added option to show Bid History and Top Bidder for Silent Auction.<br> <br> 
                        </div>
                        <div>
                            <h6 style="font-weight: 500;">Released on: April 7th 2021</h6> 
                            1. New UX for Virtual Event management <br> <br> 
                            2. Support for Anonymous Donations during Virtual Events. Donors choose to remain anonymous at the time they join the event. <br><br> 
                            3. Anonymous Donations can be enabled or disabled from virtual event settings. <br> <br> 
                            4. Support for explicit selection of time zone and duration of the virtual event.<br> <br> 
                            5. Support for explicit selection of time zone and duration for ticketing campaign.<br> <br>
                            6. Clone Virtual Event to create a new one with all the same settings.<br> <br> 
                            7. Misc. bug fixes and improvement throughout the platform.<br><br> 
                        </div>
                    </div>
                </div>
            </div>
        </div>
    
        <div data-html2canvas-ignore class="modal fade right" id="supportModel" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-full-height" role="document">
                
                <div class="modal-content paybee-modal-content" style="margin-bottom: 6rem;border-top-right-radius: 0px !important;border-bottom-right-radius: 0px !important;">
                    
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col-11">
                                <p class="modal-main-heading">Contact us</p>
                            </div>
                            <div class="col-1">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" class="black-text">&times;</span>
                                </button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="modal-sub-heading">
                                    The response will go out to the main email on the account. If you want us to include some other email, please mention it in the message.
                                    <br><br>You can also use the chat button below to contact us.
                                </div>
                            </div>
                        </div>                    
                    </div>
    
                    
                    <div class="modal-body">
                        <div class="text-center">
                            <div class="md-form" id="supportNameBlock">
                                <input type="text" id="supportName" class="form-control">
                                <label class="inputLabel" id="supportNameLabel" for="supportName">Your Name</label>
                            </div>
    
                            <div class="md-form" id="supportEmailBlock">
                                <input type="email" id="supportEmail" class="form-control">
                                <label class="inputLabel" id="supportEmailLabel" for="supportEmail">Your Email</label>
                            </div>
    
                            <div class="md-form">
                                <input type="text" id="supportSubject" class="form-control">
                                <label class="inputLabel" id="supportSubjectLabel" for="supportSubject">Subject</label>
                            </div>
    
                            <div class="md-form">
                                <textarea type="text" id="supportMessage" class="form-control md-textarea" style="height: 100px"></textarea>
                                <label class="inputLabel" id="supportMessageLabel" for="supportMessage">Your Message</label>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer paybee-modal-footer">
                        <button data-dismiss="modal" class="btn btn-sm modal-cancel-button waves-effect waves-light">
                            Close
                        </button> &nbsp;&nbsp;&nbsp;
                        <button id="supportSend" class="btn btn-sm modal-confirm-button waves-effect waves-light">
                            Send <i class="fas fa-paper-plane ml-1"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    
        <div data-html2canvas-ignore class="modal fade" id="subscriptionPaymentModel" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-notify modal-info modal-lg" role="document">
                <div class="modal-content paybee-modal-content paybee-modal-content-paymentModal">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col-11">
                                <div class="modal-main-heading">Payment</div>
                            </div>
                            <div class="col-1">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span type="button" aria-hidden="true" class="black-text">×</span>
                                </button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="modal-sub-heading"><b>Pending invoices</b></div>
                            </div>
                        </div>
                    </div>
    
                    
                    <div class="modal-body">
                        <div id="payNowBody">
                            <div class="text-center h5" style="padding-bottom: 20px">
                                Total Amount Due: <span id="amountDue"></span>
                            </div>
                            <div class="form-check text-center md-form" id="enableAutoPaymentBlock">
                                <input type="checkbox" class="form-check-input filled-in" id="autoPay">
                                <label  class="form-check-label" for="autoPay">Enable automatic payment in future</label>
                            </div>
                            <div id="invoiceDescBlock" style="margin-bottom:2rem">
                                <table class="table table-sm table--paybee">
                                    <thead style="background-color: #F8F9FC">
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">Title</th>
                                        <th scope="col">Description</th>
                                        <th scope="col">Amount</th>
                                    </tr>
                                    </thead>
                                    <tbody id="invoiceList">
                                    </tbody>
                                </table>
                            </div>
    
                        </div>
                        <div id="payNowDone" style="display:none">
                            <div class="row text-center" style="margin-bottom: 30px;margin-top: 30px">
                                <div class="col text-center">
                                    <div class="h5">Payment is successful!!</div>
                                </div>
                            </div>
                            <div class="row text-center">
                                <div class="col text-center">
                                    <p>Thanks!</p>
                                </div>
                            </div>
                            <div class="row text-center">
                                <div class="col text-center">
                                <button id="payNowDoneButton" onclick="$('#subscriptionPaymentModel').modal('hide');" class="btn btn-info">Done</button>
                                </div>
                            </div>
                        </div>
                        <div id="payNowNotRequired" style="display:none">
                            <div class="row text-center" style="margin-bottom: 30px;margin-top: 30px">
                                <div class="col text-center">
                                    <div class="h5">You don't have any pending payments.</div>
                                </div>
                            </div>
                            <div class="row text-center">
                                <div class="col text-center">
                                    <p> You account is in good standing! Thanks!</p>
                                </div>
                            </div>
                            <div class="row text-center">
                                <div class="col text-center">
                                    <button id="payNowNotRequiedDoneButton" onclick="$('#subscriptionPaymentModel').modal('hide');" class="btn btn-info">Done</button>
                                </div>
                            </div>
                        </div>
                        
                        <div class="row">
                            <div class="col text-right">
                                <div class="red-text" id="invoicePaymentError"></div>
                            </div>
                        </div>                    
                    </div>
                    <div class="modal-footer paybee-modal-footer">                    
                        <div class="btn-group">
                            <button
                                    id="payNowBtn"
                                    class="btn btn-sm modal-confirm-button"
                                    type="button"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false">
                                Pay Now
                            </button>
                            <div class="dropdown-menu">
                                <a class="dropdown-item" id="payNowWithCard">Pay using card</a>
                                <a class="dropdown-item" id="payNowWithBankAccount">Pay using Bank Account</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    
        <div data-html2canvas-ignore class="modal fade bottom show" id="frameModalBottomSuccess" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" style="display: none;">
            <div class="modal-dialog modal-frame modal-bottom modal-notify modal-success" role="document">
                
                <div class="modal-content">
                    
                    <div class="modal-body">
                        <div class="row px-4">
                            <a type="button" class="btn btn-success waves-effect waves-light">Got it</a>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>

        <div data-html2canvas-ignore class="modal fade" id="centralModalWarning" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-sm modal-notify modal-warning" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <p id="confirmTitle" class="heading lead"></p>
    
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true" class="white-text">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="text-center">
                            <p id="confirmMessage"></p>
                        </div>
                    </div>
    
                    <div class="modal-footer justify-content-center">
                        <a type="button" class="btn btn-sm btn-red btn-block waves-effect waves-light" style="margin: 1rem;" id="confirmYes">Sure</a>
                        <a type="button" class="btn btn-sm btn-block btn-outline-success waves-effect" style="margin: 1rem;" id="confirmCancel">Cancel</a>
                    </div>
                </div>
                
            </div>
        </div>
    
        <div data-html2canvas-ignore class="modal fade" id="sendTicketReminderModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col">
                                <div class="modal-main-heading" id="sendTicketReminderModalHeader">Send Reminder</div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div id="sendTicketReminderModalSubHeader" class="modal-sub-heading">
                                    Send reminder with checkin QR code to all ticketholders and their guests.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body custom-material-form updated-dropdown">
                        <div id="sendTicketReminderModalBodyEmpty" class="body-1 text-center">This ticket does not have any guests</div>
                        <div id="sendTicketReminderModalBody">
                            <div class="d-flex align-items-end justify-content-between mb-3">
                                <div class="d-flex align-items-end">
                                    <div id="selTempBlock_sendTicketReminderModal" class="templateSelect">
                                        <span class="body-2 mb-2 d-block" >Select Email Template</span>
                                        <select id='selectTemplate_sendTicketReminderModal' class='select-wrapper mdb-select mdb-select--paybee mb-1 w-100'>
                                        </select>
                                    </div>
                                </div>
                                <div class="d-flex flex-row">
                                    <button id="customTemplatesBtn_sendTicketReminderModal" class="btn btn-sm modal-cancel-button waves-effect waves-light caption text-nowrap align-items-center"><i class="fas fa-pencil-alt mr-2"></i>Manage Templates</button>
                                </div>
                            </div>
                            <div class="divider mb-2"></div>
                            <div id="regularTemplate_sendTicketReminderModal" >
                                <div class="position-relative">
                                    <div id="backgroundBlock_sendTicketReminderModal" class="disabled backgroundBlock" style="display: none;"></div>
                                    <div class="d-flex justify-content-between mb-2">
                                        <span class="body-2" id="default-header-ReminderMessage">
                                            Optional header in reminder emails
                                        </span>
                                        <div class=" md-accordion md-accordion--help" id="accordionExReminderMessageHeader">
                                            <div class="card card--guest z-depth-0">
                                                <div class="card-header card-header--guest p-0 d-flex align-items-center justify-content-between" id='reminderMessageHeader'>
                                                    <span class="body-2">
                                                        Optional header in reminder emails
                                                    </span>
                                                    <button
                                                        class="btn btn-sm modal-cancel-button waves-effect waves-light caption text-nowrap d-flex align-items-center"
                                                        type="button"
                                                        id='header_buttonReminderMessage'
                                                        data-toggle="collapse"
                                                        data-target="#contentReminderMessageHeader"
                                                        aria-expanded="true"
                                                        aria-controls="accordionReminderMessageHeader"
                                                    >
                                                    <img class="mr-1" src="images/svg/eye-solid.svg" style="width: 13px;">
                                                    See campaign header
                                                    </button>
                                                </div>
                                                <div id="contentReminderMessageHeader" class="collapse"
                                                    aria-labelledby="reminderMessageHeader"
                                                    data-parent="#accordionExReminderMessageHeader"
                                                >
                                                    <div class="accodion-body body-2 mt-2" id="help-ReminderMessageHeader">
                                                    </div>
                                                    <div class="d-flex">
                                                        <a id="copy-ReminderMessageHeader" 
                                                            class="blue-text body-2 mt-2 ml-auto copy-icon-btn"
                                                            class="blue-text body-2 mt-2 ml-auto copy-icon-btn"
                                                            data-toggle="tooltip-optional-header" 
                                                            data-placement="right" 
                                                            title="Copy to optional header">
                                                            <img  src="images/svg/copy-solid.svg" style="width: 13px;">
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
            
                                    </div>
                                    <div class="text-center">
                                        <div class="md-form flex-column justify-content-end align-items-end quill-normalise">
                                            <div id="reminderMessage-header" class="form-control md-textarea quill--paybee--small quill-scrollablle--small p-0">
                                            </div>
                                            <span id="ReminderMessage-headerLength"  class="character-counter character-counter-jquery"></span>
                                        </div>
                                    </div>
                                    <div class="d-flex justify-content-between mb-2">
                                        <span  class="body-2" id="default-footer-ReminderMessage">
                                            Optional footer in reminder emails
                                        </span>
            
                                        <div class=" md-accordion md-accordion--help" id="accordionExReminderMessageFooter">
                                            <div class="card card--guest z-depth-0">
                                                <div class="card-header card-header--guest p-0 d-flex align-items-center justify-content-between" id='reminderMessageFooter'>
                                                    <span class="body-2">
                                                        Optional footer in reminder emails
                                                    </span>
                                                    <button
                                                        class="btn btn-sm modal-cancel-button waves-effect waves-light caption text-nowrap d-flex align-items-center"
                                                        type="button"
                                                        id='footer_buttonReminderMessage'
                                                        data-toggle="collapse"
                                                        data-target="#contentReminderMessageFooter"
                                                        aria-expanded="true"
                                                        aria-controls="accordionReminderMessageFooter"
                                                    >
                                                    <img class="mr-1" src="images/svg/eye-solid.svg" style="width: 13px;">
                                                    See campaign footer
                                                    </button>
                                                </div>
                                                <div id="contentReminderMessageFooter" class="collapse"
                                                    aria-labelledby="reminderMessageFooter"
                                                    data-parent="#accordionExReminderMessageFooter"
                                                >
                                                    <div class="accodion-body body-2 mt-2" id="help-ReminderMessageFooter">
                                                    </div>
                                                    <div class="d-flex">
                                                        <a id="copy-ReminderMessageFooter" 
                                                            class="blue-text body-2 mt-2 ml-auto copy-icon-btn"
                                                            data-toggle="tooltip-optional-footer" 
                                                            data-placement="right" 
                                                            title="Copy to optional footer">
                                                            <img  src="images/svg/copy-solid.svg" style="width: 13px;">
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
            
                                    </div>
                                    <div class="text-center">
                                        <div class="md-form flex-column justify-content-end align-items-end quill-normalise">
                                            <div id="reminderMessage-footer" class="form-control md-textarea quill--paybee quill-scrollablle p-0" >
                                            </div>
                                            <span id="ReminderMessage-footerLength"  class="character-counter character-counter-jquery"></span>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12 mb-4">
                                        <div class="black-text custom-control custom-switch">
                                            <input type="checkbox" class="custom-control-input" id="sentTextMesCheckbox_sendTicketReminderModal">
                                            <label class="custom-control-label subtitle-1" for="sentTextMesCheckbox_sendTicketReminderModal">Send Text Message to guest(s) with phone number.</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="customTemplate_sendTicketReminderModal" style="display: none">
                            </div>
                            
                        </div>
                    </div>
                    <div id='footerBlock_sendTicketReminderModal' class="modal-footer paybee-modal-footer d-flex justify-content-between">
                        <a id="ticketReminderSendPreview" class="btn btn--paybee btn--green button waves-effect waves-light">Preview</a>
                        <div class="ml-auto">
                            <a class="btn btn-sm modal-cancel-button" data-dismiss="modal">Cancel</a>
                            <a id="ticketReminderSendBtn" class="btn btn-sm modal-confirm-button">Send</a>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
    
        <div data-html2canvas-ignore class="modal fade" id="sendTicketReminderAllModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div id="sendTicketReminderAllModal_notificationSection" class="modal-content paybee-modal-content" style="display:none;">
                </div>

                <div id="sendTicketReminderAllModal_chooseRecipientsSection" class="modal-content paybee-modal-content" style="display:none;">
                </div>

                <div id="sendTicketReminderAllModal_reminderSection" class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col">
                                <div class="modal-main-heading" id="sendTicketReminderAllModalHeader_reminder">Send Event Reminders To All</div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div id="sendTicketReminderAllModalSubHeader" class="modal-sub-heading">
                                    Send event reminders to all guests via email and text message. The reminders include guests ticket QR code and event details.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body custom-material-form updated-dropdown">
                        <div id="sendTicketReminderAllModalNotConnected" class="body-1 text-center">
                                No connected Ticket Campaign
                        </div>
                        <div id="sendTicketReminderAllModalConnected">
                            <div id="sendTicketReminderModalTemplatesRow" class="d-flex align-items-end justify-content-between mb-3">
                                <div class="d-flex align-items-end">
                                    <div id="selTempBlock_sendTicketReminderAllModal" class="templateSelect">
                                        <span class="body-2 mb-2 d-block" >Select Email Template</span>
                                        <select id='selectTemplate_sendTicketReminderAllModal' class='select-wrapper mdb-select mdb-select--paybee mb-1 w-100'>
                                        </select>
                                    </div>
                                </div>
                                <div class="d-flex flex-row">
                                    <button id="customTemplatesBtn_sendTicketReminderAllModal" class="btn btn-sm modal-cancel-button waves-effect waves-light caption text-nowrap align-items-center"><i class="fas fa-pencil-alt mr-2"></i>Manage Templates</button>
                                </div>
                            </div>
                            <div class="divider mb-2"></div>

                            <div id="regularTemplate_sendTicketReminderAllModal" >
                                <div class="position-relative">
                                    <div id="backgroundBlock_sendTicketReminderAllModal" class="disabled backgroundBlock" style="display: none;"></div>
                                    <div class="d-flex justify-content-between mb-2">
                                        <span class="body-2" id="default-header-ReminderAllMessage">
                                            Optional header in reminder emails
                                        </span>
                                        <div class=" md-accordion md-accordion--help" id="accordionExReminderAllMessageHeader">
                                            <div class="card card--guest z-depth-0">
                                                <div class="card-header card-header--guest p-0 d-flex align-items-center justify-content-between" id='reminderAllMessageHeader'>
                                                    <span class="body-2">
                                                        Optional header in reminder emails
                                                    </span>
                                                    <button
                                                        class="btn btn-sm modal-cancel-button waves-effect waves-light caption text-nowrap d-flex align-items-center"
                                                        type="button"
                                                        id='header_buttonReminderAllMessage'
                                                        data-toggle="collapse"
                                                        data-target="#contentReminderAllMessageHeader"
                                                        aria-expanded="true"
                                                        aria-controls="accordionReminderAllMessageHeader"
                                                    >
                                                    <img class="mr-1" src="images/svg/eye-solid.svg" style="width: 13px;">
                                                    See campaign header
                                                    </button>
                                                </div>
                                                <div id="contentReminderAllMessageHeader" class="collapse"
                                                    aria-labelledby="reminderAllMessageHeader"
                                                    data-parent="#accordionExReminderAllMessageHeader"
                                                >
                                                    <div class="accodion-body body-2 mt-2" id="help-ReminderAllMessageHeader">
                                                    </div>
                                                    <div class="d-flex">
                                                        <a id="copy-ReminderAllMessageHeader" 
                                                            class="blue-text body-2 mt-2 ml-auto copy-icon-btn"
                                                            data-toggle="tooltip-optional-header" 
                                                            data-placement="right" 
                                                            title="Copy to optional header">
                                                            <img  src="images/svg/copy-solid.svg" style="width: 13px;">
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
            
                                    </div>
                                    <div class="text-center">
                                        <div class="md-form flex-column justify-content-end align-items-end quill-normalise">
                                            <div id="reminderAllMessage-header" class="form-control md-textarea quill--paybee--small quill-scrollablle--small p-0">
                                            </div>
                                            <span id="ReminderAllMessage-headerLength"  class="character-counter character-counter-jquery"></span>
                                        </div>
                                    </div>
                                    <div class="d-flex justify-content-between mb-2">
                                        <span  class="body-2" id="default-footer-ReminderAllMessage">
                                            Optional footer in reminder emails
                                        </span>
                                        <div class=" md-accordion md-accordion--help" id="accordionExReminderAllMessageFooter">
                                            <div class="card card--guest z-depth-0">
                                                <div class="card-header card-header--guest p-0 d-flex align-items-center justify-content-between" id='reminderAllMessageFooter'>
                                                    <span class="body-2">
                                                        Optional footer in reminder emails
                                                    </span>
                                                    <button
                                                        class="btn btn-sm modal-cancel-button waves-effect waves-light caption text-nowrap d-flex align-items-center"
                                                        type="button"
                                                        id='footer_buttonReminderAllMessage'
                                                        data-toggle="collapse"
                                                        data-target="#contentReminderAllMessageFooter"
                                                        aria-expanded="true"
                                                        aria-controls="accordionReminderAllMessageFooter"
                                                    >
                                                    <img class="mr-1" src="images/svg/eye-solid.svg" style="width: 13px;">
                                                    See campaign footer
                                                    </button>
                                                </div>
                                                <div id="contentReminderAllMessageFooter" class="collapse"
                                                    aria-labelledby="reminderAllMessageFooter"
                                                    data-parent="#accordionExReminderAllMessageFooter"
                                                >
                                                    <div class="accodion-body body-2 mt-2" id="help-ReminderAllMessageFooter">
                                                    </div>
                                                    <div class="d-flex">
                                                        <a id="copy-ReminderAllMessageFooter" 
                                                            class="blue-text body-2 mt-2 ml-auto copy-icon-btn"
                                                            data-toggle="tooltip-optional-footer" 
                                                            data-placement="right" 
                                                            title="Copy to optional footer">
                                                            <img  src="images/svg/copy-solid.svg" style="width: 13px;">
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
            
                                    </div>
                                    <div class="text-center">
                                        <div class="md-form flex-column justify-content-end align-items-end quill-normalise">
                                            <div id="reminderAllMessage-footer" class="form-control md-textarea quill--paybee quill-scrollablle p-0">
                                            </div>
                                            <span id="ReminderAllMessage-footerLength"  class="character-counter character-counter-jquery"></span>
                                        </div>
                                    </div>                 
                                </div>
                                <div class="row">
                                    <div class="col-12 mb-4">
                                        <div class="black-text custom-control custom-switch">
                                            <input type="checkbox" class="custom-control-input" id="sentTextMesCheckbox_sendTicketReminderAllModal">
                                            <label class="custom-control-label subtitle-1" for="sentTextMesCheckbox_sendTicketReminderAllModal">Send Text Message to guest(s) with phone number.</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="customTemplate_sendTicketReminderAllModal" style="display: none">
                            </div>
                          
                        </div>
                    </div>
        
                    <div id='footerBlock_sendTicketReminderAllModal' class="modal-footer paybee-modal-footer d-flex justify-content-between">
                        <a id="ticketReminderAllPreview" class="btn btn--paybee btn--green button waves-effect waves-light">Preview</a>
                        <div class="ml-auto">
                            <a class="btn btn-sm modal-cancel-button" data-dismiss="modal">Cancel</a>
                            <a id="ticketReminderAllSendBtn" class="btn btn-sm modal-confirm-button">Send</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div data-html2canvas-ignore class="modal fade" id="sendReminderModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col">
                                <div class="modal-main-heading" id="sendReminderModalHeader">Send Reminders</div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div id="sendReminderModalSubHeader" class="modal-sub-heading">
                                    Send reminders.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body custom-material-form updated-dropdown">
                        <div id="sendReminderPresetOptionListWrapper">
                            <div _ngcontent-ng-c36452053="" class="text-left" style="color: #757575; font-size: 0.8rem;">Select Party</div>
                            <fieldset id="sendReminderPresetOptionListFS" class="form-group noMargin mb-3 caret-up"></fieldset>
                        </div>
                        <div id="customTemplateHeader_sendReminderModal">
                            <div class="d-flex align-items-end justify-content-between mb-3">
                                <div class="d-flex align-items-end">
                                    <div id="selTempBlock_sendReminder" class="templateSelect">
                                        <span class="body-2 mb-2 d-block" >Select Email Template</span>
                                        <select id='selectTemplate_sendReminderModal' class='select-wrapper mdb-select mdb-select--paybee mb-1 w-100'>
                                        </select>
                                        <div 
                                        id="sendAllBiddersReminder_noTemplateSelectedErrorMessage"
                                        style="display:none; position:relative !important; white-space: nowrap;"
                                        class="form-fill-error ml-1"
                                    >
                                        No Template Selected. Please Select A Template Or Create One
                                    </div>
                                    </div>
                                </div>
                                <div class="d-flex flex-row">
                                    <button id="customTemplatesBtn_sendReminderModal" class="btn btn-sm modal-cancel-button waves-effect waves-light caption text-nowrap align-items-center"><i class="fas fa-pencil-alt mr-2"></i>Manage Templates</button>
                                </div>
                            </div>
                            <div class="divider mb-2"></div>
                        </div>
                        <div id="regularTemplate_sendReminderModal" >
                            <div class="position-relative">
                                <div id="backgroundBlock_sendReminderModal" class="disabled backgroundBlock" style="display: none;"></div>
                                <div class="d-flex justify-content-between mb-2">
                                    <span class="body-2" id="default-header-SendReminder">
                                        Optional header in reminder emails
                                    </span>        
                                </div>
                                <div class="text-center">
                                    <div class="md-form flex-column justify-content-end align-items-end quill-normalise">
                                        <div id="sendReminder-header" class="form-control md-textarea quill--paybee--small quill-scrollablle--small p-0">
                                        </div>
                                        <span id="SendReminder-headerLength"  class="character-counter character-counter-jquery"></span>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-between mb-2">
                                    <span  class="body-2" id="default-footer-SendReminder">
                                        Optional footer in reminder emails
                                    </span>
                                </div>
                                <div class="text-center">
                                    <div class="md-form flex-column justify-content-end align-items-end quill-normalise">
                                        <div id="sendReminder-footer" class="form-control md-textarea quill--paybee quill-scrollablle p-0">
                                        </div>
                                        <span id="SendReminder-footerLength"  class="character-counter character-counter-jquery"></span>
                                    </div>
                                </div>
                            </div>
                            <div class="row" id="sendReminder-sendTextWrapper">
                                <div class="col-12 mb-4">
                                    <div class="black-text custom-control custom-switch">
                                        <input type="checkbox" class="custom-control-input" id="sendReminder-sendText">
                                        <label class="custom-control-label subtitle-1" for="sendReminder-sendText">Send Text Message to guest(s) with phone number.</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="customTemplate_sendReminderModal" style="display: none">
                        </div>
                    </div>
        
                    <div id='footerBlock_sendReminderModal' class="modal-footer paybee-modal-footer d-flex justify-content-between">
                        <a id="sendReminderPreviewBtn" class="btn btn--paybee btn--green button waves-effect waves-light">Preview</a>
                        <div class="ml-auto">
                            <a class="btn btn-sm modal-cancel-button" data-dismiss="modal">Cancel</a>
                            <a id="sendReminderSendBtn" class="btn btn-sm modal-confirm-button">Send</a>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>

        <div data-html2canvas-ignore class="modal fade" id="merchandiseItemRefund" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col">
                                <div class="modal-main-heading">Refunding An Item</div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div id="merchandiseItemRefundSubheader" class="modal-sub-heading"></div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body custom-material-form updated-dropdown pt-0">
                        <div class="d-flex body-2 mb-2">
                            Are you sure you want to issue a refund of $<span id="merchandiseItemRefundAmount"></span>?
                        </div>
                        <div class="d-flex body-2">
                            Some things to note:
                        </div>
                        <div class="ml-2 body-2">
                            - Although sooner in most cases, it may take up to 5-10 days to reach the donor's account.
                        </div>
                        <div class="ml-2 body-2">
                            - Fees are never refunded so this will be deducted from your organization's account.
                        </div>
                        <div class="ml-2 mb-2 body-2">
                            - If your organization's current balance is negative after the refund, the equivalent amount will be pulled from your credit card/bank account.
                        </div>
                        <div class="d-flex justify-content-between mb-2">
                            <span class="body-2">
                                Refund Reason (optional)
                            </span>
                        </div>
                        <div class="text-center">
                            <div class="md-form flex-column justify-content-end align-items-end">
                                <div id="merchandiseItemRefundMessage-header" class="form-control md-textarea quill--paybee--small quill-scrollablle--small">
                                </div>
                                <span id="merchandiseItemRefundMessage-headerLength"  class="character-counter character-counter-jquery"></span>
                            </div>
                        </div>
                    </div>
    
                    <div class="modal-footer paybee-modal-footer d-flex justify-content-end">
                        <div class="ml-auto">
                            <a class="btn btn-sm modal-cancel-button" data-dismiss="modal">Cancel</a>
                            <a id="merchandiseItemRefundProceed" class="btn btn-sm modal-confirm-button">Proceed</a>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>

        <div
            data-html2canvas-ignore
            data-module='scheduleTaskList'
            data-modal="scheduleReminder"
            class="modal fade"
            id="scheduleReminderModal"
            tabindex="-1"
            role="dialog"
            aria-hidden="true"
        >
            <div class="modal-dialog modal-lg" role="document">
                <div id="scheduleReminderModal_notificationSection" class="modal-content paybee-modal-content" style="display:none;">
                </div>

                <div id="scheduleReminderModal_chooseRecipientsSection" class="modal-content paybee-modal-content" style="display:none;">
                </div>

                <div id="scheduleReminderModal_reminderSection" class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col-12 d-flex align-items-center justify-content-between mb-1">
                                <div id="scheduleReminderModalHeader_reminder" class="modal-main-heading mb-0">Schedule Reminders</div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div id="scheduleReminderModalSubHeader" class="modal-sub-heading"></div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body custom-material-form updated-dropdown">
                        <div id="customTemplateHeader_scheduleReminderModal" class="d-flex align-items-end justify-content-between mb-3">
                            <div class="d-flex align-items-end">
                                <div id="selTempBlock_scheduleReminderModal" class="templateSelect">
                                    <span class="body-2 mb-2 d-block" >Select Email Template</span>
                                    <select id='selectTemplate_scheduleReminderModal' class='select-wrapper mdb-select mdb-select--paybee mb-1 w-100'>
                                    </select>
                                    <div 
                                        id="scheduleAllBiddersReminder_noTemplateSelectedErrorMessage"
                                        style="display:none; position:relative !important; white-space: nowrap;"
                                        class="form-fill-error ml-1"
                                    >
                                        No Template Selected. Please Select A Template Or Create One
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex flex-row">
                                <button id="customTemplatesBtn_scheduleReminderModal" class="btn btn-sm modal-cancel-button waves-effect waves-light caption text-nowrap align-items-center"><i class="fas fa-pencil-alt mr-2"></i>Manage Templates</button>
                            </div>
                        </div>
                        <div id="regularTemplate_scheduleReminderModal" class="row">
                            <div id="scheduleReminderTypeBlock" class="col-12 d-none">
                                <fieldset id="scheduleReminderTypeListFS" class="form-group noMargin mb-3 caret-up"></fieldset>
                            </div>
                            <div class="col-12 d-none">
                                <fieldset id="scheduleReminderTaskTypeListFS" class="form-group noMargin mb-3 caret-up"></fieldset>
                            </div>
                            <div id="scheduleReminderPresetOptionListBlock" class="col-12 d-none">
                                <fieldset id="scheduleReminderPresetOptionListFS" class="form-group noMargin mb-3 caret-up"></fieldset>
                            </div>
                            <div id="scheduleReminderCustomDateTime" class="d-block w-100">
                                <div class="col-12 d-flex">
                                    <div class="col-6 pl-0">
                                        <div class="md-form">
                                            <input placeholder="Scheduled Date" type="text" id="scheduleReminderDate" class="form-control datepicker" style="cursor: pointer;">
                                            <label id="scheduleReminderDateLabel" for="scheduleReminderDate" class="active">Scheduled Date</label>
                                            <i class="far fa-calendar-alt calendar-icon--paybee" onclick="document.getElementById('scheduleReminderDate').focus()" style="cursor:pointer"></i>
                                        </div>
                                    </div>
                                    <div class="col-6 pr-0">
                                        <div class="md-form">
                                            <input placeholder="Scheduled Time" type="text" id="scheduleReminderTime" class="form-control timepicker" style="cursor: pointer;">
                                            <label id="scheduleReminderTimeLabel" for="scheduleReminderTime" class="active">Scheduled Time</label>
                                            <i class="far fa-clock calendar-icon--paybee" onclick="document.getElementById('scheduleReminderTime').focus()" style="cursor:pointer"></i>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-12">
                                    <fieldset id="scheduleReminderTimeZoneFS" class="form-group noMargin">
                                    </fieldset>
                                </div>
                            </div>
                            <div id="scheduleReminderScheduleForBlock" class="col-12 d-none">
                                <fieldset id="scheduleReminderScheduleForListFS" class="form-group noMargin mb-3 caret-up"></fieldset>
                            </div>
                            <div id="scheduleReminder_QuillsContainer" class="position-relative w-100">
                                <div id="backgroundBlock_scheduleReminderModal" class="disabled backgroundBlock" style="display: none;"></div>
                                <div class="col-12">
                                    <!-- header -->
                                    <div id="scheduleReminderHeaderDiv">
                                        <div class="d-flex justify-content-between mb-2">
                                            <span class="body-2"  id="default-header-scheduleReminderMessage">
                                                Optional header in reminder emails
                                            </span>
                                            <div class=" md-accordion md-accordion--help" id="accordionExscheduleReminderMessageHeader">
                                                <div class="card card--guest z-depth-0">
                                                    <div class="card-header card-header--guest p-0 d-flex align-items-center justify-content-between" id='scheduleReminderMessageHeader'>
                                                        <span class="body-2">
                                                            Optional header in reminder emails
                                                        </span>
                                                        <button
                                                            class="btn btn-sm modal-cancel-button waves-effect waves-light caption text-nowrap d-flex align-items-center"
                                                            type="button"
                                                            id='header_buttonscheduleReminderMessage'
                                                            data-toggle="collapse"
                                                            data-target="#contentscheduleReminderMessageHeader"
                                                            aria-expanded="true"
                                                            aria-controls="accordionscheduleReminderMessageHeader"
                                                        >
                                                        <img class="mr-1" src="images/svg/eye-solid.svg" style="width: 13px;">
                                                        See campaign header
                                                        </button>
                                                    </div>
                                                    <div id="contentscheduleReminderMessageHeader" class="collapse"
                                                        aria-labelledby="scheduleReminderMessageHeader"
                                                        data-parent="#accordionExscheduleReminderMessageHeader"
                                                    >
                                                        <div class="accodion-body body-2 mt-2" id="help-scheduleReminderMessageHeader">
                                                        </div>
                                                        <div class="d-flex">
                                                            <a id="copy-scheduleReminderMessageHeader" 
                                                            class="blue-text body-2 mt-2 ml-auto copy-icon-btn"
                                                            data-toggle="tooltip-optional-header" 
                                                            data-placement="right" 
                                                            title="Copy to optional header">
                                                                <img  src="images/svg/copy-solid.svg" style="width: 13px;">
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="text-center">
                                            <div class="md-form flex-column justify-content-end align-items-end">
                                                <div id="scheduleReminderMessage-header" class="form-control md-textarea quill--paybee--small quill-scrollablle--small">
                                                </div>
                                                <span id="scheduleReminderMessage-headerLength"  class="character-counter character-counter-jquery"></span>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- footer -->
                                        <div id="scheduleReminderFooterDiv">
                                        <div class="d-flex justify-content-between mb-2">
                                            <span  class="body-2" id="default-footer-scheduleReminderMessage">
                                                Optional footer in reminder emails
                                            </span>
                                            <div class=" md-accordion md-accordion--help" id="accordionExscheduleReminderMessageFooter">
                                                <div class="card card--guest z-depth-0">
                                                    <div class="card-header card-header--guest p-0 d-flex align-items-center justify-content-between" id='scheduleReminderMessageFooter'>
                                                        <span class="body-2">
                                                            Optional footer in reminder emails
                                                        </span>
                                                        <button
                                                            class="btn btn-sm modal-cancel-button waves-effect waves-light caption text-nowrap d-flex align-items-center"
                                                            type="button"
                                                            id='footer_buttonscheduleReminderMessage'
                                                            data-toggle="collapse"
                                                            data-target="#contentscheduleReminderMessageFooter"
                                                            aria-expanded="true"
                                                            aria-controls="accordionscheduleReminderMessageFooter"
                                                        >
                                                        <img class="mr-1" src="images/svg/eye-solid.svg" style="width: 13px;">
                                                        See campaign footer
                                                        </button>
                                                    </div>
                                                    <div id="contentscheduleReminderMessageFooter" class="collapse"
                                                        aria-labelledby="scheduleReminderMessageFooter"
                                                        data-parent="#accordionExscheduleReminderMessageFooter"
                                                    >
                                                        <div class="accodion-body body-2 mt-2" id="help-scheduleReminderMessageFooter">
                                                        </div>
                                                        <div class="d-flex">
                                                            <a id="copy-scheduleReminderMessageFooter" 
                                                                class="blue-text body-2 mt-2 ml-auto copy-icon-btn"
                                                                data-toggle="tooltip-optional-footer" 
                                                                data-placement="right" 
                                                                title="Copy to optional footer">
                                                                <img  src="images/svg/copy-solid.svg" style="width: 13px;">
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                
                                        </div>
                                        <div class="text-center">
                                            <div class="md-form flex-column justify-content-end align-items-end">
                                                <div id="scheduleReminderMessage-footer" class="form-control md-textarea quill--paybee quill-scrollablle">
                                                </div>
                                                <span id="scheduleReminderMessage-footerLength"  class="character-counter character-counter-jquery"></span>
                                            </div>
                                        </div>
                                        </div>

                                        <!-- optional message -->
                                        <div id="scheduleReminderOptionalMessageDiv">
                                        <div>
                                            <label class="body-2">
                                                Add optional message to email
                                            </label>
    
                                            <div class=" md-accordion md-accordion--help" id="accordionExscheduleReminderOptionalMessage">
                                                <div class="card card--guest z-depth-0">
                                                    <div id="contentscheduleReminderMessageFooter" class="collapse"
                                                        aria-labelledby="scheduleReminderOptionalMessage"
                                                        data-parent="#accordionExscheduleReminderMessageFooter"
                                                    >
                                                        <div class="accodion-body body-2 mt-2" id="help-scheduleReminderOptionalMessage">
                                                        </div>
                                                        <div class="d-flex">
                                                            <a id="copy-scheduleReminderOptionalMessage" 
                                                                class="blue-text body-2 mt-2 ml-auto copy-icon-btn"
                                                                data-toggle="tooltip-optional-footer" 
                                                                data-placement="right" 
                                                                title="Copy to optional footer">
                                                                <img  src="images/svg/copy-solid.svg" style="width: 13px;">
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="text-center">
                                            <div class="md-form flex-column justify-content-end align-items-end">
                                                <div id="scheduleReminder-optionalMessage" class="form-control md-textarea quill--paybee quill-scrollablle">
                                                </div>
                                                <span id="scheduleReminder-optionalMessageLength"  class="character-counter character-counter-jquery"></span>
                                            </div>
                                        </div>
                                        </div>
                                </div>
                            </div>

                            <div class="col-12 mt-3" id="scheduleReminderMessage-sendTextWrapper">
                                <div class="black-text custom-control custom-switch">
                                    <input type="checkbox" class="custom-control-input" id="scheduleReminderMessage-sendText">
                                    <label class="custom-control-label subtitle-1" for="scheduleReminderMessage-sendText">Send Text Message to guest(s) with phone number.</label>
                                </div>
                            </div>
                        </div>
                        <div id="customTemplate_scheduleReminderModal" style="display: none">
                        </div>
                    </div>
                    <div id="footerBlock_scheduleReminderModal" class="modal-footer paybee-modal-footer d-flex justify-content-between">
                        <a id="scheduleReminderMessagePreview" data-action="addTaskPreview" class="btn btn--paybee btn--green button waves-effect waves-light" style="display: none;">Preview</a>
                        <div class="ml-auto">
                            <a class="btn btn-sm modal-cancel-button" data-action="addTaskCancel">Cancel</a>
                            <a class="btn btn-sm modal-confirm-button" data-action="addTaskCreate">Schedule Reminder</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div
            data-html2canvas-ignore
            data-module='scheduleTaskList'
            data-modal="scheduleRecurringReminder"
            class="modal fade"
            id="scheduleRecurringReminderModal"
            tabindex="-1"
            role="dialog"
            aria-hidden="true"
        >
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col-12 d-flex align-items-center justify-content-between mb-1">
                                <div id="scheduleRecurringReminderHeader" class="modal-main-heading mb-0">Schedule Recurring Reminders</div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div id="scheduleRecurringReminderSubheader" class="modal-sub-heading"></div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body custom-material-form updated-dropdown">
                        <div class="row">
                            <div class="col-6">
                                <div class="md-form">
                                    <input placeholder="Start Date" type="text" id="scheduleRecurringReminderStartDate" class="form-control datepicker" style="cursor: pointer;">
                                    <label for="scheduleRecurringReminderDate" class="active">Start Date</label>
                                    <i class="far fa-calendar-alt calendar-icon--paybee" onclick="document.getElementById('scheduleRecurringReminderDate').focus()" style="cursor:pointer"></i>
                                </div>
                            </div>
                            
                            <div class="col-6">
                                <div class="md-form">
                                    <input placeholder="End Date" type="text" id="scheduleRecurringReminderEndDate" class="form-control datepicker" style="cursor: pointer;">
                                    <label for="scheduleRecurringReminderEndDate" class="active">End Date</label>
                                    <i class="far fa-calendar-alt calendar-icon--paybee" onclick="document.getElementById('scheduleRecurringReminderEndDate').focus()" style="cursor:pointer"></i>
                                </div>
                            </div>

                            <div class="col-12">
                                <div class="md-form">
                                    <input placeholder="Time" type="text" id="scheduleRecurringReminderScheduleTime" class="form-control timepicker" style="cursor: pointer;">
                                    <label for="scheduleRecurringReminderTime" class="active">Schedule Time</label>
                                    <i class="far fa-clock calendar-icon--paybee" onclick="document.getElementById('scheduleRecurringReminderTime').focus()" style="cursor:pointer"></i>
                                </div>
                            </div>
                            
                            <div class="col-6">
                                <span class="body-2">Schedule Day</span>
                                <fieldset id="scheduleRecurringReminderDayFS" class="form-group noMargin">
                                </fieldset>
                            </div>

                            <div class="col-6">
                                <span class="body-2">Time Zone</span>
                                <fieldset id="scheduleRecurringReminderTimeZoneFS" class="form-group noMargin">
                                </fieldset>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer paybee-modal-footer">
                        <a class="btn btn-sm modal-cancel-button" data-action="addTaskCancel">Cancel</a>
                        <a class="btn btn-sm modal-confirm-button" data-action="addTaskCreate">Schedule Reminder</a>
                    </div>
                </div>
            </div>
        </div>

        <div
            data-html2canvas-ignore
            class="modal fade"
            id="savePromoCodeModal"
            tabindex="-1"
            role="dialog"
            aria-hidden="true"
        >
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col-12 d-flex align-items-center justify-content-between mb-1">
                                <div id="createPromoCodeHeader" class="modal-main-heading mb-0">Promo Code</div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div id="createPromoCodeSubheader" class="modal-sub-heading"></div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body custom-material-form updated-dropdown">
                        <div class="row">
                            <div class="col-8">
                                <div class="md-form mb-2" style="margin-bottom: 8px !important;">
                                    <input type="text" id="promoCodeName" class="form-control validate">
                                    <label class="inputLabel" id="promoCodeNameLabel" data-error="Empty Name" for="promoCodeName">Promo Name</label>
                                </div>
                                <span id="promoCodeNameLength"  class="character-counter character-counter-jquery character-counter-jquery--field">0/48</span>
                                <div class="mat-form-field-description mb-5 pr-5" style="padding-left: 10px !important">
                                    <div class="opacity-50" style="opacity: 0.5;">Shown to the buyers</div>
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="md-form mb-2" style="margin-bottom: 8px !important;">
                                    <input type="text" id="promoCodePrefix" class="form-control validate">
                                    <label class="inputLabel" id="promoCodePrefixLabel" data-error="Empty Prefix" for="promoCodePrefix">Promo Code Prefix</label>
                                </div>
                                <span id="promoCodePrefixLength"  class="character-counter character-counter-jquery character-counter-jquery--field">0/12</span>
                                <div class="mat-form-field-description mb-5 pr-5" style="padding-left: 10px !important">
                                    <div class="opacity-50" style="opacity: 0.5;">Shown to the buyers</div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <fieldset id="promoCodeOptionListFS" class="form-group noMargin caret-up" style="margin-bottom: 2rem;">
                                </fieldset>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <fieldset id="promoCodeTypeListFS" class="form-group noMargin caret-up" style="margin-bottom: 2rem;">
                                </fieldset>
                            </div>
                        </div>
                        <div class="row d-block" id="amountValueBlock">
                            <div class="col-12">
                                <div class="md-form">
                                    <input
                                        type="text"
                                        pattern="^\$\d{1,3}(,\d{3})*(\.\d+)?$"
                                        value=""
                                        inputmode="decimal"
                                        data-type="currency"
                                        max="400000"
                                        min="0"
                                        step="0.1"
                                        id="promoCodeAmountValue"
                                        required
                                        class="form-control validate"
                                    >
                                    <label class="inputLabel active" id="promoCodeAmountValueLabel" data-error="Empty Amount Value" for="promoCodeAmountValue">Fixed Amount</label>
                                </div>
                            </div>
                        </div>
                        <div class="row d-none" id="percentValueBlock">
                            <div class="col-12">
                                <div class="md-form">
                                    <input
                                        type="text"
                                        pattern="^\d{1,3}(,\d{3})*(\.\d+)?%$"
                                        value=""
                                        inputmode="decimal"
                                        data-type="percent"
                                        max="400000"
                                        min="0"
                                        step="0.1"
                                        id="promoCodePercentValue"
                                        required
                                        class="form-control validate"
                                    >
                                    <label class="inputLabel active" id="promoCodePercentValueLabel" data-error="Empty Percent Value" for="promoCodePercentValue">Percent</label>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-4">
                            <div class="col-6">
                                <div class="md-form">
                                    <input placeholder="Start Date" type="text" id="promoCodeValidForm" class="form-control datepicker" style="cursor: pointer;">
                                    <label id="promoCodeValidFormLabel" for="promoCodeValidForm" class="active">Start Date</label>
                                    <i class="far fa-calendar-alt calendar-icon--paybee" onclick="document.getElementById('promoCodeValidForm').focus()" style="cursor:pointer"></i>
                                </div>
                                <div id="promoCodeValidFormError" class="md-form__error caption mt-n4 red-text" style="padding:0px 10px;"></div>
                            </div>
                            <div class="col-6">
                                <div class="md-form">
                                    <input placeholder="End Date" type="text" id="promoCodeValidTill" class="form-control datepicker" style="cursor: pointer;">
                                    <label id="promoCodeValidTillLabel" for="promoCodeValidTill" class="active">End Date</label>
                                    <i class="far fa-calendar-alt calendar-icon--paybee" onclick="document.getElementById('promoCodeValidTill').focus()" style="cursor:pointer"></i>
                                </div>
                                <div id="promoCodeValidTillError" class="md-form__error caption mt-n4 red-text" style="padding:0px 10px;"></div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <div class="md-form">
                                    <input
                                        type="number"
                                        pattern="^\d{1,3}(,\d{3})*(\.\d+)?$"
                                        inputmode="decimal"
                                        data-type="number"
                                        max="10000"
                                        min="0"
                                        step="1"
                                        id="promoCodeQuantity"
                                        required
                                        class="form-control validate"
                                    >
                                    <label class="inputLabel" id="promoCodeQuantityLabel" data-error="Empty Max Redeems" for="promoCodeQuantity">Max Redeems</label>
                                </div>
                            </div>
                        </div>
                        <div class="row" id="promoCodeMaxItemCountPerTransactionBlock">
                            <div class="col-12">
                                <div class="md-form d-flex align-items-center justify-content-center w-100">
                                    <input
                                        type="number"
                                        pattern="^\d{1,3}(,\d{3})*(\.\d+)?$"
                                        inputmode="decimal"
                                        data-type="number"
                                        max="10000"
                                        min="0"
                                        step="1"
                                        id="promoCodeMaxItemCountPerTransaction"
                                        required
                                        class="form-control validate mb-0"
                                    >
                                    <label class="inputLabel" id="promoCodeMaxItemCountPerTransactionLabel" data-error="Empty Max Item Count Per Transaction" for="promoCodeMaxItemCountPerTransaction">Max Item Count Per Transaction</label>
                                    <i data-toggle="tooltip" data-placement="top" title="" class="blue-text far fa-question-circle cursor--pointer ml-2" data-original-title="Add the maximum number of tickets per transaction where the discounted price applies. Buyers can purchase more that this quantity if tickets are available but the remaining tickets will be sold at the original price."></i>
                                </div>
                                <div class="mat-form-field-description pr-5" style="padding-left: 10px !important;">
                                    <div class="opacity-50" style="opacity: 0.5;">Note: This can only be set when one ticket option is selected</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer paybee-modal-footer">
                        <a class="btn btn-sm modal-cancel-button" id="savePromoCodeCancel">Cancel</a>
                        <a class="btn btn-sm modal-confirm-button" id="savePromoCodeConfirm">Save</a>
                    </div>
                </div>
            </div>
        </div>

        <div
            data-html2canvas-ignore
            class="modal fade"
            id="promoCodeDetailsModal"
            tabindex="-1"
            role="dialog"
            aria-hidden="true"
        >
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col-12 d-flex align-items-center justify-content-between mb-1">
                                <div id="promoCodeDetailsHeader" class="modal-main-heading mb-0"></div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div id="promoCodeDetailsSubheader" class="modal-sub-heading"></div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body custom-material-form updated-dropdown">
                        <ul class="nav nav-tabs md-tabs md-tabs--paybee md-tabs__bottom-border p-0" role="tablist">
                            <li class="nav-item">
                                <a class="nav-link active" id="recurringDetailsTabNav" data-toggle="tab" href="#promoCodeDetailsTab" role="tab" aria-controls="promoCodeDetailsTab"
                                   aria-selected="true">Details</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" id="recurringTransactionsTabNav" data-toggle="tab" href="#promoCodeTransactionsTab" role="tab" aria-controls="promoCodeTransactionsTab"
                                   aria-selected="false">Transactions</a>
                            </li>
                        </ul>
                        <div class="tab-content pt-4">
                            <div class="tab-pane fade show active" id="promoCodeDetailsTab" role="tabpanel" aria-labelledby="promoCodeDetailsTabNav">
                                <div class="row">
                                    <div class="col-6">
                                        <div class="row">
                                            <div id="promoCodeDetailsPrefixBlock" class="col-12 d-none align-items-center justify-content-between border__bottom py-3">
                                                <div class="subtitle-2 black-text">Code Prefix</div>
                                                <div id="promoCodeDetailsPrefix" class="body-1 grey-text"></div>
                                            </div>
                                            <div class="col-12 d-flex align-items-center justify-content-between border__bottom py-3">
                                                <div class="subtitle-2 black-text">Options</div>
                                                <div id="promoCodeDetailsOptions" class="body-1 grey-text text-justify pl-4"></div>
                                            </div>
                                            <div class="col-12 d-flex align-items-center justify-content-between border__bottom py-3">
                                                <div class="subtitle-2 black-text">Promo Type</div>
                                                <div id="promoCodeDetailsType" class="body-1 grey-text"></div>
                                            </div>
                                            <div id="promoCodeDetailsAmountBlock" class="col-12 d-none align-items-center justify-content-between border__bottom py-3">
                                                <div class="subtitle-2 black-text">Amount</div>
                                                <div id="promoCodeDetailsAmount" class="body-1 grey-text"></div>
                                            </div>
                                            <div id="promoCodeDetailsPercentageBlock" class="col-12 d-none align-items-center justify-content-between border__bottom py-3">
                                                <div class="subtitle-2 black-text">Percentage</div>
                                                <div id="promoCodeDetailsPercentage" class="body-1 grey-text"></div>
                                            </div>
                                            <div class="col-12 d-flex align-items-center justify-content-between border__bottom py-3">
                                                <div class="subtitle-2 black-text">Start Date</div>
                                                <div id="promoCodeDetailsStartDate" class="body-1 grey-text"></div>
                                            </div>
                                            <div class="col-12 d-flex align-items-center justify-content-between border__bottom py-3">
                                                <div class="subtitle-2 black-text">End Date</div>
                                                <div id="promoCodeDetailsEndDate" class="body-1 grey-text"></div>
                                            </div>
                                            <div class="col-12 d-flex align-items-center justify-content-between border__bottom py-3">
                                                <div class="subtitle-2 black-text">Total Created</div>
                                                <div id="promoCodeDetailsTotalCreated" class="body-1 grey-text"></div>
                                            </div>
                                            <div class="col-12 d-flex align-items-center justify-content-between border__bottom py-3">
                                                <div class="subtitle-2 black-text">Remaining</div>
                                                <div id="promoCodeDetailsRemaining" class="body-1 grey-text"></div>
                                            </div>
                                            <div id="promoCodeDetailsMaxItemCountPerTransactionBlock" class="col-12 d-flex align-items-center justify-content-between border__bottom py-3">
                                                <div class="subtitle-2 black-text">Max Item Count Per Transaction</div>
                                                <div id="promoCodeDetailsMaxItemCountPerTransaction" class="body-1 grey-text"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="tab-pane fade show" id="promoCodeTransactionsTab" role="tabpanel" aria-labelledby="promoCodeTransactionsTabNav">
                                <div class="table--paybee">
                                    <div class='text-center no-data-text' style="display: none" id="emptyPromoCodeTransactions">No donations yet.</div>
                                    <table id ="promoCodeTransactions" class="table" cellspacing="0" style="width: 100%;">
                                        <thead class="thead-light">
                                            <tr>
                                                <th>Name</th>
                                                <th>EMail</th>
                                                <th>Option</th>
                                                <th>Quantity</th>
                                                <th>Date</th>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer paybee-modal-footer">
                        <a class="btn btn-sm modal-cancel-button" id="promoCodeDetailsClose">Close</a>
                    </div>
                </div>
            </div>
        </div>

        <div
            data-html2canvas-ignore
            class="modal fade"
            id="campaignItemModal"
            tabindex="-1"
            role="dialog"
            aria-hidden="true"
        >
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col-12 d-flex align-items-center justify-content-between mb-1">
                                <div id="campaignItemHeader" class="modal-main-heading mb-0"></div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div id="campaignItemSubheader" class="modal-sub-heading"></div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body custom-material-form updated-dropdown">
                        <ul class="nav nav-tabs md-tabs md-tabs--paybee md-tabs__bottom-border p-0" role="tablist">
                            <li class="nav-item">
                                <a class="nav-link active" id="campaignItemDetailsTabNav" data-toggle="tab" href="#campaignItemDetailsTab" role="tab" aria-controls="campaignItemDetailsTab"
                                aria-selected="true">Details</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" id="campaignItemFormDataTabNav" data-toggle="tab" href="#campaignItemFormDataTab" role="tab" aria-controls="campaignItemFormDataTab"
                                aria-selected="false">Form Data</a>
                            </li>
                        </ul>
                        <div class="tab-content pt-4">
                            <div class="tab-pane active" id="campaignItemDetailsTab" role="tabpanel" aria-labelledby="campaignItemDetailsTabNav">
                                <div class="row">
                                    <div class="col-6">
                                        <div class="row">
                                            <div class="col-12 d-flex align-items-center justify-content-between border__bottom py-3">
                                                <div class="subtitle-2 black-text">Name</div>
                                                <div id="campaignItemName" class="body-1 grey-text"></div>
                                            </div>
                                            <div class="col-12 d-flex align-items-center justify-content-between border__bottom py-3">
                                                <div class="subtitle-2 black-text">Email</div>
                                                <div id="campaignItemEmail" class="body-1 grey-text text-justify pl-4"></div>
                                            </div>
                                            <div id="campaignItemPhoneBlock" class="col-12 d-flex align-items-center justify-content-between border__bottom py-3">
                                                <div class="subtitle-2 black-text">Phone</div>
                                                <div id="campaignItemPhone" class="body-1 grey-text"></div>
                                            </div>
                                            <div id="campaignItemAddressBlock" class="col-12 d-flex align-items-center justify-content-between border__bottom py-3">
                                                <div class="subtitle-2 black-text">Address</div>
                                                <div id="campaignItemAddress" class="body-1 grey-text"></div>
                                            </div>
                                            <div class="col-12 d-flex align-items-center justify-content-between border__bottom py-3">
                                                <div class="subtitle-2 black-text">Option</div>
                                                <div id="campaignItemOption" class="body-1 grey-text"></div>
                                            </div>
                                            <div class="col-12 d-flex align-items-center justify-content-between border__bottom py-3">
                                                <div class="subtitle-2 black-text">Status</div>
                                                <div id="campaignItemStatus" class="body-1 grey-text"></div>
                                            </div>
                                            <div class="col-12 d-flex align-items-center justify-content-between border__bottom py-3">
                                                <div class="subtitle-2 black-text">Type</div>
                                                <div id="campaignItemType" class="body-1 grey-text"></div>
                                            </div>
                                            <div class="col-12 d-flex align-items-center justify-content-between border__bottom py-3">
                                                <div class="subtitle-2 black-text">Amount</div>
                                                <div id="campaignItemAmount" class="body-1 grey-text"></div>
                                            </div>
                                            <div id="campaignItemTaxBlock" class="col-12 d-flex align-items-center justify-content-between border__bottom py-3">
                                                <div class="subtitle-2 black-text">Tax</div>
                                                <div id="campaignItemTax" class="body-1 grey-text"></div>
                                            </div>
                                            <div class="col-12 d-flex align-items-center justify-content-between border__bottom py-3">
                                                <div class="subtitle-2 black-text">Date</div>
                                                <div id="campaignItemDate" class="body-1 grey-text"></div>
                                            </div>
                                            <div id="campaignItemMethodBlock" class="col-12 d-flex align-items-center justify-content-between border__bottom py-3">
                                                <div class="subtitle-2 black-text">Method</div>
                                                <div id="campaignItemMethod" class="body-1 grey-text"></div>
                                            </div>
                                            <div class="col-12 d-flex align-items-center justify-content-between border__bottom py-3">
                                                <div class="subtitle-2 black-text">Quantity</div>
                                                <div id="campaignItemQuantity" class="body-1 grey-text"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="tab-pane" id="campaignItemFormDataTab" role="tabpanel" aria-labelledby="campaignItemFormDataTabNav">
                                <div class="row">
                                    <div class="col-6">
                                        <div id="campaignItemFormData" class="row"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer paybee-modal-footer">
                        <a class="btn btn-sm modal-cancel-button" data-dismiss="modal" id="promoCodeDetailsClose">Close</a>
                    </div>
                </div>
            </div>
        </div>

        <div data-html2canvas-ignore class="modal fade" id="sendCartReminderAllModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col">
                                <div class="modal-main-heading">Send Reminder All</div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div id="sendCartReminderAllSubHeader" class="modal-sub-heading">
                                    Send an email reminder to this donor for all pending items now.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body custom-material-form updated-dropdown">
                        <label class="body-2">
                            Add optional message to email
                        </label>
                        <div class="text-center">
                            <div class="md-form flex-column justify-content-end align-items-end">
                                <div id="cartReminderAllMessage" class="form-control md-textarea quill--paybee overflow-visible resize-vertical">
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 mb-4">
                                <div class="black-text custom-control custom-switch">
                                    <input type="checkbox" class="custom-control-input" id="sendCartReminderAllText">
                                    <label class="custom-control-label subtitle-1" for="sendCartReminderAllText">Send Text Message to guest(s) with phone number.</label>
                                </div>
                            </div>
                        </div>
                    </div>
    
                    <div class="modal-footer paybee-modal-footer d-flex justify-content-between">
                        <a id="sendCartReminderAllPreview" class="btn btn--paybee btn--green button waves-effect waves-light">Preview</a>

                        <div class="ml-auto">
                            <a class="btn btn-sm modal-cancel-button" data-dismiss="modal">Cancel</a>
                            <a id="cartReminderAllSendBtn" class="btn btn-sm modal-confirm-button">Send</a>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
    
        <div data-html2canvas-ignore class="modal fade" id="sendAddGuestTicketReminderModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div id="sendAddGuestTicketReminderModal_notificationSection" class="modal-content paybee-modal-content" style="display:none;">
                </div>

                <div id="sendAddGuestTicketReminderModal_reminderSection" class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col">
                                <div id="sendAddGuestTicketReminderModalHeading" class="modal-main-heading">Send Add Guest Reminder to all</div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="modal-sub-heading" id="sendAddGuestTicketReminderModalSubHeading">
                                    Send Add Guest Reminder to all.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body custom-material-form updated-dropdown">
                        <div class="d-flex justify-content-between mb-2">
                            <span class="body-2" id="default-header-SendAddGuestTicketReminderMessage">
                                Optional header in reminder emails
                            </span>
                            <div class=" md-accordion md-accordion--help" id="accordionExSendAddGuestTicketReminderMessageHeader">
                                <div class="card card--guest z-depth-0">
                                    <div class="card-header card-header--guest p-0 d-flex align-items-center justify-content-between" id='sendAddGuestTicketReminderMessageHeader'>
                                        <span class="body-2">
                                            Optional header in reminder emails
                                        </span>
                                        <button
                                            class="btn btn-sm modal-cancel-button waves-effect waves-light caption text-nowrap d-flex align-items-center"
                                            type="button"
                                            id='header_buttonSendAddGuestTicketReminderMessage'
                                            data-toggle="collapse"
                                            data-target="#contentSendAddGuestTicketReminderMessageHeader"
                                            aria-expanded="true"
                                            aria-controls="accordionSendAddGuestTicketReminderMessageHeader"
                                        >
                                        <img class="mr-1" src="images/svg/eye-solid.svg" style="width: 13px;">
                                        See campaign header
                                        </button>
                                    </div>
                                    <div id="contentSendAddGuestTicketReminderMessageHeader" class="collapse"
                                        aria-labelledby="sendAddGuestTicketReminderMessageHeader"
                                        data-parent="#accordionExSendAddGuestTicketReminderMessageHeader"
                                    >
                                        <div class="accodion-body body-2 mt-2" id="help-SendAddGuestTicketReminderMessageHeader">
                                        </div>
                                        <div class="d-flex">
                                            <a id="copy-SendAddGuestTicketReminderMessageHeader" 
                                                class="blue-text body-2 mt-2 ml-auto copy-icon-btn"
                                                data-toggle="tooltip-optional-header" 
                                                data-placement="right" 
                                                title="Copy to optional header"> 
                                                <img  src="images/svg/copy-solid.svg" style="width: 13px;">
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="text-center">
                            <div class="md-form flex-column justify-content-end align-items-end">
                                <div id="sendAddGuestTicketReminderMessage-header" class="form-control md-textarea quill--paybee--small quill-scrollablle--small">
                                </div>
                                <span id="SendAddGuestTicketReminderMessage-headerLength"  class="character-counter character-counter-jquery"></span>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between mb-2">
                            <span  class="body-2" id="default-footer-SendAddGuestTicketReminderMessage">
                                Optional footer in reminder emails
                            </span>
                            <div class=" md-accordion md-accordion--help" id="accordionExSendAddGuestTicketReminderMessageFooter">
                                <div class="card card--guest z-depth-0">
                                    <div class="card-header card-header--guest p-0 d-flex align-items-center justify-content-between" id='sendAddGuestTicketReminderMessageFooter'>
                                        <span class="body-2">
                                            Optional footer in reminder emails
                                        </span>
                                        <button
                                            class="btn btn-sm modal-cancel-button waves-effect waves-light caption text-nowrap d-flex align-items-center"
                                            type="button"
                                            id='footer_buttonSendAddGuestTicketReminderMessage'
                                            data-toggle="collapse"
                                            data-target="#contentSendAddGuestTicketReminderMessageFooter"
                                            aria-expanded="true"
                                            aria-controls="accordionSendAddGuestTicketReminderMessageFooter"
                                        >
                                        <img class="mr-1" src="images/svg/eye-solid.svg" style="width: 13px;">
                                        See campaign footer
                                        </button>
                                    </div>
                                    <div id="contentSendAddGuestTicketReminderMessageFooter" class="collapse"
                                        aria-labelledby="addGuestReminderMessageFooter"
                                        data-parent="#accordionExSendAddGuestTicketReminderMessageFooter"
                                    >
                                        <div class="accodion-body body-2 mt-2" id="help-SendAddGuestTicketReminderMessageFooter">
                                        </div>
                                        <div class="d-flex">
                                            <a id="copy-SendAddGuestTicketReminderMessageFooter" 
                                                class="blue-text body-2 mt-2 ml-auto copy-icon-btn"
                                                data-toggle="tooltip-optional-footer" 
                                                data-placement="right" 
                                                title="Copy to optional footer">
                                                <img  src="images/svg/copy-solid.svg" style="width: 13px;">
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="text-center">
                            <div class="md-form flex-column justify-content-end align-items-end">
                                <div id="sendAddGuestTicketReminderMessage-footer" class="form-control md-textarea quill--paybee quill-scrollablle">
                                </div>
                                <span id="SendAddGuestTicketReminderMessage-footerLength"  class="character-counter character-counter-jquery"></span>
                            </div>
                        </div>
                        <div class="col-12 px-0">
                            <div class="black-text custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" id="sendAddGuestTicketReminderModalSendText">
                                <label class="custom-control-label subtitle-1" for="sendAddGuestTicketReminderModalSendText">Send Text Message to guest(s) with phone number.</label>
                            </div>
                        </div>
                    </div>
    
                    
                    <div class="modal-footer paybee-modal-footer d-flex justify-content-between">
                        <a id="addGuestTicketReminderPreview" class="btn btn--paybee btn--green button waves-effect waves-light">Preview</a>
                        <div class="ml-auto">
                            <a class="btn btn-sm modal-cancel-button" data-dismiss="modal">Cancel</a>
                            <a id="addGuestTicketReminderSendBtn" class="btn btn-sm modal-confirm-button">Send</a>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <div data-html2canvas-ignore class="modal fade" id="reminderPreviewModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">                    
                        <div class="row">
                            <div class="col-11">
                                <div id="reminderPreview" class="modal-main-heading">Event Reminder Preview</div>
                            </div>
                            <div class="col-1">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" class="black-text">&times;</span>
                                </button>
                            </div>
                        </div>                 
                    </div>
                    <div class="modal-body">
                        <div id="remiderPreviewSubject" class="body-1 mb-3"></div>
                        <div class="row justify-content-center">
                            <div class="col text-center">
                                <div id="reminderPreviewlHtml" class="text-left"></div>
                            </div>
                        </div>        
                    </div>
                    <div class="modal-footer paybee-modal-footer">
                        <a class="btn btn-sm modal-cancel-button" data-dismiss="modal">Close</a>
                    </div>
                </div>
            </div>
        </div>

        <div data-html2canvas-ignore class="modal fade" id="sendAddGuestTicketReminderAllModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div id="sendAddGuestTicketReminderAllModal_notificationSection" class="modal-content paybee-modal-content" style="display:none;">
                </div>

                <div id="sendAddGuestTicketReminderAllModal_chooseRecipientsSection" class="modal-content paybee-modal-content" style="display:none;">
                </div>

                <div id="sendAddGuestTicketReminderAllModal_reminderSection" class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col">
                                <div id="sendAddGuestTicketReminderAllModalHeading" class="modal-main-heading">Send Add Guest(s) Reminders To All</div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="modal-sub-heading" id="sendAddGuestTicketReminderAllModalSubHeading">
                                    Send add guest(s) reminders to all ticket holders with incomplete guest information via email and text message
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body custom-material-form updated-dropdown">
                        <div id="sendAddGuestTicketReminderAllModalNotConnected"  class="body-1 text-center">
                            No connected Ticket Campaign
                        </div>
                        <div id="sendAddGuestTicketReminderAllModalConnected">
                            <div class="d-flex justify-content-between mb-2">
                                <span class="body-2" id="default-header-AddGuestReminderAllMessage">
                                    Optional header in reminder emails
                                </span>
                                <div class=" md-accordion md-accordion--help" id="accordionExAddGuestReminderAllMessageHeader">
                                    <div class="card card--guest z-depth-0">
                                        <div class="card-header card-header--guest p-0 d-flex align-items-center justify-content-between" id='addGuestReminderAllMessageHeader'>
                                            <span class="body-2">
                                                Optional header in reminder emails
                                            </span>
                                            <button
                                                class="btn btn-sm modal-cancel-button waves-effect waves-light caption text-nowrap d-flex align-items-center"
                                                type="button"
                                                id='header_buttonAddGuestReminderAllMessage'
                                                data-toggle="collapse"
                                                data-target="#contentAddGuestReminderAllMessageHeader"
                                                aria-expanded="true"
                                                aria-controls="accordionRAddGuestReminderAllMessageHeader"
                                            >
                                            <img class="mr-1" src="images/svg/eye-solid.svg" style="width: 13px;">
                                            See campaign header
                                            </button>
                                        </div>
                                        <div id="contentAddGuestReminderAllMessageHeader" class="collapse"
                                            aria-labelledby="addGuestReminderAllMessageHeader"
                                            data-parent="#accordionExAddGuestReminderAllMessageHeader"
                                        >
                                            <div class="accodion-body body-2 mt-2" id="help-AddGuestReminderAllMessageHeader">
                                            </div>
                                            <div class="d-flex">
                                                <a id="copy-AddGuestReminderAllMessageHeader" 
                                                    class="blue-text body-2 mt-2 ml-auto copy-icon-btn"
                                                    data-toggle="tooltip-optional-header" 
                                                    data-placement="right" 
                                                    title="Copy to optional header">
                                                    <img  src="images/svg/copy-solid.svg" style="width: 13px;">
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="text-center">
                                <div class="md-form flex-column justify-content-end align-items-end">
                                    <div id="addGuestReminderAllMessage-header" class="form-control md-textarea quill--paybee--small quill-scrollablle--small">
                                    </div>
                                    <span id="AddGuestReminderAllMessage-headerLength"  class="character-counter character-counter-jquery"></span>
                                </div>
                            </div>
                            <div class="d-flex justify-content-between mb-2">
                                <span  class="body-2" id="default-footer-AddGuestReminderAllMessage">
                                    Optional footer in reminder emails
                                </span>
                                <div class=" md-accordion md-accordion--help" id="accordionExAddGuestReminderAllMessageFooter">
                                    <div class="card card--guest z-depth-0">
                                        <div class="card-header card-header--guest p-0 d-flex align-items-center justify-content-between" id='addGuestReminderAllMessageFooter'>
                                            <span class="body-2">
                                                Optional footer in reminder emails
                                            </span>
                                            <button
                                                class="btn btn-sm modal-cancel-button waves-effect waves-light caption text-nowrap d-flex align-items-center"
                                                type="button"
                                                id='footer_buttonAddGuestReminderAllMessage'
                                                data-toggle="collapse"
                                                data-target="#contentAddGuestReminderAllMessageFooter"
                                                aria-expanded="true"
                                                aria-controls="accordionAddGuestReminderAllMessageFooter"
                                            >
                                            <img class="mr-1" src="images/svg/eye-solid.svg" style="width: 13px;">
                                            See campaign footer
                                            </button>
                                        </div>
                                        <div id="contentAddGuestReminderAllMessageFooter" class="collapse"
                                            aria-labelledby="addGuestAddGuestReminderAllMessageFooter"
                                            data-parent="#accordionExAddGuestReminderAllMessageFooter"
                                        >
                                            <div class="accodion-body body-2 mt-2" id="help-AddGuestReminderAllMessageFooter">
                                            </div>
                                            <div class="d-flex">
                                                <a id="copy-AddGuestReminderAllMessageFooter" 
                                                    class="blue-text body-2 mt-2 ml-auto copy-icon-btn"
                                                    data-toggle="tooltip-optional-footer" 
                                                    data-placement="right" 
                                                    title="Copy to optional footer">
                                                    <img  src="images/svg/copy-solid.svg" style="width: 13px;">
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
    
                            </div>
                            <div class="text-center">
                                <div class="md-form flex-column justify-content-end align-items-end">
                                    <div id="addGuestReminderAllMessage-footer" class="form-control md-textarea quill--paybee quill-scrollablle">
                                    </div>
                                    <span id="AddGuestReminderAllMessage-footerLength"  class="character-counter character-counter-jquery"></span>
                                </div>
                            </div>
                            <div class="col-12 px-0">
                                <div class="black-text custom-control custom-switch">
                                    <input type="checkbox" class="custom-control-input" id="addGuestReminderAllMessageSendText">
                                    <label class="custom-control-label subtitle-1" for="addGuestReminderAllMessageSendText">Send Text Message to guest(s) with phone number.</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer paybee-modal-footer d-flex justify-content-between">
                        <a id="addGuestTicketReminderAllPreview" class="btn btn--paybee btn--green button waves-effect waves-light">Preview</a>
                        <div class="ml-auto">
                            <a class="btn btn-sm modal-cancel-button" data-dismiss="modal">Cancel</a>
                            <a id="addGuestTicketReminderAllSendBtn" class="btn btn-sm modal-confirm-button">Send</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    
        <div data-html2canvas-ignore class="modal fade" id="sendSaveCardReminderAllModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content paybee-modal-content">
                    <div id="sendSaveCardReminderAllModal_notificationSection" class="modal-content paybee-modal-content" style="display:none;"></div>

                    <div id="sendSaveCardReminderAllModal_reminderSection" class="modal-content paybee-modal-content">
                        <div class="paybee-modal-header">
                            <div class="row">
                                <div class="col">
                                    <div id="sendSaveCardReminderAllModalHeading" class="modal-main-heading">Send Save Card Reminder To All</div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <div class="modal-sub-heading" id="sendSaveCardReminderAllModalSubHeading">
                                        Send Save Card Reminder To All
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-body custom-material-form updated-dropdown">
                            <div id="sendSaveCardReminderAllModalNotConnected"  class="body-1 text-center">
                                No connected Ticket Campaign
                            </div>
                        </div>
                        
                        <div class="modal-footer paybee-modal-footer d-flex justify-content-between">
                            <a id="sendSaveCardReminderAllPreview" class="btn btn--paybee btn--green button waves-effect waves-light">Preview</a>
                            <div class="ml-auto">
                                <a class="btn btn-sm modal-cancel-button" data-dismiss="modal">Cancel</a>
                                <a id="sendSaveCardReminderAllSendBtn" class="btn btn-sm modal-confirm-button">Send</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div data-html2canvas-ignore class="modal fade" id="topDonorsEvent" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-xl paybee-modal-dialog" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col-10">
                                <div class="modal-main-heading" id="campaignNameTopEvent"></div>
                            </div>
                            <div class="col-2">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" class="black-text">&times;</span>
                                </button>
                            </div>
                        </div>
                    </div>
    
                    <div class="modal-body">
                        <div class="table--paybee">
                            <div class='text-center no-data-text' style="display: none" id="campaignEventTopActivityEmpty">No transactions yet.</div>
                            <table id ="campaignEventTopActivity" class="table mb-0" cellspacing="0" style="width: 100%;">
                                <thead class="thead-light">
                                <tr>
                                    <th>Name</th>
                                    <th>Email</th>
                                    <th>Amount</th>
                                    <th style="min-width: 100px;">Status</th>
                                    <th>Option </th>
                                    <th>PaddleNum</th>
                                    <th>TableNum</th>
                                    <th>Date</th>
                                </tr>
                                </thead>
                            </table>
                        </div>
                    </div>
    
                    <div class="modal-footer paybee-modal-footer" style="border:none;">
                        <a class="btn btn-sm modal-cancel-button" data-dismiss="modal">Cancel</a>
                    </div>
                </div>
            </div>
        </div>
    
        <div data-html2canvas-ignore class="modal fade" id="topDonorsVEvent" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg paybee-modal-dialog" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col-10">
                                <div class="modal-main-heading" id="campaignNameTopVEvent"></div>
                            </div>
                            <div class="col-2">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" class="black-text">&times;</span>
                                </button>
                            </div>
                        </div>
                    </div>
    
                    <div class="modal-body">
                        <div class="table--paybee">
                            <div class='text-center no-data-text' style="display: none" id="campaignEventTopActivityVEventEmpty">No transactions yet.</div>
                            <table id ="campaignEventTopActivityVEvent" class="table mb-0" cellspacing="0" style="width: 100%;">
                                <thead class="thead-light">
                                <tr>
                                    <th>Name</th>
                                    <th>Email</th>
                                    <th>Amount</th>
                                    <th style="min-width: 100px;">Status</th>
                                    <th>Option </th>
                                    <th>Date</th>
                                </tr>
                                </thead>
                            </table>
                        </div>
                    </div>
    
                    <div class="modal-footer paybee-modal-footer" style="border:none;">
                        <a class="btn btn-sm modal-cancel-button" data-dismiss="modal">Cancel</a>
                    </div>
                </div>
            </div>
        </div>
    
        <div data-html2canvas-ignore class="modal fade" id="sendGuestReminderModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col">
                                <div id="sendGuestReminderModalHeader" class="modal-main-heading">Send Reminder</div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="modal-sub-heading" id="sendGuestReminderModalSubHeader">
                                    Send Reminder
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body custom-material-form updated-dropdown">
                        <div class="d-flex align-items-end justify-content-between mb-3">
                            <div class="d-flex align-items-end">
                                <div id="selTempBlock_sendGuestReminderModal" class="templateSelect">
                                    <span class="body-2 mb-2 d-block" >Select Email Template</span>
                                    <select id='selectTemplate_sendGuestReminderModal' class='select-wrapper mdb-select mdb-select--paybee mb-1 w-100'>
                                    </select>
                                </div>
                            </div>
                            <div class="d-flex flex-row">
                                <button id="customTemplatesBtn_sendGuestReminderModal" class="btn btn-sm modal-cancel-button waves-effect waves-light caption text-nowrap align-items-center"><i class="fas fa-pencil-alt mr-2"></i>Manage Templates</button>
                            </div>
                        </div>
                        <div class="divider mb-2"></div>
                        <div id="regularTemplate_sendGuestReminderModal" >
                            <div class="position-relative">
                                <div id="backgroundBlock_sendGuestReminderModal" class="disabled backgroundBlock" style="display: none;"></div>
                                <div class="d-flex justify-content-between mb-2">
                                    <span class="body-2" id="default-header-SendGuestReminderMessage">
                                        Optional header in reminder emails
                                    </span>
                                    <div class=" md-accordion md-accordion--help" id="accordionExSendGuestReminderMessageHeader">
                                        <div class="card card--guest z-depth-0">
                                            <div class="card-header card-header--guest p-0 d-flex align-items-center justify-content-between" id='sendGuestReminderMessageHeader'>
                                                <span class="body-2">
                                                    Optional header in reminder emails
                                                </span>
                                                <button
                                                    class="btn btn-sm modal-cancel-button waves-effect waves-light caption text-nowrap d-flex align-items-center"
                                                    type="button"
                                                    id='header_buttonSendGuestReminderMessage'
                                                    data-toggle="collapse"
                                                    data-target="#contentSendGuestReminderMessageHeader"
                                                    aria-expanded="true"
                                                    aria-controls="accordionSendGuestReminderMessageHeader"
                                                >
                                                <img class="mr-1" src="images/svg/eye-solid.svg" style="width: 13px;">
                                                See campaign header
                                                </button>
                                            </div>
                                            <div id="contentSendGuestReminderMessageHeader" class="collapse"
                                                aria-labelledby="sendGuestReminderMessageHeader"
                                                data-parent="#accordionExSendGuestReminderMessageHeader"
                                            >
                                                <div class="accodion-body body-2 mt-2" id="help-SendGuestReminderMessageHeader">
                                                </div>
                                                <div class="d-flex">
                                                    <a id="copy-SendGuestReminderMessageHeader"
                                                        class="blue-text body-2 mt-2 ml-auto copy-icon-btn"
                                                        data-toggle="tooltip-optional-header" 
                                                        data-placement="right" 
                                                        title="Copy to optional header">
                                                        <img  src="images/svg/copy-solid.svg" style="width: 13px;">
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="text-center">
                                    <div class="md-form flex-column justify-content-end align-items-end quill-normalise">
                                        <div id="sendGuestReminderMessage-header" class="form-control md-textarea quill--paybee--small quill-scrollablle--small p-0">
                                        </div>
                                        <span id="SendGuestReminderMessage-headerLength"  class="character-counter character-counter-jquery"></span>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-between mb-2">
                                    <span  class="body-2" id="default-footer-SendGuestReminderMessage">
                                        Optional footer in reminder emails
                                    </span>
                                    <div class=" md-accordion md-accordion--help" id="accordionExSendGuestReminderMessageFooter">
                                        <div class="card card--guest z-depth-0">
                                            <div class="card-header card-header--guest p-0 d-flex align-items-center justify-content-between" id='rendGuestReminderMessageFooter'>
                                                <span class="body-2">
                                                    Optional footer in reminder emails
                                                </span>
                                                <button
                                                    class="btn btn-sm modal-cancel-button waves-effect waves-light caption text-nowrap d-flex align-items-center"
                                                    type="button"
                                                    id='footer_buttonSendGuestReminderMessage'
                                                    data-toggle="collapse"
                                                    data-target="#contentSendGuestReminderMessageFooter"
                                                    aria-expanded="true"
                                                    aria-controls="accordionSendGuestReminderMessageFooter"
                                                >
                                                <img class="mr-1" src="images/svg/eye-solid.svg" style="width: 13px;">
                                                See campaign footer
                                                </button>
                                            </div>
                                            <div id="contentSendGuestReminderMessageFooter" class="collapse"
                                                aria-labelledby="sendGuestReminderMessageFooter"
                                                data-parent="#accordionExSendGuestReminderMessageFooter"
                                            >
                                                <div class="accodion-body body-2 mt-2" id="help-SendGuestReminderMessageFooter">
                                                </div>
                                                <div class="d-flex">
                                                    <a id="copy-SendGuestReminderMessageFooter" 
                                                    class="blue-text body-2 mt-2 ml-auto copy-icon-btn"
                                                    data-toggle="tooltip-optional-footer" 
                                                    data-placement="right" 
                                                    title="Copy to optional footer">
                                                        <img  src="images/svg/copy-solid.svg" style="width: 13px;">
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
        
                                </div>
                                <div class="text-center">
                                    <div class="md-form flex-column justify-content-end align-items-end quill-normalise">
                                        <div id="sendGuestReminderMessage-footer" class="form-control md-textarea quill--paybee quill-scrollablle p-0">
                                        </div>
                                        <span id="SendGuestReminderMessage-footerLength"  class="character-counter character-counter-jquery"></span>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 mb-4">
                                    <div class="black-text custom-control custom-switch">
                                        <input type="checkbox" class="custom-control-input" id="sentTextMesCheckbox_sendGuestReminderModal">
                                        <label class="custom-control-label subtitle-1" for="sentTextMesCheckbox_sendGuestReminderModal">Send Text Message to guest with phone number.</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="customTemplate_sendGuestReminderModal" style="display: none"> </div>
  
                    </div>
                    
                    <div id='footerBlock_sendGuestReminderModal' class="modal-footer paybee-modal-footer d-flex justify-content-between">
                        <a id="sendGuestReminderPreview" class="btn btn--paybee btn--green button waves-effect waves-light">Preview</a>
                        <div class="ml-auto">
                            <a class="btn btn-sm modal-cancel-button" data-dismiss="modal">Cancel</a>
                            <a id="sendGuestReminderSendBtn" class="btn btn-sm modal-confirm-button">Send</a>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
    
        <div data-html2canvas-ignore class="modal fade" id="connectCampaignToEventModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-notify modal-info" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col-10">
                                <div class="modal-main-heading">Connect to an Event</div>
                            </div>
                            <div class="col-2">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" class="black-text">&times;</span>
                                </button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="modal-sub-heading">This will ensure ticketholders and guests will receive event join information</div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body text-center" style="font-size: 0.9rem;">
                        <div class="red-text"> This action is irreversible!</div>
                        <div class="mb-3" id="connectCampaignToEventDescription"></div>
                        <div class="mb-3">
                            <select id='selectEventType' class='select-wrapper mdb-select mdb-select--paybee caret-up mb-1 w-100'>
                                <option value="-1" selected disabled>Select Event Type</option>
                                <option id="isTicketingForVirtualEvent" value="1">Virtual</option>
                                <option id="isTicketingForInPersonEvent" value="0">In-Person</option>
                            </select>
                            <div class='text-left red-text small' id='selectEventTypeError'></div>
                        </div>
                        <div id="eventSelectBlock" class="d-flex flex-column align-items-start mb-3 caret-up"></div>
                    </div>
                    <div class="modal-footer paybee-modal-footer">
                        <a class="btn btn-sm modal-cancel-button" data-dismiss="modal">Cancel</a>
                        <a id="connectCampaignToEventSubmit" class="btn btn-sm modal-confirm-button">Connect</a>
                    </div>
                </div>
            </div>
        </div>
       
        <div data-html2canvas-ignore class="modal fade" id="showOpenCartsByTable" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-notify modal-info" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col-10">
                                <div class="modal-main-heading">Open Carts</div>
                            </div>
                            <div class="col-2">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" class="black-text">&times;</span>
                                </button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="modal-sub-heading">See pending carts arrange by the table.</div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body" id="pendingTables">
                    </div>
                    <div class="modal-footer paybee-modal-footer">
                        <a class="btn btn-sm modal-cancel-button waves-effect waves-light" data-dismiss="modal">Cancel</a>
                    </div>
                </div>
            </div>
        </div>
    
        <div data-html2canvas-ignore class="modal fade" id="confirmModalSimple" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog paybee-modal-dialog-350" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col-10">
                                <div class="modal-main-heading" id="confirmModalSimpleTitle"></div>
                            </div>
                            <div class="col-2">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" class="black-text">&times;</span>
                                </button>
                            </div>
                        </div>
                    </div>
    
                    <div class="modal-body">
                        <div class="row">
                            <div class="col text-center">
                                <p id="confirmModalSimpleMessage"></p>
                            </div>
                        </div>
                    </div>
    
                    <div class="modal-footer justify-content-around" style="border:none;">
                        <a id="confirmSimpleCancel" class="btn btn-sm modal-cancel-button waves-effect waves-light">No</a>
                        <a id="confirmSimpleYes" class="btn btn-sm modal-confirm-button waves-effect waves-light">Yes</a>
                    </div>
                </div>
            </div>
        </div>
        <div data-html2canvas-ignore class="modal fade" id="sendSimpleReminderModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col">
                                <div id="sendSimpleReminderModalTitle" class="modal-main-heading">Send Save Card Reminder To All</div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="modal-sub-heading" id="sendSimpleReminderModalMessage">
                                </div>
                            </div>
                        </div>
                    </div>
                    

                    
                    <div class="modal-footer paybee-modal-footer d-flex justify-content-between">
                        <a id="sendSimpleReminderModalSendPreview" class="btn btn--paybee btn--green button waves-effect waves-light">Preview</a>
                        <div class="ml-auto">
                            <a class="btn btn-sm modal-cancel-button" data-dismiss="modal">Cancel</a>
                            <a id="sendSimpleReminderModalSend" class="btn btn-sm modal-confirm-button">Send</a>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>

        <div data-html2canvas-ignore class="modal fade" id="waitModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog paybee-modal-dialog-350" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col">
                                <div class="modal-main-heading" id="waitModalHeading">Generating Bid Sheet</div>
                            </div>
                        </div>
                    </div>
    
                    <div class="modal-body">
                        <div class="row">
                            <div class="col text-center">
                                <p id="waitModalSubHeading">Bid Sheet being created, depending upon number of items it might take few minutes.</p>
                                <img src="/images/loading.gif">
                                <p id="waitModalSubHeadingBottom">Preview will open automatically when done</p>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer justify-content-right" style="border:none;">
                        <a id="cancelBidSheet" class="btn btn-sm modal-cancel-button waves-effect waves-light">Cancel</a>
                    </div>
                </div>
            </div>
        </div>
    
        <div data-html2canvas-ignore class="modal fade" id="deprecatedSection" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog paybee-modal-dialog" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col-10">
                                <div class="modal-main-heading">Virtual Events - deprecated</div>
                            </div>
                            <div class="col-2">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" class="black-text">&times;</span>
                                </button>
                            </div>
                        </div>
                    </div>
    
                    <div class="modal-body">
                        <div class="row">
                            <div class="col text-center">
                                <p>Please use "<b>Manage -> Events</b>" because "<b>Manage -> Virtual Events</b>" is decprecated and will be removed in the next releases.</p>
                            </div>
                        </div>
                    </div>
    
                    <div class="modal-footer paybee-modal-footer" style="border:none;">
                        <a class="btn btn-sm modal-cancel-button" data-dismiss="modal">Cancel</a>
                    </div>
                </div>
            </div>
        </div>
    
        <div data-html2canvas-ignore class="modal fade" id="topDonors" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg paybee-modal-dialog" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col-10">
                                <div class="modal-main-heading" id="campaignNameTopEvent"></div>
                            </div>
                            <div class="col-2">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" class="black-text">&times;</span>
                                </button>
                            </div>
                        </div>
                    </div>
    
                    <div class="modal-body">
                        <div class="table--paybee">
                            <div class='text-center no-data-text' style="display: none" id="campaignEventTopActivityEmpty">No transactions yet.</div>
                            <table id ="campaignEventTopActivity" class="table mb-0" cellspacing="0" style="width: 100%;">
                                <thead class="thead-light">
                                <tr>
                                    <th>Donor</th>
                                    <th>Amount</th>
                                    <th>Option </th>
                                    <th>PaddleNum</th>
                                    <th>TableNum</th>
                                    <th>Status</th>
                                </tr>
                                </thead>
                            </table>
                        </div>
                    </div>
    
                    <div class="modal-footer paybee-modal-footer" style="border:none;">
                        <a class="btn btn-sm modal-cancel-button" data-dismiss="modal">Cancel</a>
                    </div>
                </div>
            </div>
        </div>
    
        <div data-html2canvas-ignore class="modal fade" id="confirmModalSimpleMd" tabindex="-1" role="dialog" aria-hidden="true" data-focus-on="input:first">
            <div class="modal-dialog modal-md modal-notify modal-warning" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="modal-body pb-0">
                        <div class="row">
                            <div class="col text-center">
                                <p class="font-weight-bold" id="confirmModalSimpleMdTitle"></p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col text-center">
                                <p id="confirmModalSimpleMdMessage"></p>
                            </div>
                        </div>
    
                        <div class="modal-footer paybee-modal-footer mt-4 pr-0" style="background: white;">
                            <a class="btn btn-sm modal-cancel-button" id="confirmSimpleMdCancel">No</a>
                            <a id="confirmSimpleMdYes" class="btn btn-sm modal-confirm-button">Yes</a>
                        </div>                    
                    </div>
                </div>
            </div>
        </div>
    
        <div data-html2canvas-ignore class="modal fade" id="confirmModalSimpleLg" tabindex="-1" role="dialog" aria-hidden="true" data-focus-on="input:first">
            <div class="modal-dialog modal-lg modal-notify modal-warning" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="modal-body pb-0">
                        <div class="row">
                            <div class="col text-center">
                                <p class="font-weight-bold" id="confirmModalSimpleLgTitle"></p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col text-center">
                                <p id="confirmModalSimpleLgMessage"></p>
                            </div>
                        </div>
    
                        <div class="modal-footer paybee-modal-footer mt-4 pr-0" style="background: white;">
                            <a class="btn btn-sm modal-cancel-button" id="confirmSimpleLgCancel">No</a>
                            <a id="confirmSimpleLgYes" class="btn btn-sm modal-confirm-button">Yes</a>
                        </div>                    
                    </div>
                </div>
            </div>
        </div>
    
        <div data-html2canvas-ignore class="modal fade" id="notificationModal" tabindex="-1" role="dialog" aria-hidden="true" data-focus-on="input:first">
            <div class="modal-dialog modal-lg modal-notify modal-warning" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="modal-body pb-0">
                        <div class="row">
                            <div class="col text-center">
                                <p class="font-weight-bold" id="notificationTitle"></p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col text-center">
                                <p id="notificationMessage"></p>
                            </div>
                        </div>                
                    </div>
                    <div class="modal-footer paybee-modal-footer">
                        <a id="notificationOk" class="btn btn-sm modal-confirm-button waves-effect waves-light">Ok</a>
                    </div>  
                </div>
            </div>
        </div>
    
        <div data-html2canvas-ignore class="modal fade" id="deleteGuestsModal" tabindex="-1" role="dialog" aria-hidden="true" data-focus-on="input:first">
            <div class="modal-dialog modal-lg modal-notify modal-warning" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header border-bottom">
                        <div class="row">
                            <div class="col-10">
                                <div class="modal-main-heading">Delete Guest(s)</div>
                            </div>
                            <div class="col-2">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" class="black-text">×</span>
                                </button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div id="deleteGuestsSubHeaderModal" class="modal-sub-heading">This action will delete following Guest(s)</div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body pb-0">
                        <div class="row">
                            <div class="col text-center">
                                <p class="font-weight-bold" id="deleteGuestsModalTitle"></p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col text-center">
                                <p id="deleteGuestsModalMessage"></p>
                            </div>
                        </div>                  
                    </div>
                    <div class="modal-footer paybee-modal-footer mt-4">
                        <a id="deleteGuestsModalCancel" class="btn btn-sm modal-cancel-button">Cancel</a>
                        <a id="deleteGuestsModalYes" class="btn btn-sm modal-confirm-button">Delete</a>
                    </div>  
                </div>
            </div>
        </div>
    
        <div data-html2canvas-ignore class="modal fade" id="deleteTicketModal" tabindex="-1" role="dialog" aria-hidden="true" data-focus-on="input:first">
            <div class="modal-dialog modal-lg modal-notify modal-warning" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header border-bottom">
                        <div class="row">
                            <div class="col-10">
                                <div class="modal-main-heading">Delete Ticket</div>
                            </div>
                            <div class="col-2">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" class="black-text">×</span>
                                </button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div id="deleteTicketSubHeaderModal" class="modal-sub-heading">This action will delete ticket and all its Guest(s) and invitations</div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body pb-0">
                        <div class="row">
                            <div class="col text-center">
                                <p class="font-weight-bold" id="deleteTicketModalTitle"></p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col text-center">
                                <p id="deleteTicketModalMessage"></p>
                            </div>
                        </div>                  
                    </div>
                    <div class="modal-footer paybee-modal-footer mt-4">
                        <a id="deleteTicketModalCancel" class="btn btn-sm modal-cancel-button">Cancel</a>
                        <a id="deleteTicketModalYes" class="btn btn-sm modal-confirm-button">Delete</a>
                    </div>  
                </div>
            </div>
        </div>

        <div data-html2canvas-ignore class="modal fade" id="captainTicketModal" tabindex="-1" role="dialog" aria-hidden="true" data-focus-on="input:first">
            <div class="modal-dialog modal-lg modal-notify modal-warning" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header border-bottom">
                        <div class="row">
                            <div class="col-10">
                                <div id="captainTicketHeaderModal" class="modal-main-heading mb-0"></div>
                            </div>
                            <div class="col-2">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" class="black-text">×</span>
                                </button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div id="captainTicketSubHeaderModal" class="modal-sub-heading body-2"></div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body pb-0">
                        <div class="row">
                            <div class="col text-center">
                                <p id="captainTicketModalMessage"></p>
                            </div>
                        </div>                  
                    </div>
                    <div class="modal-footer paybee-modal-footer mt-4">
                        <a id="captainTicketModalClose" class="btn btn-sm modal-cancel-button" data-dismiss="modal">Close</a>
                    </div>  
                </div>
            </div>
        </div>
      
        <div data-html2canvas-ignore class="modal fade right" id="chatHistoryModal" tabindex="-1" role="dialog" aria-labelledby="chatHistoryModal" aria-hidden="true">
            <div class="modal-dialog modal-full-height modal-right" role="document">
                <div class="modal-content">
                    <div class="row" style="background-color: #2c2f341c;">
                        <div class="col">
                            <button id="downloadChatHistory" class="btn btn-secondary buttons-excel buttons-html5 btn-copy-code btn-outline-grey btn-sm px-2 waves-effect" type="button">
                                <span><i class="fas fa-cloud-download-alt mr-1"></i>Download</span>
                            </button>
                        </div>
                    </div>
                    <div class="row" style="height: 100%">
                        <div class="col">
                            <div class="card" style="z-index: 10000;height: 100%;background-color: #2c2f341c;height: calc(100% - 40px);bottom: 0;position: fixed;">                            
                                <div class="card-body msg_card_body" id="chatHistory" style="height: 100%;overflow: scroll">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    
        <div data-html2canvas-ignore class="modal fade" id="cloneCampaignForm" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col">
                                <div class="modal-main-heading">Copy Campaign</div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="modal-sub-heading">
                                    Copy <span style="color: #6E42FF;" id="campaignNameCloning"></span> to create new.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body mx-3">
                        <div class="md-form mb-5">
                            <i class="fas fa-qrcode prefix grey-text"></i>
                            <input type="text" id="cloneCampaignName" class="form-control validate">
                            <label class="inputLabel" id="cloneCampaignNameLabel" data-error="Empty Name" for="cloneCampaignName">New Campaign Name</label>
                        </div>
                    </div>
                    <div class="modal-footer paybee-modal-footer">
                        <a class="btn btn-sm modal-cancel-button" data-dismiss="modal">Cancel</a>
                        <a id="cloneCampaignButton" class="btn btn-sm modal-confirm-button">Copy <i class="far fa-clone m1-1"></i></a>
                    </div>
                </div>
            </div>
        </div>
    
        <div data-html2canvas-ignore class="modal fade" id="cloneVirtualEventForm" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col">
                                <div class="modal-main-heading">Copy Virtual Event</div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="modal-sub-heading">
                                    Copy <span style="color: #6E42FF;" id="virtualEventNameCloning"></span> to create new.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body mx-3">
                        <div class="md-form mb-5">
                            <i class="fas fa-qrcode prefix grey-text"></i>
                            <input type="text" id="cloneVirtualEventName" class="form-control validate">
                            <label class="inputLabel" id="cloneVirtualEventNameLabel" data-error="Empty Name" for="cloneVirtualEventName">New Virtual Event Name</label>
                        </div>
                    </div>
                    <div class="modal-footer paybee-modal-footer">
                        <a class="btn btn-sm modal-cancel-button" data-dismiss="modal">Cancel</a>
                        <a id="cloneVirtualEventButton" class="btn btn-sm modal-confirm-button">Copy <i class="far fa-clone m1-1"></i></a>
                    </div>
                </div>
            </div>
        </div>

        <div data-html2canvas-ignore class="modal fade" id="cloneEventForm" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col">
                                <div class="modal-main-heading" id="cloneEventFormType">Copy Virtual Event</div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="modal-sub-heading">
                                    Copy <span style="color: #6E42FF;" id="eventNameCloning"></span> to create new.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body mx-3">
                        <div class="md-form mb-5">
                            <i class="fas fa-qrcode prefix grey-text"></i>
                            <input type="text" id="cloneEventName" class="form-control validate">
                            <label class="inputLabel" id="cloneEventNameLabel" data-error="Empty Name" for="cloneEventName">New Event Name</label>
                        </div>
                    </div>
                    <div class="modal-footer paybee-modal-footer">
                        <a class="btn btn-sm modal-cancel-button" data-dismiss="modal">Cancel</a>
                        <a id="cloneEventButton" class="btn btn-sm modal-confirm-button">Copy <i class="far fa-clone m1-1"></i></a>
                    </div>
                </div>
            </div>
        </div>
    
        <div data-html2canvas-ignore class="modal fade" id="pdfPreviewModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col-10">
                                <div id="pdfPreviewMainHeading" class="modal-main-heading">PDF Preview</div>                            
                            </div>
                            <div class="col-2">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" class="black-text">&times;</span>
                                </button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div id="pdfPreviewSubHeading" class="modal-sub-heading">View and download</div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body mx-3 text-center">
                        <object id="paddlePreviewObject" type="application/pdf" style="height: 640px; width: 410px;" data=""></object>
                    </div>
                    <div class="modal-footer paybee-modal-footer">
                        <a href="#" id="paddlePreviewObjectDownload" target="_blank" class="btn btn--paybee btn--purple button waves-effect waves-light" download>Download</a>
                    </div>
                </div>
            </div>
        </div>
    
        <div data-html2canvas-ignore class="modal fade" id="helpValueProvided" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-notify modal-info" role="document">
                
                <div class="modal-content">
                    <div class="modal-body">
                        <h4>Value of goods or services provided, If any!</h4>
                        <p>If you provide any goods or service in exchange for donation you can add value of item here.
                            It will be used when PayBee sends annual tax receipts and might also be included in the donation acknowledgement.
                            Donor must generally reduce the amount of the contribution deduction by the fair market value of the goods and services provided by
                            the organization. Goods or services include cash, property, services, benefits or privileges.
                            However, there are some exceptions. Please read this <a href="https://www.irs.gov/pub/irs-pdf/p1771.pdf" target="_blank"> document from IRS </a> to learn more.
                        </p>
                        <p>
                            Should be set 0 for most donations.
                        </p>
                        <p>
                            You can mark entire campaign as non-deductible, un-check the "Qualify for tax deduction" on the previous screen.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    
        <style>
            .modal-help-text {
                font-size: 14px;
            }
        </style>
    
        <div data-html2canvas-ignore class="modal fade" id="helpParishSoftImport" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header mb-0">
                        <div class="row">
                            <div class="col-11">
                                <div class="modal-main-heading">ParishSoft Export Help</div>
                            </div>
                            <div class="col-1">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" class="black-text">&times;</span>
                                </button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="modal-sub-heading">Documenation to understand export and import to ParishSoft</div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body">                    
                        <div style="font-weight: 500;color: black;">Before importing to ParishSoft</div>
                        <ul class="modal-help-text">
                            <li>
                                Add ParishSoft OrganizationID to second column of the header row.
                            </li>
                        </ul>
                        <div style="font-weight: 500;color: black;">To add EnvelopeNum for donors</div>
                        <ul class="modal-help-text">
                            <li>
                                Go to report/Donors from the left menu.
                            </li>
                            <li>
                                Locate donor (sort it by ExternalId to see donors without EvelopeNum.)
                            </li>
                            <li>
                                Scroll all the way to the right and click on the edit button.
                            </li>
                            <li>
                                Add ExternalId (same as EnvelopeNum in ParishSoft).
                            </li>
                            <li>
                                Contact us at contact&#64;paybee.io if you would like to import all donors at once.
                            </li>
                        </ul>
    
                        <div style="font-weight: 500;color: black;">To add FundId to a campaign</div>
                        <div class="modal-sub-heading">CampaignInternalId set to a campaign is also ParishSoft FundId</div>
                        <ul class="modal-help-text">
                            <li>
                                Go to the Campaigns from the side menu.
                            </li>
                            <li>
                                Click on the green button to edit the campaign.
                            </li>
                            <li>
                                Expand General Settings.
                            </li>
                            <li>
                                Set the value in the last edit box, "Internal Id for the campaign."
                            </li>
                            <li>
                                Click Save on the top to save the changes.
                            </li>
                            <li>
                                Please do it for all the campaigns.
                            </li>
                        </ul>
                        <div style="font-weight: 500;color: black;">Filter donations for export</div>
                        <div class="modal-sub-heading">Exports all completed donation with positive amount, rows included in based on the filters selected</div>
                        <ul class="modal-help-text">
                            <li>
                                Set date range from the top of the page.
                            </li>
                            <li>
                                Set other filters from the "Report Filters".
                            </li>
                            <li>
                                Click on "ParishSoft Export" to download the file.
                            </li>
                        </ul>
    
                        <div style="font-weight: 500;color: black;">Helpful ParishSoft links</div>
                        <ul class="modal-help-text">
                            <li>
                                <a target="_blank" href="https://support.parishsoft.com/hc/en-us/articles/360054000012-DMO-Contributions-Import-How-to-format-a-file-for-importing-contributions">
                                    ParishSoft documentation about file format.
                                </a>
                            </li>
                            <li>
                                <a target="_blank" href="https://support.parishsoft.com/hc/en-us/articles/360057308731-DMO-Contributions-Import-How-to-import-offering-from-ParishSOFT-Giving-PSG-or-a-3rd-party-vendor">
                                    Other ParishSoft general import help
                                </a>        
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    
        <div data-html2canvas-ignore class="modal fade" id="helpNetworkForGoodImport" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header mb-0">
                        <div class="row">
                            <div class="col-11">
                                <div class="modal-main-heading">Network For Good Export Help</div>
                            </div>
                            <div class="col-1">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" class="black-text">&times;</span>
                                </button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="modal-sub-heading">Documenation to understand export and import to NetworkForGood</div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body">                    
                        <div style="font-weight: 500;color: black;">To add campaign name</div>
                        <div class="modal-sub-heading">CampaignInternalId set to a campaign used as campign field</div>
                        <ul class="modal-help-text">
                            <li>
                                Go to the Campaigns from the side menu.
                            </li>
                            <li>
                                Click on the green button to edit the campaign.
                            </li>
                            <li>
                                Expand General Settings.
                            </li>
                            <li>
                                Set the value in the last edit box, "Internal Id for the campaign."
                            </li>
                            <li>
                                Click Save on the top to save the changes.
                            </li>
                            <li>
                                Please do it for all the campaigns.
                            </li>
                        </ul>
                        <div style="font-weight: 500;color: black;">Filter donations for export</div>
                        <div class="modal-sub-heading">Exports all completed donation with positive amount, rows included in based on the filters selected</div>
                        <ul class="modal-help-text">
                            <li>
                                Set date range from the top of the page.
                            </li>
                            <li>
                                Set other filters from the "Report Filters".
                            </li>
                            <li>
                                Click on "NETWORK FOR GOOD EXPORT" to download the file.
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    
        <div data-html2canvas-ignore class="modal fade" id="sendReferralModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col-11">
                                <div class="modal-main-heading">Refer PayBee</div>
                            </div>
                            <div class="col-1">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" class="black-text">&times;</span>
                                </button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="modal-sub-heading">
                                    We will donate $50 to you when they signup. They get a $150 discount from the onboarding fee.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body pt-0">
                        <div class="row justify-content-center custom-material-form updated-dropdown">
                            <div class="col-11">
                                <div class="md-form pb-2">
                                    <input type="text" id="referralName" maxlength="127" class="form-control validate mb-0">
                                    <label class="inputLabel" data-error="Invalid" data-success="" id="referralNameLabel" for="referralName" class="form-label">Friend's Name</label>
                                </div>
                                <div class="md-form pb-2">
                                    <input type="text" id="referralEmail" maxlength="127" class="form-control validate mb-0">
                                    <label class="inputLabel" data-error="Invalid" data-success="" id="referralEmailLabel" for="referralEmail" class="form-label">Friend's Email</label>
                                </div>
                                <div class="md-form pb-2">
                                    <input type="text" id="referralOrgName" maxlength="256" class="form-control validate mb-0">
                                    <label class="inputLabel" data-error="Invalid" data-success="" id="referralOrgNameLabel" for="referralOrgName" class="form-label">Friend's nonprofit Name</label>
                                </div>
                                <div class="md-form pb-2">
                                    <input type="text" id="refereeName" maxlength="127" class="form-control validate mb-0">
                                    <label class="inputLabel" data-error="Invalid" data-success="" id="refereeNameLabel" for="refereeName" class="form-label">Your Name</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer paybee-modal-footer">
                        <a id="sendReferralButton" class="btn btn-sm modal-confirm-button">Refer</a>
                    </div>
                </div>
            </div>
        </div>

            
        <div data-html2canvas-ignore class="modal fade" id="seatsModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content paybee-modal-content custom-material-form">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col-11">
                                <div class="modal-main-heading">Seat</div>
                            </div>
                            <div class="col-1">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" class="black-text">&times;</span>
                                </button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div id="editSeatsModalSubHeader" class="modal-sub-heading"></div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body pt-0">
                        <div class="md-form pb-2">
                            <input type="text" id="seatNameField" maxlength="16" class="form-control validate mb-0">
                            <label class="inputLabel" id="seatNameFieldLabel" for="seatNameField" class="form-label">Seat Name (optional)</label>
                        </div>
                    </div>
                    <div class="modal-footer paybee-modal-footer">
                        <a id="seatsModalClose" class="btn btn-sm modal-confirm-button" >Close</a>
                        <a id="seatsModalSave" class="btn btn-sm modal-confirm-button" >Save</a>
                    </div>
                </div>
            </div>
        </div>
    
        <div data-html2canvas-ignore class="modal fade" id="helpVEventClear" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-notify modal-info" role="document">
                
                <div class="modal-content">
                    <div class="modal-body">
                        <h4>Clear</h4>
                        <p>
                            This button will clear the current campaign/option selection shown to the users.
                            The campaign portion will be replaced with event information and sponsors.
                            This is suitable when live stream carrying keynote speakers or general information about non-profit and cause.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    
        <div data-html2canvas-ignore class="modal fade" id="addMoreImagesModel" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-notify modal-info" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <p class="heading lead">Add More Images</p>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true" class="white-text">&times;</span>
                        </button>
                    </div>
    
                    <div class="modal-body">
                        <div class="md-form">
                            <div class="file-field">
                                <div class="btn btn-primary btn-sm waves-effect waves-light">
                                    <span>Select Image</span>
                                    <input id="auctionMoreImage" type="file">
                                </div>
                                <div class="file-path-wrapper">
                                    <input class="file-path validate" type="text" placeholder="Selected Image">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    
        <div data-html2canvas-ignore class="modal fade" id="helpAuctionAutoStart" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-notify modal-info" role="document">
                
                <div class="modal-content">
                    <div class="modal-body">
                        <h4>Automatically Start/Stop online bidding</h4>
                        <p>
                            you can either set start and end time after checking this box or auction will start in paused mode. You should be able to pause/resume online bidding from manage/auctions menu.
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <div data-html2canvas-ignore class="modal fade" id="addPeopleToTicketModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-notify modal-lg modal-info px-sm-2" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header mb-0" style="border-bottom: 1px solid RGB(217, 217, 217)">
                        <div class="row">
                            <div class="d-flex col-12 align-items-center justify-content-between align-center modal-main-heading history-header">
                                <div class="d-block">
                                    <div id="addPeopleToTicketModalHeader" class="headline-5 mb-2">Add People to Ticket</div>
                                    <div id="addPeopleToTicketModalSubHeader" class="body-2 grey-text">0 seat(s) remaining</div>
                                </div>
                                <div class="d-block">
                                    <img id="addPeopleToTicketIconUser" src="img/svg/user-checkmark.svg" height="28" style="display: none;">
                                    <img id="addPeopleToTicketIconMail" src="img/svg/mail-circle-large.svg" height="28" style="display: none;">
                                </div>
                                <div class="d-flex align-items-start h-100">
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true" class="black-text">×</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body">
                        <div id="addPeopleToTicketStep02" class="row" style="display: none;">
                            <div id="addPeopleToTicketSelectTypeBlock" class="col-12 mb-4">
                                <div class="row">
                                    <div class="col-6">
                                        <div class="black-text subtitle-1--weight-regular mb-1">Guest Type</div>
                                        <div class="body-2">If the guest is arriving alone select Single. If the guest will have company, select group.</div>
                                    </div>
                                    <div class="col-6">
                                        <div class="guest-type-control d-flex w-100">
                                            <div id="addPeopleToTicketSingle" class="guest-type-control__button button black-text cursor--pointer text-center w-50 selected">Single</div>
                                            <div id="addPeopleToTicketGroup" class="guest-type-control__button button black-text cursor--pointer text-center w-50">Group</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="addPeopleToTicketGroupBlock" class="col-12" style="display: none;">
                                <div class="row align-items-center">
                                    <div class="col-6">
                                        <div class="black-text subtitle-1--weight-regular mb-4">Select the number of guests in the group:</div>
                                    </div>
                                    <div class="col-6">
                                        <fieldset class="form-group noMargin">
                                            <select id="addPeopleToTicketGuests" class="mdb-select mdb-select--paybee mdb-select--hide-caret noMargin validate mb-4">
                                                <option value="2">2 Guests</option>
                                                <option value="3">3 Guests</option>
                                            </select>
                                            <div id='addPeopleToTicketGuestsError' class='red-text error-message' style="display: none"></div>
                                        </fieldset>
                                    </div>
                                </div>
                            </div>
                            <div id="addPeopleToTicketGuestsInformation" class="col-12" style="display: none;">
                                <div class="row custom-material-form">
                                    <div class="col-12 col-sm-6">
                                        <div class="md-form">
                                            <input type='text' id='addPeopleToTicketGuestName' autocomplete='chrome-off' required class='form-control validate'>
                                            <label id="addPeopleToTicketGuestNameLabel" class='inputLabel' for='addPeopleToTicketGuestName' required data-error='Invalid' data-success=''>
                                                Name
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-12 col-sm-6">
                                        <div class='md-form'>
                                            <input type='text' id='addPeopleToTicketGuestEMail' autocomplete='chrome-off' required class='form-control validate'>
                                            <label id="addPeopleToTicketGuestEMailLabel" class='inputLabel' for='addPeopleToTicketGuestEMail' required data-error='Invalid' data-success=''>
                                                Email
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="addPeopleToTicketStep03" style="display: none;">
                        </div>
                    </div>
                    <div class="modal-footer paybee-modal-footer">
                        <a class="btn btn-sm modal-cancel-button" data-dismiss="modal">Cancel</a>
                        <a id="nextAddPeopleToTicketButton"class="btn btn-sm modal-confirm-button disabled">Next</a>
                    </div>
                </div>
            </div>
        </div>

        <div data-html2canvas-ignore class="modal fade" id="basketRaffleItemListModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-notify modal-lg modal-info" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header mb-0" style="border-bottom: 1px solid RGB(217, 217, 217)">
                        <div class="row">
                            <div class="d-flex col-12 align-items-center justify-content-between align-center modal-main-heading history-header">
                                <div class="d-block">
                                    <div id="basketRaffleItemListModalHeader" class="headline-5 mb-2"></div>
                                    <div id="basketRaffleItemListModalSubHeader" class="body-2 grey-text"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body" id="basketRaffleItemListModalContainer">
                    </div>
                    <div class="modal-footer paybee-modal-footer">
                        <a class="btn btn-sm modal-cancel-button" data-dismiss="modal">Cancel</a>
                        <a id="basketRaffleItemListModalSave" class="btn btn-sm modal-confirm-button disabled">Save</a>
                    </div>
                </div>
            </div>
        </div>

        <div data-html2canvas-ignore class="modal fade" id="assignEmailModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col-11">
                                <div class="modal-main-heading">Assign E-Mail</div>
                            </div>
                            <div class="col-1">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" class="black-text">×</span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body">
                        <div class="row custom-material-form updated-dropdown">
                            <div class="col-12">
                                <div class="md-form">
                                    <input type="text" id="assignEmailField" class="form-control validate" autocomplete="name" />
                                    <label class="inputLabel" id="assignEmailFieldLabel" data-error="invalid" data-success="" for="assignEmailField">E-Mail</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer paybee-modal-footer">
                        <a class="btn btn-sm modal-cancel-button waves-effect waves-light" data-dismiss="modal">Cancel</a>
                        <a id="assignEmailSubmit" class="btn btn-sm modal-confirm-button waves-effect waves-light">Assign</a>
                    </div>
                </div>
            </div>
        </div>

        <div data-html2canvas-ignore class="modal fade" id="assignTableModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col-11">
                                <div class="modal-main-heading">Assign Table</div>
                            </div>
                            <div class="col-1">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" class="black-text">×</span>
                                </button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div id="assignTableModalSubHeader" class="modal-sub-heading"><b>Select Table & Seat (where applicable) for guest</b></div>
                            </div>
                        </div>  
                    </div>
                    <div class="modal-body">
                        <div class="row custom-material-form updated-dropdown mb-2">
                            <div class="col-12">
                                <div class="grey-text body-2">Table</div>
                                <div id="assignTableCol"></div>
                                <span id="assignTableModalInfo" style="display: none;" class="grey-text body-2">Create a table and then assign it to the attendee.</span>
                            </div>
                        </div>
                        <div class="row custom-material-form updated-dropdown">
                            <div class="col-12" id="assignSeatCol"></div>
                            <span id="assignSeatColError" class="body-2 pl-3 red-text">Please select seat</span>
                        </div>
                    </div>
                    <div class="modal-footer paybee-modal-footer">
                        <a class="btn btn-sm modal-cancel-button waves-effect waves-light" data-dismiss="modal">Cancel</a>
                        <a id="assignTableSubmit" class="btn btn-sm modal-confirm-button waves-effect waves-light">Assign</a>
                    </div>
                </div>
            </div>
        </div>

        <div data-html2canvas-ignore class="modal fade" id="assignGolfHoleModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col-11">
                                <div class="modal-main-heading">Assign Golf Hole</div>
                            </div>
                            <div class="col-1">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" class="black-text">×</span>
                                </button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div id="assignGolfHoleModalSubHeader" class="modal-sub-heading"><b>Select Golf Hole for guest</b></div>
                            </div>
                        </div>  
                    </div>
                    <div class="modal-body">
                        <div class="row custom-material-form updated-dropdown mb-2">
                            <div class="col-12">
                                <div class="grey-text body-2">Golf Hole</div>
                                <div id="assignGolfHoleCol"></div>
                                <div id="assignGolfHoleCartCol"></div>
                                <span id="assignGolfHoleCartColError" class="body-2 pl-3 red-text" style="display: none;">Please select a golf cart</span>
                                <span id="assignGolfHoleModalInfo" style="display: none;" class="grey-text body-2">Create a golf hole and then assign it to the attendee.</span>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer paybee-modal-footer">
                        <a class="btn btn-sm modal-cancel-button waves-effect waves-light" data-dismiss="modal">Cancel</a>
                        <a id="assignGolfHoleSubmit" class="btn btn-sm modal-confirm-button waves-effect waves-light">Assign</a>
                    </div>
                </div>
            </div>
        </div>

        <div data-html2canvas-ignore class="modal fade" id="assignTableToAllModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col-11">
                                <div id="assignTableToAllModalHeader" class="modal-main-heading">Assign Table To All Guests</div>
                            </div>
                            <div class="col-1">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" class="black-text">×</span>
                                </button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div id="assignTableToAllModalSubHeader" class="modal-sub-heading">Assign the same table to confirmed guests on this ticket</div>
                            </div>
                        </div>  
                    </div>
                    <div class="modal-body">
                        <div id="assignTableToAllModalStep01" class="row custom-material-form updated-dropdown mb-2">
                            <div class="col-12">
                                <div class="grey-text body-2">Table</div>
                                <div id="assignTableToAllSelect"></div>
                                <span id="assignTableToAllModalInfo" style="display: none;" class="grey-text body-2">Create a table and then assign it to the attendee.</span>
                            </div>
                        </div>
                        <div id="assignTableToAllModalStep02" class="custom-material-form updated-dropdown mb-2 pr-2 mr-n2" style="display: none; overflow-y: auto; overflow-x: hidden; height: 60vh;">
                            <div id="assignTableToAllSeatsList"></div>
                        </div>
                    </div>
                    <div class="modal-footer paybee-modal-footer">
                        <a id="assignTableToAllCancel" class="btn btn-sm modal-cancel-button waves-effect waves-light" data-dismiss="modal">Cancel</a>
                        <a id="assignTableToAllBack" class="btn btn-sm modal-cancel-button waves-effect waves-light" style="display: none; margin-right: 10px !important;">Back</a>
                        <a id="assignTableToAllSubmit" class="btn btn-sm modal-confirm-button waves-effect waves-light">Confirm</a>
                        <a id="assignTableToAllNext" class="btn btn-sm modal-confirm-button waves-effect waves-light" style="display: none;">Next</a>
                    </div>
                </div>
            </div>
        </div>

        <div data-html2canvas-ignore class="modal fade" id="assignPaddleNumberModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header">
                        <div class="row">
                            <div class="col-11">
                                <div class="modal-main-heading">Assign Paddle Number</div>
                            </div>
                            <div class="col-1">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" class="black-text">×</span>
                                </button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="modal-sub-heading">Enter a paddle number or click button to automatically generate one for <div id="assignPaddleNumberFor"></div></div>
                            </div>
                        </div>  
                    </div>
                    <div class="modal-body">
                        <div class="row custom-material-form updated-dropdown">
                            <div class="col-12">
                                <div class="md-form">
                                    <input type="text" id="assignPaddleNumberField" class="form-control validate" autocomplete="name" />
                                    <label class="inputLabel" id="assignPaddleNumberFieldLabel" data-error="invalid" data-success="" for="assignPaddleNumberField">Paddle Number</label>
                                </div>
                                <div class="caption blue-text mt-n2 ml-3">
                                    <span class="cursor--pointer" id="removePaddleNumber">Remove Paddle</span>
                                    <span class="cursor--pointer" id="assignNextPaddleNumber">Get Next Available Paddle Number</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer paybee-modal-footer">
                        <a class="btn btn-sm modal-cancel-button waves-effect waves-light" data-dismiss="modal">Cancel</a>
                        <a id="assignPaddleNumberSubmit" class="btn btn-sm modal-confirm-button waves-effect waves-light">Assign</a>
                    </div>
                </div>
            </div>
        </div>

        <div data-html2canvas-ignore id="campaignDonationsReport" style="display:none">
            <div class="row" style="margin-bottom: 20px">
                <div class="col">
                    <h5><a routerLink="/reports/campaign" id="goToAllCampaigns">All Campaigns/</a><span id="campaignNameDonations"></span></h5>
                </div>
            </div>

            <div class="row custom-material-form updated-dropdown"  id="adrDateSelectRow">
                <div class="col">
                    <div class="md-form">
                        <input placeholder="Start date" type="text" id="adrStartDate" class="form-control datepicker" style="cursor: pointer;">
                        <label id="adrStartDateLabel" for="adrStartDate">Start Date</label>
                        <i class="far fa-calendar-alt calendar-icon--paybee" onclick="document.getElementById('adrStartDate').focus()" style="cursor:pointer"></i>
                    </div>
                </div>
                <div class="col">
                    <div class="md-form">
                        <input placeholder="End date" type="text" id="adrEndDate" class="form-control datepicker" style="cursor: pointer;">
                        <label id="adrEndDateLabel" for="adrEndDate">End Date</label>
                        <i class="far fa-calendar-alt calendar-icon--paybee" onclick="document.getElementById('adrEndDate').focus()" style="cursor:pointer"></i>
                    </div>
                </div>
            </div>

            <div class="table--paybee">
                <div class='text-center no-data-text' style="display: none" id="emptyCampaignDonationsList">No transactions yet.</div>
                <table id ="campaignDonationsList" class="table" cellspacing="0" style="width: 100%;">
                    <thead class="thead-light">
                    <tr>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Phone</th>
                        <th>Address</th>
                        <th>Option </th>
                        <th>Status</th>
                        <th>Type</th>
                        <th>Amount</th>
                        <th>Tax</th>
                        <th>Date </th>
                        <th>Method</th>
                    </tr>
                    </thead>
                </table>
            </div>
            <div class="table--paybee">
                <div class='text-center no-data-text' style="display: none" id="emptyCampaignPendingList">No transactions yet.</div>
                <table id ="campaignPendingList" class="table" cellspacing="0" style="width: 100%;">
                    <thead class="thead-light">
                    <tr>
                        <th>Donor</th>
                        <th>Email</th>
                        <th>Phone</th>
                        <th>Address</th>
                        <th>Option </th>
                        <th>Status</th>
                        <th>Amount</th>
                        <th>Date </th>
                        <th>Action</th>
                    </tr>
                    </thead>
                </table>
            </div>
        </div>

        <div data-html2canvas-ignore class="modal fade" id="assignPaddlesToAll" tabindex="-1" role="dialog" aria-hidden="true">
            <div id="assignPaddlesToAll_disabledSection" class="modal-dialog modal-md" role="document">
            </div>
            
            <div id="assignPaddlesToAll_activeSection" class="modal-dialog modal-md" role="document">
                <div class="modal-content paybee-modal-content">
                    <div class="paybee-modal-header p-4 mb-4" style="border-bottom:1px solid #D9D9D9">
                        <div class="row mb-2">
                            <div class="col-11">
                                <div class="headline-5">Assign Paddles To All</div>
                            </div>
                            <div class="col-1">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" class="black-text" style="font-size: 30px;font-weight:300">×</span>
                                </button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="body-1">Choose how you'd like to assign paddles</div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body custom-material-form p-0">
                        <div class="col-12">
                            <div class="md-form">
                                <div class="text-left" style="color: #757575; font-size: 0.8rem;">Assign By</div>
                                <select id="assigmentTypeSelect" class="mdb-select mdb-select--paybee noMargin validate mb-4">
                                    <option value="0" selected>Default, As appeared in the list</option>
                                    <option value="1">First Name</option>
                                    <option value="2">Last Name</option>
                                    <option value="3">Table Number</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-12" id="assigmentOrderSelectSection">
                            <div class="md-form">
                                <div class="text-left" style="color: #757575; font-size: 0.8rem;">Order</div>
                                <select id="assigmentOrderSelect" class="mdb-select mdb-select--paybee noMargin validate mb-4">
                                    <option value="1" selected>Ascending</option>
                                    <option value="2">Descending</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer paybee-modal-footer">
                        <a class="btn btn-sm modal-cancel-button waves-effect waves-light" data-dismiss="modal">Cancel</a>
                        <a id="assignPaddlesToAllSubmit" class="btn btn-sm modal-confirm-button waves-effect waves-light">Assign</a>
                    </div>
                </div>
            </div>
        </div>
</div>

<app-dialog></app-dialog>
<app-loading></app-loading>
<app-mdb-toast></app-mdb-toast>